// Code generated by @keq-request/cli. DO NOT EDIT.
// Code generated by @keq-request/cli. DO NOT EDIT.
// Code generated by @keq-request/cli. DO NOT EDIT.

/* @anchor:file:start */

import { Injectable, Logger } from '@nestjs/common'
import { Keq, KeqRequest } from 'keq'
import type { KubernetesReadAuthConfigurationOperation, KubernetesReadAuthConfigurationResponseBodies, KubernetesReadAuthConfigurationRequestParameters } from './types/operations/kubernetes-read-auth-configuration.type'
import type { KubernetesConfigureAuthOperation, KubernetesConfigureAuthResponseBodies, KubernetesConfigureAuthRequestParameters } from './types/operations/kubernetes-configure-auth.type'
import type { KubernetesLoginOperation, KubernetesLoginResponseBodies, KubernetesLoginRequestParameters } from './types/operations/kubernetes-login.type'
import type { KubernetesListAuthRolesOperation, KubernetesListAuthRolesResponseBodies, KubernetesListAuthRolesRequestParameters } from './types/operations/kubernetes-list-auth-roles.type'
import type { KubernetesReadAuthRoleOperation, KubernetesReadAuthRoleResponseBodies, KubernetesReadAuthRoleRequestParameters } from './types/operations/kubernetes-read-auth-role.type'
import type { KubernetesWriteAuthRoleOperation, KubernetesWriteAuthRoleResponseBodies, KubernetesWriteAuthRoleRequestParameters } from './types/operations/kubernetes-write-auth-role.type'
import type { KubernetesDeleteAuthRoleOperation, KubernetesDeleteAuthRoleResponseBodies, KubernetesDeleteAuthRoleRequestParameters } from './types/operations/kubernetes-delete-auth-role.type'
import type { TokenListAccessorsOperation, TokenListAccessorsResponseBodies, TokenListAccessorsRequestParameters } from './types/operations/token-list-accessors.type'
import type { TokenCreateOperation, TokenCreateResponseBodies, TokenCreateRequestParameters } from './types/operations/token-create.type'
import type { TokenCreateOrphanOperation, TokenCreateOrphanResponseBodies, TokenCreateOrphanRequestParameters } from './types/operations/token-create-orphan.type'
import type { TokenCreateAgainstRoleOperation, TokenCreateAgainstRoleResponseBodies, TokenCreateAgainstRoleRequestParameters } from './types/operations/token-create-against-role.type'
import type { TokenLookUpGetOperation, TokenLookUpGetResponseBodies, TokenLookUpGetRequestParameters } from './types/operations/token-look-up-get.type'
import type { TokenLookUpUpdateOperation, TokenLookUpUpdateResponseBodies, TokenLookUpUpdateRequestParameters } from './types/operations/token-look-up-update.type'
import type { TokenLookUpByAccessorOperation, TokenLookUpByAccessorResponseBodies, TokenLookUpByAccessorRequestParameters } from './types/operations/token-look-up-by-accessor.type'
import type { TokenLookUpSelfGetOperation, TokenLookUpSelfGetResponseBodies, TokenLookUpSelfGetRequestParameters } from './types/operations/token-look-up-self-get.type'
import type { TokenLookUpSelfUpdateOperation, TokenLookUpSelfUpdateResponseBodies, TokenLookUpSelfUpdateRequestParameters } from './types/operations/token-look-up-self-update.type'
import type { TokenRenewOperation, TokenRenewResponseBodies, TokenRenewRequestParameters } from './types/operations/token-renew.type'
import type { TokenRenewAccessorOperation, TokenRenewAccessorResponseBodies, TokenRenewAccessorRequestParameters } from './types/operations/token-renew-accessor.type'
import type { TokenRenewSelfOperation, TokenRenewSelfResponseBodies, TokenRenewSelfRequestParameters } from './types/operations/token-renew-self.type'
import type { TokenRevokeOperation, TokenRevokeResponseBodies, TokenRevokeRequestParameters } from './types/operations/token-revoke.type'
import type { TokenRevokeAccessorOperation, TokenRevokeAccessorResponseBodies, TokenRevokeAccessorRequestParameters } from './types/operations/token-revoke-accessor.type'
import type { TokenRevokeOrphanOperation, TokenRevokeOrphanResponseBodies, TokenRevokeOrphanRequestParameters } from './types/operations/token-revoke-orphan.type'
import type { TokenRevokeSelfOperation, TokenRevokeSelfResponseBodies, TokenRevokeSelfRequestParameters } from './types/operations/token-revoke-self.type'
import type { TokenListRolesOperation, TokenListRolesResponseBodies, TokenListRolesRequestParameters } from './types/operations/token-list-roles.type'
import type { TokenReadRoleOperation, TokenReadRoleResponseBodies, TokenReadRoleRequestParameters } from './types/operations/token-read-role.type'
import type { TokenWriteRoleOperation, TokenWriteRoleResponseBodies, TokenWriteRoleRequestParameters } from './types/operations/token-write-role.type'
import type { TokenDeleteRoleOperation, TokenDeleteRoleResponseBodies, TokenDeleteRoleRequestParameters } from './types/operations/token-delete-role.type'
import type { TokenTidyOperation, TokenTidyResponseBodies, TokenTidyRequestParameters } from './types/operations/token-tidy.type'
import type { UserpassLoginOperation, UserpassLoginResponseBodies, UserpassLoginRequestParameters } from './types/operations/userpass-login.type'
import type { UserpassListUsersOperation, UserpassListUsersResponseBodies, UserpassListUsersRequestParameters } from './types/operations/userpass-list-users.type'
import type { UserpassReadUserOperation, UserpassReadUserResponseBodies, UserpassReadUserRequestParameters } from './types/operations/userpass-read-user.type'
import type { UserpassWriteUserOperation, UserpassWriteUserResponseBodies, UserpassWriteUserRequestParameters } from './types/operations/userpass-write-user.type'
import type { UserpassDeleteUserOperation, UserpassDeleteUserResponseBodies, UserpassDeleteUserRequestParameters } from './types/operations/userpass-delete-user.type'
import type { UserpassResetPasswordOperation, UserpassResetPasswordResponseBodies, UserpassResetPasswordRequestParameters } from './types/operations/userpass-reset-password.type'
import type { UserpassUpdatePoliciesOperation, UserpassUpdatePoliciesResponseBodies, UserpassUpdatePoliciesRequestParameters } from './types/operations/userpass-update-policies.type'
import type { CubbyholeReadOperation, CubbyholeReadResponseBodies, CubbyholeReadRequestParameters } from './types/operations/cubbyhole-read.type'
import type { CubbyholeWriteOperation, CubbyholeWriteResponseBodies, CubbyholeWriteRequestParameters } from './types/operations/cubbyhole-write.type'
import type { CubbyholeDeleteOperation, CubbyholeDeleteResponseBodies, CubbyholeDeleteRequestParameters } from './types/operations/cubbyhole-delete.type'
import type { AliasCreateOperation, AliasCreateResponseBodies, AliasCreateRequestParameters } from './types/operations/alias-create.type'
import type { AliasListByIdOperation, AliasListByIdResponseBodies, AliasListByIdRequestParameters } from './types/operations/alias-list-by-id.type'
import type { AliasReadByIdOperation, AliasReadByIdResponseBodies, AliasReadByIdRequestParameters } from './types/operations/alias-read-by-id.type'
import type { AliasUpdateByIdOperation, AliasUpdateByIdResponseBodies, AliasUpdateByIdRequestParameters } from './types/operations/alias-update-by-id.type'
import type { AliasDeleteByIdOperation, AliasDeleteByIdResponseBodies, AliasDeleteByIdRequestParameters } from './types/operations/alias-delete-by-id.type'
import type { EntityCreateOperation, EntityCreateResponseBodies, EntityCreateRequestParameters } from './types/operations/entity-create.type'
import type { EntityCreateAliasOperation, EntityCreateAliasResponseBodies, EntityCreateAliasRequestParameters } from './types/operations/entity-create-alias.type'
import type { EntityListAliasesByIdOperation, EntityListAliasesByIdResponseBodies, EntityListAliasesByIdRequestParameters } from './types/operations/entity-list-aliases-by-id.type'
import type { EntityReadAliasByIdOperation, EntityReadAliasByIdResponseBodies, EntityReadAliasByIdRequestParameters } from './types/operations/entity-read-alias-by-id.type'
import type { EntityUpdateAliasByIdOperation, EntityUpdateAliasByIdResponseBodies, EntityUpdateAliasByIdRequestParameters } from './types/operations/entity-update-alias-by-id.type'
import type { EntityDeleteAliasByIdOperation, EntityDeleteAliasByIdResponseBodies, EntityDeleteAliasByIdRequestParameters } from './types/operations/entity-delete-alias-by-id.type'
import type { EntityBatchDeleteOperation, EntityBatchDeleteResponseBodies, EntityBatchDeleteRequestParameters } from './types/operations/entity-batch-delete.type'
import type { EntityListByIdOperation, EntityListByIdResponseBodies, EntityListByIdRequestParameters } from './types/operations/entity-list-by-id.type'
import type { EntityReadByIdOperation, EntityReadByIdResponseBodies, EntityReadByIdRequestParameters } from './types/operations/entity-read-by-id.type'
import type { EntityUpdateByIdOperation, EntityUpdateByIdResponseBodies, EntityUpdateByIdRequestParameters } from './types/operations/entity-update-by-id.type'
import type { EntityDeleteByIdOperation, EntityDeleteByIdResponseBodies, EntityDeleteByIdRequestParameters } from './types/operations/entity-delete-by-id.type'
import type { EntityMergeOperation, EntityMergeResponseBodies, EntityMergeRequestParameters } from './types/operations/entity-merge.type'
import type { EntityListByNameOperation, EntityListByNameResponseBodies, EntityListByNameRequestParameters } from './types/operations/entity-list-by-name.type'
import type { EntityReadByNameOperation, EntityReadByNameResponseBodies, EntityReadByNameRequestParameters } from './types/operations/entity-read-by-name.type'
import type { EntityUpdateByNameOperation, EntityUpdateByNameResponseBodies, EntityUpdateByNameRequestParameters } from './types/operations/entity-update-by-name.type'
import type { EntityDeleteByNameOperation, EntityDeleteByNameResponseBodies, EntityDeleteByNameRequestParameters } from './types/operations/entity-delete-by-name.type'
import type { GroupCreateOperation, GroupCreateResponseBodies, GroupCreateRequestParameters } from './types/operations/group-create.type'
import type { GroupCreateAliasOperation, GroupCreateAliasResponseBodies, GroupCreateAliasRequestParameters } from './types/operations/group-create-alias.type'
import type { GroupListAliasesByIdOperation, GroupListAliasesByIdResponseBodies, GroupListAliasesByIdRequestParameters } from './types/operations/group-list-aliases-by-id.type'
import type { GroupReadAliasByIdOperation, GroupReadAliasByIdResponseBodies, GroupReadAliasByIdRequestParameters } from './types/operations/group-read-alias-by-id.type'
import type { GroupUpdateAliasByIdOperation, GroupUpdateAliasByIdResponseBodies, GroupUpdateAliasByIdRequestParameters } from './types/operations/group-update-alias-by-id.type'
import type { GroupDeleteAliasByIdOperation, GroupDeleteAliasByIdResponseBodies, GroupDeleteAliasByIdRequestParameters } from './types/operations/group-delete-alias-by-id.type'
import type { GroupListByIdOperation, GroupListByIdResponseBodies, GroupListByIdRequestParameters } from './types/operations/group-list-by-id.type'
import type { GroupReadByIdOperation, GroupReadByIdResponseBodies, GroupReadByIdRequestParameters } from './types/operations/group-read-by-id.type'
import type { GroupUpdateByIdOperation, GroupUpdateByIdResponseBodies, GroupUpdateByIdRequestParameters } from './types/operations/group-update-by-id.type'
import type { GroupDeleteByIdOperation, GroupDeleteByIdResponseBodies, GroupDeleteByIdRequestParameters } from './types/operations/group-delete-by-id.type'
import type { GroupListByNameOperation, GroupListByNameResponseBodies, GroupListByNameRequestParameters } from './types/operations/group-list-by-name.type'
import type { GroupReadByNameOperation, GroupReadByNameResponseBodies, GroupReadByNameRequestParameters } from './types/operations/group-read-by-name.type'
import type { GroupUpdateByNameOperation, GroupUpdateByNameResponseBodies, GroupUpdateByNameRequestParameters } from './types/operations/group-update-by-name.type'
import type { GroupDeleteByNameOperation, GroupDeleteByNameResponseBodies, GroupDeleteByNameRequestParameters } from './types/operations/group-delete-by-name.type'
import type { EntityLookUpOperation, EntityLookUpResponseBodies, EntityLookUpRequestParameters } from './types/operations/entity-look-up.type'
import type { GroupLookUpOperation, GroupLookUpResponseBodies, GroupLookUpRequestParameters } from './types/operations/group-look-up.type'
import type { MfaListLoginEnforcementsOperation, MfaListLoginEnforcementsResponseBodies, MfaListLoginEnforcementsRequestParameters } from './types/operations/mfa-list-login-enforcements.type'
import type { MfaReadLoginEnforcementOperation, MfaReadLoginEnforcementResponseBodies, MfaReadLoginEnforcementRequestParameters } from './types/operations/mfa-read-login-enforcement.type'
import type { MfaWriteLoginEnforcementOperation, MfaWriteLoginEnforcementResponseBodies, MfaWriteLoginEnforcementRequestParameters } from './types/operations/mfa-write-login-enforcement.type'
import type { MfaDeleteLoginEnforcementOperation, MfaDeleteLoginEnforcementResponseBodies, MfaDeleteLoginEnforcementRequestParameters } from './types/operations/mfa-delete-login-enforcement.type'
import type { MfaListMethodsOperation, MfaListMethodsResponseBodies, MfaListMethodsRequestParameters } from './types/operations/mfa-list-methods.type'
import type { MfaListDuoMethodsOperation, MfaListDuoMethodsResponseBodies, MfaListDuoMethodsRequestParameters } from './types/operations/mfa-list-duo-methods.type'
import type { MfaReadDuoMethodConfigurationOperation, MfaReadDuoMethodConfigurationResponseBodies, MfaReadDuoMethodConfigurationRequestParameters } from './types/operations/mfa-read-duo-method-configuration.type'
import type { MfaConfigureDuoMethodOperation, MfaConfigureDuoMethodResponseBodies, MfaConfigureDuoMethodRequestParameters } from './types/operations/mfa-configure-duo-method.type'
import type { MfaDeleteDuoMethodOperation, MfaDeleteDuoMethodResponseBodies, MfaDeleteDuoMethodRequestParameters } from './types/operations/mfa-delete-duo-method.type'
import type { MfaListOktaMethodsOperation, MfaListOktaMethodsResponseBodies, MfaListOktaMethodsRequestParameters } from './types/operations/mfa-list-okta-methods.type'
import type { MfaReadOktaMethodConfigurationOperation, MfaReadOktaMethodConfigurationResponseBodies, MfaReadOktaMethodConfigurationRequestParameters } from './types/operations/mfa-read-okta-method-configuration.type'
import type { MfaConfigureOktaMethodOperation, MfaConfigureOktaMethodResponseBodies, MfaConfigureOktaMethodRequestParameters } from './types/operations/mfa-configure-okta-method.type'
import type { MfaDeleteOktaMethodOperation, MfaDeleteOktaMethodResponseBodies, MfaDeleteOktaMethodRequestParameters } from './types/operations/mfa-delete-okta-method.type'
import type { MfaListPingIdMethodsOperation, MfaListPingIdMethodsResponseBodies, MfaListPingIdMethodsRequestParameters } from './types/operations/mfa-list-ping-id-methods.type'
import type { MfaReadPingIdMethodConfigurationOperation, MfaReadPingIdMethodConfigurationResponseBodies, MfaReadPingIdMethodConfigurationRequestParameters } from './types/operations/mfa-read-ping-id-method-configuration.type'
import type { MfaConfigurePingIdMethodOperation, MfaConfigurePingIdMethodResponseBodies, MfaConfigurePingIdMethodRequestParameters } from './types/operations/mfa-configure-ping-id-method.type'
import type { MfaDeletePingIdMethodOperation, MfaDeletePingIdMethodResponseBodies, MfaDeletePingIdMethodRequestParameters } from './types/operations/mfa-delete-ping-id-method.type'
import type { MfaListTotpMethodsOperation, MfaListTotpMethodsResponseBodies, MfaListTotpMethodsRequestParameters } from './types/operations/mfa-list-totp-methods.type'
import type { MfaAdminDestroyTotpSecretOperation, MfaAdminDestroyTotpSecretResponseBodies, MfaAdminDestroyTotpSecretRequestParameters } from './types/operations/mfa-admin-destroy-totp-secret.type'
import type { MfaAdminGenerateTotpSecretOperation, MfaAdminGenerateTotpSecretResponseBodies, MfaAdminGenerateTotpSecretRequestParameters } from './types/operations/mfa-admin-generate-totp-secret.type'
import type { MfaGenerateTotpSecretOperation, MfaGenerateTotpSecretResponseBodies, MfaGenerateTotpSecretRequestParameters } from './types/operations/mfa-generate-totp-secret.type'
import type { MfaReadTotpMethodConfigurationOperation, MfaReadTotpMethodConfigurationResponseBodies, MfaReadTotpMethodConfigurationRequestParameters } from './types/operations/mfa-read-totp-method-configuration.type'
import type { MfaConfigureTotpMethodOperation, MfaConfigureTotpMethodResponseBodies, MfaConfigureTotpMethodRequestParameters } from './types/operations/mfa-configure-totp-method.type'
import type { MfaDeleteTotpMethodOperation, MfaDeleteTotpMethodResponseBodies, MfaDeleteTotpMethodRequestParameters } from './types/operations/mfa-delete-totp-method.type'
import type { MfaReadMethodConfigurationOperation, MfaReadMethodConfigurationResponseBodies, MfaReadMethodConfigurationRequestParameters } from './types/operations/mfa-read-method-configuration.type'
import type { OidcReadPublicKeysOperation, OidcReadPublicKeysResponseBodies, OidcReadPublicKeysRequestParameters } from './types/operations/oidc-read-public-keys.type'
import type { OidcReadOpenIdConfigurationOperation, OidcReadOpenIdConfigurationResponseBodies, OidcReadOpenIdConfigurationRequestParameters } from './types/operations/oidc-read-open-id-configuration.type'
import type { OidcListAssignmentsOperation, OidcListAssignmentsResponseBodies, OidcListAssignmentsRequestParameters } from './types/operations/oidc-list-assignments.type'
import type { OidcReadAssignmentOperation, OidcReadAssignmentResponseBodies, OidcReadAssignmentRequestParameters } from './types/operations/oidc-read-assignment.type'
import type { OidcWriteAssignmentOperation, OidcWriteAssignmentResponseBodies, OidcWriteAssignmentRequestParameters } from './types/operations/oidc-write-assignment.type'
import type { OidcDeleteAssignmentOperation, OidcDeleteAssignmentResponseBodies, OidcDeleteAssignmentRequestParameters } from './types/operations/oidc-delete-assignment.type'
import type { OidcListClientsOperation, OidcListClientsResponseBodies, OidcListClientsRequestParameters } from './types/operations/oidc-list-clients.type'
import type { OidcReadClientOperation, OidcReadClientResponseBodies, OidcReadClientRequestParameters } from './types/operations/oidc-read-client.type'
import type { OidcWriteClientOperation, OidcWriteClientResponseBodies, OidcWriteClientRequestParameters } from './types/operations/oidc-write-client.type'
import type { OidcDeleteClientOperation, OidcDeleteClientResponseBodies, OidcDeleteClientRequestParameters } from './types/operations/oidc-delete-client.type'
import type { OidcReadConfigurationOperation, OidcReadConfigurationResponseBodies, OidcReadConfigurationRequestParameters } from './types/operations/oidc-read-configuration.type'
import type { OidcConfigureOperation, OidcConfigureResponseBodies, OidcConfigureRequestParameters } from './types/operations/oidc-configure.type'
import type { OidcIntrospectOperation, OidcIntrospectResponseBodies, OidcIntrospectRequestParameters } from './types/operations/oidc-introspect.type'
import type { OidcListKeysOperation, OidcListKeysResponseBodies, OidcListKeysRequestParameters } from './types/operations/oidc-list-keys.type'
import type { OidcReadKeyOperation, OidcReadKeyResponseBodies, OidcReadKeyRequestParameters } from './types/operations/oidc-read-key.type'
import type { OidcWriteKeyOperation, OidcWriteKeyResponseBodies, OidcWriteKeyRequestParameters } from './types/operations/oidc-write-key.type'
import type { OidcDeleteKeyOperation, OidcDeleteKeyResponseBodies, OidcDeleteKeyRequestParameters } from './types/operations/oidc-delete-key.type'
import type { OidcRotateKeyOperation, OidcRotateKeyResponseBodies, OidcRotateKeyRequestParameters } from './types/operations/oidc-rotate-key.type'
import type { OidcListProvidersOperation, OidcListProvidersResponseBodies, OidcListProvidersRequestParameters } from './types/operations/oidc-list-providers.type'
import type { OidcReadProviderOperation, OidcReadProviderResponseBodies, OidcReadProviderRequestParameters } from './types/operations/oidc-read-provider.type'
import type { OidcWriteProviderOperation, OidcWriteProviderResponseBodies, OidcWriteProviderRequestParameters } from './types/operations/oidc-write-provider.type'
import type { OidcDeleteProviderOperation, OidcDeleteProviderResponseBodies, OidcDeleteProviderRequestParameters } from './types/operations/oidc-delete-provider.type'
import type { OidcReadProviderPublicKeysOperation, OidcReadProviderPublicKeysResponseBodies, OidcReadProviderPublicKeysRequestParameters } from './types/operations/oidc-read-provider-public-keys.type'
import type { OidcReadProviderOpenIdConfigurationOperation, OidcReadProviderOpenIdConfigurationResponseBodies, OidcReadProviderOpenIdConfigurationRequestParameters } from './types/operations/oidc-read-provider-open-id-configuration.type'
import type { OidcProviderAuthorizeOperation, OidcProviderAuthorizeResponseBodies, OidcProviderAuthorizeRequestParameters } from './types/operations/oidc-provider-authorize.type'
import type { OidcProviderAuthorizeWithParametersOperation, OidcProviderAuthorizeWithParametersResponseBodies, OidcProviderAuthorizeWithParametersRequestParameters } from './types/operations/oidc-provider-authorize-with-parameters.type'
import type { OidcProviderTokenOperation, OidcProviderTokenResponseBodies, OidcProviderTokenRequestParameters } from './types/operations/oidc-provider-token.type'
import type { OidcProviderUserInfoOperation, OidcProviderUserInfoResponseBodies, OidcProviderUserInfoRequestParameters } from './types/operations/oidc-provider-user-info.type'
import type { OidcListRolesOperation, OidcListRolesResponseBodies, OidcListRolesRequestParameters } from './types/operations/oidc-list-roles.type'
import type { OidcReadRoleOperation, OidcReadRoleResponseBodies, OidcReadRoleRequestParameters } from './types/operations/oidc-read-role.type'
import type { OidcWriteRoleOperation, OidcWriteRoleResponseBodies, OidcWriteRoleRequestParameters } from './types/operations/oidc-write-role.type'
import type { OidcDeleteRoleOperation, OidcDeleteRoleResponseBodies, OidcDeleteRoleRequestParameters } from './types/operations/oidc-delete-role.type'
import type { OidcListScopesOperation, OidcListScopesResponseBodies, OidcListScopesRequestParameters } from './types/operations/oidc-list-scopes.type'
import type { OidcReadScopeOperation, OidcReadScopeResponseBodies, OidcReadScopeRequestParameters } from './types/operations/oidc-read-scope.type'
import type { OidcWriteScopeOperation, OidcWriteScopeResponseBodies, OidcWriteScopeRequestParameters } from './types/operations/oidc-write-scope.type'
import type { OidcDeleteScopeOperation, OidcDeleteScopeResponseBodies, OidcDeleteScopeRequestParameters } from './types/operations/oidc-delete-scope.type'
import type { OidcGenerateTokenOperation, OidcGenerateTokenResponseBodies, OidcGenerateTokenRequestParameters } from './types/operations/oidc-generate-token.type'
import type { PersonaCreateOperation, PersonaCreateResponseBodies, PersonaCreateRequestParameters } from './types/operations/persona-create.type'
import type { PersonaListByIdOperation, PersonaListByIdResponseBodies, PersonaListByIdRequestParameters } from './types/operations/persona-list-by-id.type'
import type { PersonaReadByIdOperation, PersonaReadByIdResponseBodies, PersonaReadByIdRequestParameters } from './types/operations/persona-read-by-id.type'
import type { PersonaUpdateByIdOperation, PersonaUpdateByIdResponseBodies, PersonaUpdateByIdRequestParameters } from './types/operations/persona-update-by-id.type'
import type { PersonaDeleteByIdOperation, PersonaDeleteByIdResponseBodies, PersonaDeleteByIdRequestParameters } from './types/operations/persona-delete-by-id.type'
import type { KvReadConfigOperation, KvReadConfigResponseBodies, KvReadConfigRequestParameters } from './types/operations/kv-read-config.type'
import type { KvWriteConfigOperation, KvWriteConfigResponseBodies, KvWriteConfigRequestParameters } from './types/operations/kv-write-config.type'
import type { KvReadDataPathOperation, KvReadDataPathResponseBodies, KvReadDataPathRequestParameters } from './types/operations/kv-read-data-path.type'
import type { KvWriteDataPathOperation, KvWriteDataPathResponseBodies, KvWriteDataPathRequestParameters } from './types/operations/kv-write-data-path.type'
import type { KvDeleteDataPathOperation, KvDeleteDataPathResponseBodies, KvDeleteDataPathRequestParameters } from './types/operations/kv-delete-data-path.type'
import type { KvWriteDeletePathOperation, KvWriteDeletePathResponseBodies, KvWriteDeletePathRequestParameters } from './types/operations/kv-write-delete-path.type'
import type { KvWriteDestroyPathOperation, KvWriteDestroyPathResponseBodies, KvWriteDestroyPathRequestParameters } from './types/operations/kv-write-destroy-path.type'
import type { KvListDetailedMetadataPathOperation, KvListDetailedMetadataPathResponseBodies, KvListDetailedMetadataPathRequestParameters } from './types/operations/kv-list-detailed-metadata-path.type'
import type { KvReadMetadataPathOperation, KvReadMetadataPathResponseBodies, KvReadMetadataPathRequestParameters } from './types/operations/kv-read-metadata-path.type'
import type { KvWriteMetadataPathOperation, KvWriteMetadataPathResponseBodies, KvWriteMetadataPathRequestParameters } from './types/operations/kv-write-metadata-path.type'
import type { KvDeleteMetadataPathOperation, KvDeleteMetadataPathResponseBodies, KvDeleteMetadataPathRequestParameters } from './types/operations/kv-delete-metadata-path.type'
import type { KvReadSubkeysPathOperation, KvReadSubkeysPathResponseBodies, KvReadSubkeysPathRequestParameters } from './types/operations/kv-read-subkeys-path.type'
import type { KvWriteUndeletePathOperation, KvWriteUndeletePathResponseBodies, KvWriteUndeletePathRequestParameters } from './types/operations/kv-write-undelete-path.type'
import type { AuditingListEnabledDevicesOperation, AuditingListEnabledDevicesResponseBodies, AuditingListEnabledDevicesRequestParameters } from './types/operations/auditing-list-enabled-devices.type'
import type { AuditingCalculateHashOperation, AuditingCalculateHashResponseBodies, AuditingCalculateHashRequestParameters } from './types/operations/auditing-calculate-hash.type'
import type { AuditingEnableDeviceOperation, AuditingEnableDeviceResponseBodies, AuditingEnableDeviceRequestParameters } from './types/operations/auditing-enable-device.type'
import type { AuditingDisableDeviceOperation, AuditingDisableDeviceResponseBodies, AuditingDisableDeviceRequestParameters } from './types/operations/auditing-disable-device.type'
import type { AuthListEnabledMethodsOperation, AuthListEnabledMethodsResponseBodies, AuthListEnabledMethodsRequestParameters } from './types/operations/auth-list-enabled-methods.type'
import type { AuthReadConfigurationOperation, AuthReadConfigurationResponseBodies, AuthReadConfigurationRequestParameters } from './types/operations/auth-read-configuration.type'
import type { AuthEnableMethodOperation, AuthEnableMethodResponseBodies, AuthEnableMethodRequestParameters } from './types/operations/auth-enable-method.type'
import type { AuthDisableMethodOperation, AuthDisableMethodResponseBodies, AuthDisableMethodRequestParameters } from './types/operations/auth-disable-method.type'
import type { AuthReadTuningInformationOperation, AuthReadTuningInformationResponseBodies, AuthReadTuningInformationRequestParameters } from './types/operations/auth-read-tuning-information.type'
import type { AuthTuneConfigurationParametersOperation, AuthTuneConfigurationParametersResponseBodies, AuthTuneConfigurationParametersRequestParameters } from './types/operations/auth-tune-configuration-parameters.type'
import type { QueryTokenCapabilitiesOperation, QueryTokenCapabilitiesResponseBodies, QueryTokenCapabilitiesRequestParameters } from './types/operations/query-token-capabilities.type'
import type { QueryTokenAccessorCapabilitiesOperation, QueryTokenAccessorCapabilitiesResponseBodies, QueryTokenAccessorCapabilitiesRequestParameters } from './types/operations/query-token-accessor-capabilities.type'
import type { QueryTokenSelfCapabilitiesOperation, QueryTokenSelfCapabilitiesResponseBodies, QueryTokenSelfCapabilitiesRequestParameters } from './types/operations/query-token-self-capabilities.type'
import type { AuditingListRequestHeadersOperation, AuditingListRequestHeadersResponseBodies, AuditingListRequestHeadersRequestParameters } from './types/operations/auditing-list-request-headers.type'
import type { AuditingReadRequestHeaderInformationOperation, AuditingReadRequestHeaderInformationResponseBodies, AuditingReadRequestHeaderInformationRequestParameters } from './types/operations/auditing-read-request-header-information.type'
import type { AuditingEnableRequestHeaderOperation, AuditingEnableRequestHeaderResponseBodies, AuditingEnableRequestHeaderRequestParameters } from './types/operations/auditing-enable-request-header.type'
import type { AuditingDisableRequestHeaderOperation, AuditingDisableRequestHeaderResponseBodies, AuditingDisableRequestHeaderRequestParameters } from './types/operations/auditing-disable-request-header.type'
import type { CorsReadConfigurationOperation, CorsReadConfigurationResponseBodies, CorsReadConfigurationRequestParameters } from './types/operations/cors-read-configuration.type'
import type { CorsConfigureOperation, CorsConfigureResponseBodies, CorsConfigureRequestParameters } from './types/operations/cors-configure.type'
import type { CorsDeleteConfigurationOperation, CorsDeleteConfigurationResponseBodies, CorsDeleteConfigurationRequestParameters } from './types/operations/cors-delete-configuration.type'
import type { ReloadSubsystemOperation, ReloadSubsystemResponseBodies, ReloadSubsystemRequestParameters } from './types/operations/reload-subsystem.type'
import type { ReadSanitizedConfigurationStateOperation, ReadSanitizedConfigurationStateResponseBodies, ReadSanitizedConfigurationStateRequestParameters } from './types/operations/read-sanitized-configuration-state.type'
import type { UiHeadersListOperation, UiHeadersListResponseBodies, UiHeadersListRequestParameters } from './types/operations/ui-headers-list.type'
import type { UiHeadersReadConfigurationOperation, UiHeadersReadConfigurationResponseBodies, UiHeadersReadConfigurationRequestParameters } from './types/operations/ui-headers-read-configuration.type'
import type { UiHeadersConfigureOperation, UiHeadersConfigureResponseBodies, UiHeadersConfigureRequestParameters } from './types/operations/ui-headers-configure.type'
import type { UiHeadersDeleteConfigurationOperation, UiHeadersDeleteConfigurationResponseBodies, UiHeadersDeleteConfigurationRequestParameters } from './types/operations/ui-headers-delete-configuration.type'
import type { DecodeOperation, DecodeResponseBodies, DecodeRequestParameters } from './types/operations/decode.type'
import type { RootTokenGenerationReadProgress2Operation, RootTokenGenerationReadProgress2ResponseBodies, RootTokenGenerationReadProgress2RequestParameters } from './types/operations/root-token-generation-read-progress2.type'
import type { RootTokenGenerationReadProgressOperation, RootTokenGenerationReadProgressResponseBodies, RootTokenGenerationReadProgressRequestParameters } from './types/operations/root-token-generation-read-progress.type'
import type { RootTokenGenerationInitializeOperation, RootTokenGenerationInitializeResponseBodies, RootTokenGenerationInitializeRequestParameters } from './types/operations/root-token-generation-initialize.type'
import type { RootTokenGenerationCancelOperation, RootTokenGenerationCancelResponseBodies, RootTokenGenerationCancelRequestParameters } from './types/operations/root-token-generation-cancel.type'
import type { RootTokenGenerationUpdateOperation, RootTokenGenerationUpdateResponseBodies, RootTokenGenerationUpdateRequestParameters } from './types/operations/root-token-generation-update.type'
import type { HaStatusOperation, HaStatusResponseBodies, HaStatusRequestParameters } from './types/operations/ha-status.type'
import type { ReadHealthStatusOperation, ReadHealthStatusResponseBodies, ReadHealthStatusRequestParameters } from './types/operations/read-health-status.type'
import type { CollectHostInformationOperation, CollectHostInformationResponseBodies, CollectHostInformationRequestParameters } from './types/operations/collect-host-information.type'
import type { CollectInFlightRequestInformationOperation, CollectInFlightRequestInformationResponseBodies, CollectInFlightRequestInformationRequestParameters } from './types/operations/collect-in-flight-request-information.type'
import type { ReadInitializationStatusOperation, ReadInitializationStatusResponseBodies, ReadInitializationStatusRequestParameters } from './types/operations/read-initialization-status.type'
import type { InitializeSystemOperation, InitializeSystemResponseBodies, InitializeSystemRequestParameters } from './types/operations/initialize-system.type'
import type { EncryptionKeyStatusOperation, EncryptionKeyStatusResponseBodies, EncryptionKeyStatusRequestParameters } from './types/operations/encryption-key-status.type'
import type { LeaderStatusOperation, LeaderStatusResponseBodies, LeaderStatusRequestParameters } from './types/operations/leader-status.type'
import type { LeasesListOperation, LeasesListResponseBodies, LeasesListRequestParameters } from './types/operations/leases-list.type'
import type { LeasesCountOperation, LeasesCountResponseBodies, LeasesCountRequestParameters } from './types/operations/leases-count.type'
import type { LeasesReadLeaseOperation, LeasesReadLeaseResponseBodies, LeasesReadLeaseRequestParameters } from './types/operations/leases-read-lease.type'
import type { LeasesLookUpOperation, LeasesLookUpResponseBodies, LeasesLookUpRequestParameters } from './types/operations/leases-look-up.type'
import type { LeasesLookUpWithPrefixOperation, LeasesLookUpWithPrefixResponseBodies, LeasesLookUpWithPrefixRequestParameters } from './types/operations/leases-look-up-with-prefix.type'
import type { LeasesRenewLeaseOperation, LeasesRenewLeaseResponseBodies, LeasesRenewLeaseRequestParameters } from './types/operations/leases-renew-lease.type'
import type { LeasesRenewLeaseWithIdOperation, LeasesRenewLeaseWithIdResponseBodies, LeasesRenewLeaseWithIdRequestParameters } from './types/operations/leases-renew-lease-with-id.type'
import type { LeasesRevokeLeaseOperation, LeasesRevokeLeaseResponseBodies, LeasesRevokeLeaseRequestParameters } from './types/operations/leases-revoke-lease.type'
import type { LeasesForceRevokeLeaseWithPrefixOperation, LeasesForceRevokeLeaseWithPrefixResponseBodies, LeasesForceRevokeLeaseWithPrefixRequestParameters } from './types/operations/leases-force-revoke-lease-with-prefix.type'
import type { LeasesRevokeLeaseWithPrefixOperation, LeasesRevokeLeaseWithPrefixResponseBodies, LeasesRevokeLeaseWithPrefixRequestParameters } from './types/operations/leases-revoke-lease-with-prefix.type'
import type { LeasesRevokeLeaseWithIdOperation, LeasesRevokeLeaseWithIdResponseBodies, LeasesRevokeLeaseWithIdRequestParameters } from './types/operations/leases-revoke-lease-with-id.type'
import type { LeasesTidyOperation, LeasesTidyResponseBodies, LeasesTidyRequestParameters } from './types/operations/leases-tidy.type'
import type { LockedUsersListOperation, LockedUsersListResponseBodies, LockedUsersListRequestParameters } from './types/operations/locked-users-list.type'
import type { LockedUsersUnlockOperation, LockedUsersUnlockResponseBodies, LockedUsersUnlockRequestParameters } from './types/operations/locked-users-unlock.type'
import type { LoggersReadVerbosityLevelOperation, LoggersReadVerbosityLevelResponseBodies, LoggersReadVerbosityLevelRequestParameters } from './types/operations/loggers-read-verbosity-level.type'
import type { LoggersUpdateVerbosityLevelOperation, LoggersUpdateVerbosityLevelResponseBodies, LoggersUpdateVerbosityLevelRequestParameters } from './types/operations/loggers-update-verbosity-level.type'
import type { LoggersRevertVerbosityLevelOperation, LoggersRevertVerbosityLevelResponseBodies, LoggersRevertVerbosityLevelRequestParameters } from './types/operations/loggers-revert-verbosity-level.type'
import type { LoggersReadVerbosityLevelForOperation, LoggersReadVerbosityLevelForResponseBodies, LoggersReadVerbosityLevelForRequestParameters } from './types/operations/loggers-read-verbosity-level-for.type'
import type { LoggersUpdateVerbosityLevelForOperation, LoggersUpdateVerbosityLevelForResponseBodies, LoggersUpdateVerbosityLevelForRequestParameters } from './types/operations/loggers-update-verbosity-level-for.type'
import type { LoggersRevertVerbosityLevelForOperation, LoggersRevertVerbosityLevelForResponseBodies, LoggersRevertVerbosityLevelForRequestParameters } from './types/operations/loggers-revert-verbosity-level-for.type'
import type { MetricsOperation, MetricsResponseBodies, MetricsRequestParameters } from './types/operations/metrics.type'
import type { MfaValidateOperation, MfaValidateResponseBodies, MfaValidateRequestParameters } from './types/operations/mfa-validate.type'
import type { MonitorOperation, MonitorResponseBodies, MonitorRequestParameters } from './types/operations/monitor.type'
import type { MountsListSecretsEnginesOperation, MountsListSecretsEnginesResponseBodies, MountsListSecretsEnginesRequestParameters } from './types/operations/mounts-list-secrets-engines.type'
import type { MountsReadConfigurationOperation, MountsReadConfigurationResponseBodies, MountsReadConfigurationRequestParameters } from './types/operations/mounts-read-configuration.type'
import type { MountsEnableSecretsEngineOperation, MountsEnableSecretsEngineResponseBodies, MountsEnableSecretsEngineRequestParameters } from './types/operations/mounts-enable-secrets-engine.type'
import type { MountsDisableSecretsEngineOperation, MountsDisableSecretsEngineResponseBodies, MountsDisableSecretsEngineRequestParameters } from './types/operations/mounts-disable-secrets-engine.type'
import type { MountsReadTuningInformationOperation, MountsReadTuningInformationResponseBodies, MountsReadTuningInformationRequestParameters } from './types/operations/mounts-read-tuning-information.type'
import type { MountsTuneConfigurationParametersOperation, MountsTuneConfigurationParametersResponseBodies, MountsTuneConfigurationParametersRequestParameters } from './types/operations/mounts-tune-configuration-parameters.type'
import type { NamespacesListNamespacesOperation, NamespacesListNamespacesResponseBodies, NamespacesListNamespacesRequestParameters } from './types/operations/namespaces-list-namespaces.type'
import type { NamespacesWriteNamespacesApiLockLockOperation, NamespacesWriteNamespacesApiLockLockResponseBodies, NamespacesWriteNamespacesApiLockLockRequestParameters } from './types/operations/namespaces-write-namespaces-api-lock-lock.type'
import type { NamespacesWriteNamespacesApiLockLockPathOperation, NamespacesWriteNamespacesApiLockLockPathResponseBodies, NamespacesWriteNamespacesApiLockLockPathRequestParameters } from './types/operations/namespaces-write-namespaces-api-lock-lock-path.type'
import type { NamespacesWriteNamespacesApiLockUnlockOperation, NamespacesWriteNamespacesApiLockUnlockResponseBodies, NamespacesWriteNamespacesApiLockUnlockRequestParameters } from './types/operations/namespaces-write-namespaces-api-lock-unlock.type'
import type { NamespacesWriteNamespacesApiLockUnlockPathOperation, NamespacesWriteNamespacesApiLockUnlockPathResponseBodies, NamespacesWriteNamespacesApiLockUnlockPathRequestParameters } from './types/operations/namespaces-write-namespaces-api-lock-unlock-path.type'
import type { NamespacesReadNamespacesPathOperation, NamespacesReadNamespacesPathResponseBodies, NamespacesReadNamespacesPathRequestParameters } from './types/operations/namespaces-read-namespaces-path.type'
import type { NamespacesWriteNamespacesPathOperation, NamespacesWriteNamespacesPathResponseBodies, NamespacesWriteNamespacesPathRequestParameters } from './types/operations/namespaces-write-namespaces-path.type'
import type { NamespacesDeleteNamespacesPathOperation, NamespacesDeleteNamespacesPathResponseBodies, NamespacesDeleteNamespacesPathRequestParameters } from './types/operations/namespaces-delete-namespaces-path.type'
import type { PluginsCatalogListPluginsOperation, PluginsCatalogListPluginsResponseBodies, PluginsCatalogListPluginsRequestParameters } from './types/operations/plugins-catalog-list-plugins.type'
import type { PluginsCatalogReadPluginConfigurationOperation, PluginsCatalogReadPluginConfigurationResponseBodies, PluginsCatalogReadPluginConfigurationRequestParameters } from './types/operations/plugins-catalog-read-plugin-configuration.type'
import type { PluginsCatalogRegisterPluginOperation, PluginsCatalogRegisterPluginResponseBodies, PluginsCatalogRegisterPluginRequestParameters } from './types/operations/plugins-catalog-register-plugin.type'
import type { PluginsCatalogRemovePluginOperation, PluginsCatalogRemovePluginResponseBodies, PluginsCatalogRemovePluginRequestParameters } from './types/operations/plugins-catalog-remove-plugin.type'
import type { PluginsCatalogListPluginsWithTypeOperation, PluginsCatalogListPluginsWithTypeResponseBodies, PluginsCatalogListPluginsWithTypeRequestParameters } from './types/operations/plugins-catalog-list-plugins-with-type.type'
import type { PluginsCatalogReadPluginConfigurationWithTypeOperation, PluginsCatalogReadPluginConfigurationWithTypeResponseBodies, PluginsCatalogReadPluginConfigurationWithTypeRequestParameters } from './types/operations/plugins-catalog-read-plugin-configuration-with-type.type'
import type { PluginsCatalogRegisterPluginWithTypeOperation, PluginsCatalogRegisterPluginWithTypeResponseBodies, PluginsCatalogRegisterPluginWithTypeRequestParameters } from './types/operations/plugins-catalog-register-plugin-with-type.type'
import type { PluginsCatalogRemovePluginWithTypeOperation, PluginsCatalogRemovePluginWithTypeResponseBodies, PluginsCatalogRemovePluginWithTypeRequestParameters } from './types/operations/plugins-catalog-remove-plugin-with-type.type'
import type { PluginsReloadBackendsOperation, PluginsReloadBackendsResponseBodies, PluginsReloadBackendsRequestParameters } from './types/operations/plugins-reload-backends.type'
import type { PoliciesListAclPoliciesOperation, PoliciesListAclPoliciesResponseBodies, PoliciesListAclPoliciesRequestParameters } from './types/operations/policies-list-acl-policies.type'
import type { PoliciesReadAclPolicyOperation, PoliciesReadAclPolicyResponseBodies, PoliciesReadAclPolicyRequestParameters } from './types/operations/policies-read-acl-policy.type'
import type { PoliciesWriteAclPolicyOperation, PoliciesWriteAclPolicyResponseBodies, PoliciesWriteAclPolicyRequestParameters } from './types/operations/policies-write-acl-policy.type'
import type { PoliciesDeleteAclPolicyOperation, PoliciesDeleteAclPolicyResponseBodies, PoliciesDeleteAclPolicyRequestParameters } from './types/operations/policies-delete-acl-policy.type'
import type { SystemListPoliciesDetailedAclOperation, SystemListPoliciesDetailedAclResponseBodies, SystemListPoliciesDetailedAclRequestParameters } from './types/operations/system-list-policies-detailed-acl.type'
import type { SystemListPoliciesDetailedAclNameOperation, SystemListPoliciesDetailedAclNameResponseBodies, SystemListPoliciesDetailedAclNameRequestParameters } from './types/operations/system-list-policies-detailed-acl-name.type'
import type { PoliciesListPasswordPoliciesOperation, PoliciesListPasswordPoliciesResponseBodies, PoliciesListPasswordPoliciesRequestParameters } from './types/operations/policies-list-password-policies.type'
import type { PoliciesReadPasswordPolicyOperation, PoliciesReadPasswordPolicyResponseBodies, PoliciesReadPasswordPolicyRequestParameters } from './types/operations/policies-read-password-policy.type'
import type { PoliciesWritePasswordPolicyOperation, PoliciesWritePasswordPolicyResponseBodies, PoliciesWritePasswordPolicyRequestParameters } from './types/operations/policies-write-password-policy.type'
import type { PoliciesDeletePasswordPolicyOperation, PoliciesDeletePasswordPolicyResponseBodies, PoliciesDeletePasswordPolicyRequestParameters } from './types/operations/policies-delete-password-policy.type'
import type { PoliciesGeneratePasswordFromPasswordPolicyOperation, PoliciesGeneratePasswordFromPasswordPolicyResponseBodies, PoliciesGeneratePasswordFromPasswordPolicyRequestParameters } from './types/operations/policies-generate-password-from-password-policy.type'
import type { PoliciesListOperation, PoliciesListResponseBodies, PoliciesListRequestParameters } from './types/operations/policies-list.type'
import type { RateLimitQuotasReadConfigurationOperation, RateLimitQuotasReadConfigurationResponseBodies, RateLimitQuotasReadConfigurationRequestParameters } from './types/operations/rate-limit-quotas-read-configuration.type'
import type { RateLimitQuotasConfigureOperation, RateLimitQuotasConfigureResponseBodies, RateLimitQuotasConfigureRequestParameters } from './types/operations/rate-limit-quotas-configure.type'
import type { RateLimitQuotasListOperation, RateLimitQuotasListResponseBodies, RateLimitQuotasListRequestParameters } from './types/operations/rate-limit-quotas-list.type'
import type { RateLimitQuotasReadOperation, RateLimitQuotasReadResponseBodies, RateLimitQuotasReadRequestParameters } from './types/operations/rate-limit-quotas-read.type'
import type { RateLimitQuotasWriteOperation, RateLimitQuotasWriteResponseBodies, RateLimitQuotasWriteRequestParameters } from './types/operations/rate-limit-quotas-write.type'
import type { RateLimitQuotasDeleteOperation, RateLimitQuotasDeleteResponseBodies, RateLimitQuotasDeleteRequestParameters } from './types/operations/rate-limit-quotas-delete.type'
import type { RekeyReadBackupKeyOperation, RekeyReadBackupKeyResponseBodies, RekeyReadBackupKeyRequestParameters } from './types/operations/rekey-read-backup-key.type'
import type { RekeyDeleteBackupKeyOperation, RekeyDeleteBackupKeyResponseBodies, RekeyDeleteBackupKeyRequestParameters } from './types/operations/rekey-delete-backup-key.type'
import type { RekeyAttemptReadProgressOperation, RekeyAttemptReadProgressResponseBodies, RekeyAttemptReadProgressRequestParameters } from './types/operations/rekey-attempt-read-progress.type'
import type { RekeyAttemptInitializeOperation, RekeyAttemptInitializeResponseBodies, RekeyAttemptInitializeRequestParameters } from './types/operations/rekey-attempt-initialize.type'
import type { RekeyAttemptCancelOperation, RekeyAttemptCancelResponseBodies, RekeyAttemptCancelRequestParameters } from './types/operations/rekey-attempt-cancel.type'
import type { RekeyReadBackupRecoveryKeyOperation, RekeyReadBackupRecoveryKeyResponseBodies, RekeyReadBackupRecoveryKeyRequestParameters } from './types/operations/rekey-read-backup-recovery-key.type'
import type { RekeyDeleteBackupRecoveryKeyOperation, RekeyDeleteBackupRecoveryKeyResponseBodies, RekeyDeleteBackupRecoveryKeyRequestParameters } from './types/operations/rekey-delete-backup-recovery-key.type'
import type { RekeyAttemptUpdateOperation, RekeyAttemptUpdateResponseBodies, RekeyAttemptUpdateRequestParameters } from './types/operations/rekey-attempt-update.type'
import type { RekeyVerificationReadProgressOperation, RekeyVerificationReadProgressResponseBodies, RekeyVerificationReadProgressRequestParameters } from './types/operations/rekey-verification-read-progress.type'
import type { RekeyVerificationUpdateOperation, RekeyVerificationUpdateResponseBodies, RekeyVerificationUpdateRequestParameters } from './types/operations/rekey-verification-update.type'
import type { RekeyVerificationCancelOperation, RekeyVerificationCancelResponseBodies, RekeyVerificationCancelRequestParameters } from './types/operations/rekey-verification-cancel.type'
import type { RemountOperation, RemountResponseBodies, RemountRequestParameters } from './types/operations/remount.type'
import type { RemountStatusOperation, RemountStatusResponseBodies, RemountStatusRequestParameters } from './types/operations/remount-status.type'
import type { EncryptionKeyRotateOperation, EncryptionKeyRotateResponseBodies, EncryptionKeyRotateRequestParameters } from './types/operations/encryption-key-rotate.type'
import type { EncryptionKeyReadRotationConfigurationOperation, EncryptionKeyReadRotationConfigurationResponseBodies, EncryptionKeyReadRotationConfigurationRequestParameters } from './types/operations/encryption-key-read-rotation-configuration.type'
import type { EncryptionKeyConfigureRotationConfigurationOperation, EncryptionKeyConfigureRotationConfigurationResponseBodies, EncryptionKeyConfigureRotationConfigurationRequestParameters } from './types/operations/encryption-key-configure-rotation-configuration.type'
import type { EncryptionKeyRotateRotateKeyringOperation, EncryptionKeyRotateRotateKeyringResponseBodies, EncryptionKeyRotateRotateKeyringRequestParameters } from './types/operations/encryption-key-rotate-rotate-keyring.type'
import type { EncryptionKeyReadRotateKeyringConfigOperation, EncryptionKeyReadRotateKeyringConfigResponseBodies, EncryptionKeyReadRotateKeyringConfigRequestParameters } from './types/operations/encryption-key-read-rotate-keyring-config.type'
import type { EncryptionKeyConfigureRotateKeyringConfigOperation, EncryptionKeyConfigureRotateKeyringConfigResponseBodies, EncryptionKeyConfigureRotateKeyringConfigRequestParameters } from './types/operations/encryption-key-configure-rotate-keyring-config.type'
import type { RotateReadRotateRecoveryBackupOperation, RotateReadRotateRecoveryBackupResponseBodies, RotateReadRotateRecoveryBackupRequestParameters } from './types/operations/rotate-read-rotate-recovery-backup.type'
import type { RotateDeleteRotateRecoveryBackupOperation, RotateDeleteRotateRecoveryBackupResponseBodies, RotateDeleteRotateRecoveryBackupRequestParameters } from './types/operations/rotate-delete-rotate-recovery-backup.type'
import type { RotateAttemptReadRotateRecoveryInitOperation, RotateAttemptReadRotateRecoveryInitResponseBodies, RotateAttemptReadRotateRecoveryInitRequestParameters } from './types/operations/rotate-attempt-read-rotate-recovery-init.type'
import type { RotateAttemptInitializeRotateRecoveryInitOperation, RotateAttemptInitializeRotateRecoveryInitResponseBodies, RotateAttemptInitializeRotateRecoveryInitRequestParameters } from './types/operations/rotate-attempt-initialize-rotate-recovery-init.type'
import type { RotateAttemptCancelRotateRecoveryInitOperation, RotateAttemptCancelRotateRecoveryInitResponseBodies, RotateAttemptCancelRotateRecoveryInitRequestParameters } from './types/operations/rotate-attempt-cancel-rotate-recovery-init.type'
import type { RotateAttemptUpdateRotateRecoveryUpdateOperation, RotateAttemptUpdateRotateRecoveryUpdateResponseBodies, RotateAttemptUpdateRotateRecoveryUpdateRequestParameters } from './types/operations/rotate-attempt-update-rotate-recovery-update.type'
import type { RotateVerificationReadRotateRecoveryVerifyOperation, RotateVerificationReadRotateRecoveryVerifyResponseBodies, RotateVerificationReadRotateRecoveryVerifyRequestParameters } from './types/operations/rotate-verification-read-rotate-recovery-verify.type'
import type { RotateVerificationUpdateRotateRecoveryVerifyOperation, RotateVerificationUpdateRotateRecoveryVerifyResponseBodies, RotateVerificationUpdateRotateRecoveryVerifyRequestParameters } from './types/operations/rotate-verification-update-rotate-recovery-verify.type'
import type { RotateVerificationCancelRotateRecoveryVerifyOperation, RotateVerificationCancelRotateRecoveryVerifyResponseBodies, RotateVerificationCancelRotateRecoveryVerifyRequestParameters } from './types/operations/rotate-verification-cancel-rotate-recovery-verify.type'
import type { RootKeyRotateOperation, RootKeyRotateResponseBodies, RootKeyRotateRequestParameters } from './types/operations/root-key-rotate.type'
import type { RotateReadBackupKeyOperation, RotateReadBackupKeyResponseBodies, RotateReadBackupKeyRequestParameters } from './types/operations/rotate-read-backup-key.type'
import type { RotateDeleteBackupKeyOperation, RotateDeleteBackupKeyResponseBodies, RotateDeleteBackupKeyRequestParameters } from './types/operations/rotate-delete-backup-key.type'
import type { RotateAttemptReadProgressOperation, RotateAttemptReadProgressResponseBodies, RotateAttemptReadProgressRequestParameters } from './types/operations/rotate-attempt-read-progress.type'
import type { RotateAttemptInitializeOperation, RotateAttemptInitializeResponseBodies, RotateAttemptInitializeRequestParameters } from './types/operations/rotate-attempt-initialize.type'
import type { RotateAttemptCancelOperation, RotateAttemptCancelResponseBodies, RotateAttemptCancelRequestParameters } from './types/operations/rotate-attempt-cancel.type'
import type { RotateAttemptUpdateOperation, RotateAttemptUpdateResponseBodies, RotateAttemptUpdateRequestParameters } from './types/operations/rotate-attempt-update.type'
import type { RotateVerificationReadProgressOperation, RotateVerificationReadProgressResponseBodies, RotateVerificationReadProgressRequestParameters } from './types/operations/rotate-verification-read-progress.type'
import type { RotateVerificationUpdateOperation, RotateVerificationUpdateResponseBodies, RotateVerificationUpdateRequestParameters } from './types/operations/rotate-verification-update.type'
import type { RotateVerificationCancelOperation, RotateVerificationCancelResponseBodies, RotateVerificationCancelRequestParameters } from './types/operations/rotate-verification-cancel.type'
import type { SealOperation, SealResponseBodies, SealRequestParameters } from './types/operations/seal.type'
import type { SealStatusOperation, SealStatusResponseBodies, SealStatusRequestParameters } from './types/operations/seal-status.type'
import type { StepDownLeaderOperation, StepDownLeaderResponseBodies, StepDownLeaderRequestParameters } from './types/operations/step-down-leader.type'
import type { GenerateHashOperation, GenerateHashResponseBodies, GenerateHashRequestParameters } from './types/operations/generate-hash.type'
import type { GenerateHashWithAlgorithmOperation, GenerateHashWithAlgorithmResponseBodies, GenerateHashWithAlgorithmRequestParameters } from './types/operations/generate-hash-with-algorithm.type'
import type { GenerateRandomOperation, GenerateRandomResponseBodies, GenerateRandomRequestParameters } from './types/operations/generate-random.type'
import type { GenerateRandomWithSourceOperation, GenerateRandomWithSourceResponseBodies, GenerateRandomWithSourceRequestParameters } from './types/operations/generate-random-with-source.type'
import type { GenerateRandomWithSourceAndBytesOperation, GenerateRandomWithSourceAndBytesResponseBodies, GenerateRandomWithSourceAndBytesRequestParameters } from './types/operations/generate-random-with-source-and-bytes.type'
import type { GenerateRandomWithBytesOperation, GenerateRandomWithBytesResponseBodies, GenerateRandomWithBytesRequestParameters } from './types/operations/generate-random-with-bytes.type'
import type { UnsealOperation, UnsealResponseBodies, UnsealRequestParameters } from './types/operations/unseal.type'
import type { ReadWrappingPropertiesOperation, ReadWrappingPropertiesResponseBodies, ReadWrappingPropertiesRequestParameters } from './types/operations/read-wrapping-properties.type'
import type { RewrapOperation, RewrapResponseBodies, RewrapRequestParameters } from './types/operations/rewrap.type'
import type { UnwrapOperation, UnwrapResponseBodies, UnwrapRequestParameters } from './types/operations/unwrap.type'
import type { WrapOperation, WrapResponseBodies, WrapRequestParameters } from './types/operations/wrap.type'
import type { TransitBackUpKeyOperation, TransitBackUpKeyResponseBodies, TransitBackUpKeyRequestParameters } from './types/operations/transit-back-up-key.type'
import type { TransitByokKeyOperation, TransitByokKeyResponseBodies, TransitByokKeyRequestParameters } from './types/operations/transit-byok-key.type'
import type { TransitByokKeyVersionOperation, TransitByokKeyVersionResponseBodies, TransitByokKeyVersionRequestParameters } from './types/operations/transit-byok-key-version.type'
import type { TransitReadCacheConfigurationOperation, TransitReadCacheConfigurationResponseBodies, TransitReadCacheConfigurationRequestParameters } from './types/operations/transit-read-cache-configuration.type'
import type { TransitConfigureCacheOperation, TransitConfigureCacheResponseBodies, TransitConfigureCacheRequestParameters } from './types/operations/transit-configure-cache.type'
import type { TransitReadKeysConfigurationOperation, TransitReadKeysConfigurationResponseBodies, TransitReadKeysConfigurationRequestParameters } from './types/operations/transit-read-keys-configuration.type'
import type { TransitConfigureKeysOperation, TransitConfigureKeysResponseBodies, TransitConfigureKeysRequestParameters } from './types/operations/transit-configure-keys.type'
import type { TransitGenerateDataKeyOperation, TransitGenerateDataKeyResponseBodies, TransitGenerateDataKeyRequestParameters } from './types/operations/transit-generate-data-key.type'
import type { TransitDecryptOperation, TransitDecryptResponseBodies, TransitDecryptRequestParameters } from './types/operations/transit-decrypt.type'
import type { TransitDeriveKeyOperation, TransitDeriveKeyResponseBodies, TransitDeriveKeyRequestParameters } from './types/operations/transit-derive-key.type'
import type { TransitEncryptOperation, TransitEncryptResponseBodies, TransitEncryptRequestParameters } from './types/operations/transit-encrypt.type'
import type { TransitExportKeyOperation, TransitExportKeyResponseBodies, TransitExportKeyRequestParameters } from './types/operations/transit-export-key.type'
import type { TransitExportKeyVersionOperation, TransitExportKeyVersionResponseBodies, TransitExportKeyVersionRequestParameters } from './types/operations/transit-export-key-version.type'
import type { TransitHashOperation, TransitHashResponseBodies, TransitHashRequestParameters } from './types/operations/transit-hash.type'
import type { TransitHashWithAlgorithmOperation, TransitHashWithAlgorithmResponseBodies, TransitHashWithAlgorithmRequestParameters } from './types/operations/transit-hash-with-algorithm.type'
import type { TransitGenerateHmacOperation, TransitGenerateHmacResponseBodies, TransitGenerateHmacRequestParameters } from './types/operations/transit-generate-hmac.type'
import type { TransitGenerateHmacWithAlgorithmOperation, TransitGenerateHmacWithAlgorithmResponseBodies, TransitGenerateHmacWithAlgorithmRequestParameters } from './types/operations/transit-generate-hmac-with-algorithm.type'
import type { TransitListKeysOperation, TransitListKeysResponseBodies, TransitListKeysRequestParameters } from './types/operations/transit-list-keys.type'
import type { TransitReadKeyOperation, TransitReadKeyResponseBodies, TransitReadKeyRequestParameters } from './types/operations/transit-read-key.type'
import type { TransitCreateKeyOperation, TransitCreateKeyResponseBodies, TransitCreateKeyRequestParameters } from './types/operations/transit-create-key.type'
import type { TransitDeleteKeyOperation, TransitDeleteKeyResponseBodies, TransitDeleteKeyRequestParameters } from './types/operations/transit-delete-key.type'
import type { TransitConfigureKeyOperation, TransitConfigureKeyResponseBodies, TransitConfigureKeyRequestParameters } from './types/operations/transit-configure-key.type'
import type { GetCsrOperation, GetCsrResponseBodies, GetCsrRequestParameters } from './types/operations/get-csr.type'
import type { TransitImportKeyOperation, TransitImportKeyResponseBodies, TransitImportKeyRequestParameters } from './types/operations/transit-import-key.type'
import type { TransitImportKeyVersionOperation, TransitImportKeyVersionResponseBodies, TransitImportKeyVersionRequestParameters } from './types/operations/transit-import-key-version.type'
import type { TransitRotateKeyOperation, TransitRotateKeyResponseBodies, TransitRotateKeyRequestParameters } from './types/operations/transit-rotate-key.type'
import type { SetChainOperation, SetChainResponseBodies, SetChainRequestParameters } from './types/operations/set-chain.type'
import type { TransitSoftDeleteKeyOperation, TransitSoftDeleteKeyResponseBodies, TransitSoftDeleteKeyRequestParameters } from './types/operations/transit-soft-delete-key.type'
import type { TransitSoftDeleteRestoreKeyOperation, TransitSoftDeleteRestoreKeyResponseBodies, TransitSoftDeleteRestoreKeyRequestParameters } from './types/operations/transit-soft-delete-restore-key.type'
import type { TransitTrimKeyOperation, TransitTrimKeyResponseBodies, TransitTrimKeyRequestParameters } from './types/operations/transit-trim-key.type'
import type { TransitGenerateRandomOperation, TransitGenerateRandomResponseBodies, TransitGenerateRandomRequestParameters } from './types/operations/transit-generate-random.type'
import type { TransitGenerateRandomWithSourceOperation, TransitGenerateRandomWithSourceResponseBodies, TransitGenerateRandomWithSourceRequestParameters } from './types/operations/transit-generate-random-with-source.type'
import type { TransitGenerateRandomWithSourceAndBytesOperation, TransitGenerateRandomWithSourceAndBytesResponseBodies, TransitGenerateRandomWithSourceAndBytesRequestParameters } from './types/operations/transit-generate-random-with-source-and-bytes.type'
import type { TransitGenerateRandomWithBytesOperation, TransitGenerateRandomWithBytesResponseBodies, TransitGenerateRandomWithBytesRequestParameters } from './types/operations/transit-generate-random-with-bytes.type'
import type { TransitRestoreKeyOperation, TransitRestoreKeyResponseBodies, TransitRestoreKeyRequestParameters } from './types/operations/transit-restore-key.type'
import type { TransitRestoreAndRenameKeyOperation, TransitRestoreAndRenameKeyResponseBodies, TransitRestoreAndRenameKeyRequestParameters } from './types/operations/transit-restore-and-rename-key.type'
import type { TransitRewrapOperation, TransitRewrapResponseBodies, TransitRewrapRequestParameters } from './types/operations/transit-rewrap.type'
import type { TransitSignOperation, TransitSignResponseBodies, TransitSignRequestParameters } from './types/operations/transit-sign.type'
import type { TransitSignWithAlgorithmOperation, TransitSignWithAlgorithmResponseBodies, TransitSignWithAlgorithmRequestParameters } from './types/operations/transit-sign-with-algorithm.type'
import type { TransitVerifyOperation, TransitVerifyResponseBodies, TransitVerifyRequestParameters } from './types/operations/transit-verify.type'
import type { TransitVerifyWithAlgorithmOperation, TransitVerifyWithAlgorithmResponseBodies, TransitVerifyWithAlgorithmRequestParameters } from './types/operations/transit-verify-with-algorithm.type'
import type { TransitReadWrappingKeyOperation, TransitReadWrappingKeyResponseBodies, TransitReadWrappingKeyRequestParameters } from './types/operations/transit-read-wrapping-key.type'

@Injectable()
export class OpenBaoHttpClient {
  private readonly logger = new Logger(OpenBaoHttpClient.name)

  constructor(
    // @anchor:client-constructor-parameters:start
    private readonly request: KeqRequest,
    // @anchor:client-constructor-parameters:end
  ) {}


  kubernetesReadAuthConfiguration<STATUS extends keyof KubernetesReadAuthConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: KubernetesReadAuthConfigurationRequestParameters): Keq<KubernetesReadAuthConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KubernetesReadAuthConfigurationResponseBodies[STATUS]>('/auth/kubernetes001/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kubernetesConfigureAuth<STATUS extends keyof KubernetesConfigureAuthResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KubernetesConfigureAuthRequestParameters): Keq<KubernetesConfigureAuthOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KubernetesConfigureAuthResponseBodies[STATUS]>('/auth/kubernetes001/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'disable_iss_validation' in args) req.send({ disable_iss_validation: args['disable_iss_validation'] })
    if (args && 'disable_local_ca_jwt' in args) req.send({ disable_local_ca_jwt: args['disable_local_ca_jwt'] })
    if (args && 'issuer' in args) req.send({ issuer: args['issuer'] })
    if (args && 'kubernetes_ca_cert' in args) req.send({ kubernetes_ca_cert: args['kubernetes_ca_cert'] })
    if (args && 'kubernetes_host' in args) req.send({ kubernetes_host: args['kubernetes_host'] })
    if (args && 'pem_keys' in args) req.send({ pem_keys: args['pem_keys'] })
    if (args && 'token_reviewer_jwt' in args) req.send({ token_reviewer_jwt: args['token_reviewer_jwt'] })
    /* @anchor:body:end */

    return req
  }


  kubernetesLogin<STATUS extends keyof KubernetesLoginResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KubernetesLoginRequestParameters): Keq<KubernetesLoginOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KubernetesLoginResponseBodies[STATUS]>('/auth/kubernetes001/login')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'jwt' in args) req.send({ jwt: args['jwt'] })
    if (args && 'role' in args) req.send({ role: args['role'] })
    /* @anchor:body:end */

    return req
  }


  kubernetesListAuthRoles<STATUS extends keyof KubernetesListAuthRolesResponseBodies, CONTENT_TYPE extends never = never>(args?: KubernetesListAuthRolesRequestParameters): Keq<KubernetesListAuthRolesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KubernetesListAuthRolesResponseBodies[STATUS]>('/auth/kubernetes001/role')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kubernetesReadAuthRole<STATUS extends keyof KubernetesReadAuthRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: KubernetesReadAuthRoleRequestParameters): Keq<KubernetesReadAuthRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KubernetesReadAuthRoleResponseBodies[STATUS]>('/auth/kubernetes001/role/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kubernetesWriteAuthRole<STATUS extends keyof KubernetesWriteAuthRoleResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KubernetesWriteAuthRoleRequestParameters): Keq<KubernetesWriteAuthRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KubernetesWriteAuthRoleResponseBodies[STATUS]>('/auth/kubernetes001/role/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'alias_name_source' in args) req.send({ alias_name_source: args['alias_name_source'] })
    if (args && 'audience' in args) req.send({ audience: args['audience'] })
    if (args && 'bound_cidrs' in args) req.send({ bound_cidrs: args['bound_cidrs'] })
    if (args && 'bound_service_account_names' in args) req.send({ bound_service_account_names: args['bound_service_account_names'] })
    if (args && 'bound_service_account_namespace_selector' in args) req.send({ bound_service_account_namespace_selector: args['bound_service_account_namespace_selector'] })
    if (args && 'bound_service_account_namespaces' in args) req.send({ bound_service_account_namespaces: args['bound_service_account_namespaces'] })
    if (args && 'max_ttl' in args) req.send({ max_ttl: args['max_ttl'] })
    if (args && 'num_uses' in args) req.send({ num_uses: args['num_uses'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'token_bound_cidrs' in args) req.send({ token_bound_cidrs: args['token_bound_cidrs'] })
    if (args && 'token_explicit_max_ttl' in args) req.send({ token_explicit_max_ttl: args['token_explicit_max_ttl'] })
    if (args && 'token_max_ttl' in args) req.send({ token_max_ttl: args['token_max_ttl'] })
    if (args && 'token_no_default_policy' in args) req.send({ token_no_default_policy: args['token_no_default_policy'] })
    if (args && 'token_num_uses' in args) req.send({ token_num_uses: args['token_num_uses'] })
    if (args && 'token_period' in args) req.send({ token_period: args['token_period'] })
    if (args && 'token_policies' in args) req.send({ token_policies: args['token_policies'] })
    if (args && 'token_strictly_bind_ip' in args) req.send({ token_strictly_bind_ip: args['token_strictly_bind_ip'] })
    if (args && 'token_ttl' in args) req.send({ token_ttl: args['token_ttl'] })
    if (args && 'token_type' in args) req.send({ token_type: args['token_type'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    /* @anchor:body:end */

    return req
  }


  kubernetesDeleteAuthRole<STATUS extends keyof KubernetesDeleteAuthRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: KubernetesDeleteAuthRoleRequestParameters): Keq<KubernetesDeleteAuthRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<KubernetesDeleteAuthRoleResponseBodies[STATUS]>('/auth/kubernetes001/role/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenListAccessors<STATUS extends keyof TokenListAccessorsResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenListAccessorsRequestParameters): Keq<TokenListAccessorsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TokenListAccessorsResponseBodies[STATUS]>('/auth/token/accessors')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenCreate<STATUS extends keyof TokenCreateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenCreateRequestParameters): Keq<TokenCreateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenCreateResponseBodies[STATUS]>('/auth/token/create')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'display_name' in args) req.send({ display_name: args['display_name'] })
    if (args && 'entity_alias' in args) req.send({ entity_alias: args['entity_alias'] })
    if (args && 'explicit_max_ttl' in args) req.send({ explicit_max_ttl: args['explicit_max_ttl'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'lease' in args) req.send({ lease: args['lease'] })
    if (args && 'meta' in args) req.send({ meta: args['meta'] })
    if (args && 'no_default_policy' in args) req.send({ no_default_policy: args['no_default_policy'] })
    if (args && 'no_parent' in args) req.send({ no_parent: args['no_parent'] })
    if (args && 'num_uses' in args) req.send({ num_uses: args['num_uses'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'renewable' in args) req.send({ renewable: args['renewable'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  tokenCreateOrphan<STATUS extends keyof TokenCreateOrphanResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenCreateOrphanRequestParameters): Keq<TokenCreateOrphanOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenCreateOrphanResponseBodies[STATUS]>('/auth/token/create-orphan')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'display_name' in args) req.send({ display_name: args['display_name'] })
    if (args && 'entity_alias' in args) req.send({ entity_alias: args['entity_alias'] })
    if (args && 'explicit_max_ttl' in args) req.send({ explicit_max_ttl: args['explicit_max_ttl'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'lease' in args) req.send({ lease: args['lease'] })
    if (args && 'meta' in args) req.send({ meta: args['meta'] })
    if (args && 'no_default_policy' in args) req.send({ no_default_policy: args['no_default_policy'] })
    if (args && 'no_parent' in args) req.send({ no_parent: args['no_parent'] })
    if (args && 'num_uses' in args) req.send({ num_uses: args['num_uses'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'renewable' in args) req.send({ renewable: args['renewable'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  tokenCreateAgainstRole<STATUS extends keyof TokenCreateAgainstRoleResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenCreateAgainstRoleRequestParameters): Keq<TokenCreateAgainstRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenCreateAgainstRoleResponseBodies[STATUS]>('/auth/token/create/{role_name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'display_name' in args) req.send({ display_name: args['display_name'] })
    if (args && 'entity_alias' in args) req.send({ entity_alias: args['entity_alias'] })
    if (args && 'explicit_max_ttl' in args) req.send({ explicit_max_ttl: args['explicit_max_ttl'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'lease' in args) req.send({ lease: args['lease'] })
    if (args && 'meta' in args) req.send({ meta: args['meta'] })
    if (args && 'no_default_policy' in args) req.send({ no_default_policy: args['no_default_policy'] })
    if (args && 'no_parent' in args) req.send({ no_parent: args['no_parent'] })
    if (args && 'num_uses' in args) req.send({ num_uses: args['num_uses'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'renewable' in args) req.send({ renewable: args['renewable'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  tokenLookUpGet<STATUS extends keyof TokenLookUpGetResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenLookUpGetRequestParameters): Keq<TokenLookUpGetOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TokenLookUpGetResponseBodies[STATUS]>('/auth/token/lookup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenLookUpUpdate<STATUS extends keyof TokenLookUpUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenLookUpUpdateRequestParameters): Keq<TokenLookUpUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenLookUpUpdateResponseBodies[STATUS]>('/auth/token/lookup')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenLookUpByAccessor<STATUS extends keyof TokenLookUpByAccessorResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenLookUpByAccessorRequestParameters): Keq<TokenLookUpByAccessorOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenLookUpByAccessorResponseBodies[STATUS]>('/auth/token/lookup-accessor')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'accessor' in args) req.send({ accessor: args['accessor'] })
    /* @anchor:body:end */

    return req
  }


  tokenLookUpSelfGet<STATUS extends keyof TokenLookUpSelfGetResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenLookUpSelfGetRequestParameters): Keq<TokenLookUpSelfGetOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TokenLookUpSelfGetResponseBodies[STATUS]>('/auth/token/lookup-self')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenLookUpSelfUpdate<STATUS extends keyof TokenLookUpSelfUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenLookUpSelfUpdateRequestParameters): Keq<TokenLookUpSelfUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenLookUpSelfUpdateResponseBodies[STATUS]>('/auth/token/lookup-self')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenRenew<STATUS extends keyof TokenRenewResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRenewRequestParameters): Keq<TokenRenewOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRenewResponseBodies[STATUS]>('/auth/token/renew')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'increment' in args) req.send({ increment: args['increment'] })
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenRenewAccessor<STATUS extends keyof TokenRenewAccessorResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRenewAccessorRequestParameters): Keq<TokenRenewAccessorOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRenewAccessorResponseBodies[STATUS]>('/auth/token/renew-accessor')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'accessor' in args) req.send({ accessor: args['accessor'] })
    if (args && 'increment' in args) req.send({ increment: args['increment'] })
    /* @anchor:body:end */

    return req
  }


  tokenRenewSelf<STATUS extends keyof TokenRenewSelfResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRenewSelfRequestParameters): Keq<TokenRenewSelfOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRenewSelfResponseBodies[STATUS]>('/auth/token/renew-self')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'increment' in args) req.send({ increment: args['increment'] })
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenRevoke<STATUS extends keyof TokenRevokeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRevokeRequestParameters): Keq<TokenRevokeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRevokeResponseBodies[STATUS]>('/auth/token/revoke')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenRevokeAccessor<STATUS extends keyof TokenRevokeAccessorResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRevokeAccessorRequestParameters): Keq<TokenRevokeAccessorOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRevokeAccessorResponseBodies[STATUS]>('/auth/token/revoke-accessor')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'accessor' in args) req.send({ accessor: args['accessor'] })
    /* @anchor:body:end */

    return req
  }


  tokenRevokeOrphan<STATUS extends keyof TokenRevokeOrphanResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenRevokeOrphanRequestParameters): Keq<TokenRevokeOrphanOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRevokeOrphanResponseBodies[STATUS]>('/auth/token/revoke-orphan')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  tokenRevokeSelf<STATUS extends keyof TokenRevokeSelfResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenRevokeSelfRequestParameters): Keq<TokenRevokeSelfOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenRevokeSelfResponseBodies[STATUS]>('/auth/token/revoke-self')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenListRoles<STATUS extends keyof TokenListRolesResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenListRolesRequestParameters): Keq<TokenListRolesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TokenListRolesResponseBodies[STATUS]>('/auth/token/roles')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenReadRole<STATUS extends keyof TokenReadRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenReadRoleRequestParameters): Keq<TokenReadRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TokenReadRoleResponseBodies[STATUS]>('/auth/token/roles/{role_name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenWriteRole<STATUS extends keyof TokenWriteRoleResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TokenWriteRoleRequestParameters): Keq<TokenWriteRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenWriteRoleResponseBodies[STATUS]>('/auth/token/roles/{role_name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allowed_entity_aliases' in args) req.send({ allowed_entity_aliases: args['allowed_entity_aliases'] })
    if (args && 'allowed_policies' in args) req.send({ allowed_policies: args['allowed_policies'] })
    if (args && 'allowed_policies_glob' in args) req.send({ allowed_policies_glob: args['allowed_policies_glob'] })
    if (args && 'bound_cidrs' in args) req.send({ bound_cidrs: args['bound_cidrs'] })
    if (args && 'disallowed_policies' in args) req.send({ disallowed_policies: args['disallowed_policies'] })
    if (args && 'disallowed_policies_glob' in args) req.send({ disallowed_policies_glob: args['disallowed_policies_glob'] })
    if (args && 'explicit_max_ttl' in args) req.send({ explicit_max_ttl: args['explicit_max_ttl'] })
    if (args && 'orphan' in args) req.send({ orphan: args['orphan'] })
    if (args && 'path_suffix' in args) req.send({ path_suffix: args['path_suffix'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'renewable' in args) req.send({ renewable: args['renewable'] })
    if (args && 'token_bound_cidrs' in args) req.send({ token_bound_cidrs: args['token_bound_cidrs'] })
    if (args && 'token_explicit_max_ttl' in args) req.send({ token_explicit_max_ttl: args['token_explicit_max_ttl'] })
    if (args && 'token_no_default_policy' in args) req.send({ token_no_default_policy: args['token_no_default_policy'] })
    if (args && 'token_num_uses' in args) req.send({ token_num_uses: args['token_num_uses'] })
    if (args && 'token_period' in args) req.send({ token_period: args['token_period'] })
    if (args && 'token_type' in args) req.send({ token_type: args['token_type'] })
    /* @anchor:body:end */

    return req
  }


  tokenDeleteRole<STATUS extends keyof TokenDeleteRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenDeleteRoleRequestParameters): Keq<TokenDeleteRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<TokenDeleteRoleResponseBodies[STATUS]>('/auth/token/roles/{role_name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  tokenTidy<STATUS extends keyof TokenTidyResponseBodies, CONTENT_TYPE extends never = never>(args?: TokenTidyRequestParameters): Keq<TokenTidyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TokenTidyResponseBodies[STATUS]>('/auth/token/tidy')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  userpassLogin<STATUS extends keyof UserpassLoginResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UserpassLoginRequestParameters): Keq<UserpassLoginOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UserpassLoginResponseBodies[STATUS]>('/auth/userpass/login/{username}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'password' in args) req.send({ password: args['password'] })
    /* @anchor:body:end */

    return req
  }


  userpassListUsers<STATUS extends keyof UserpassListUsersResponseBodies, CONTENT_TYPE extends never = never>(args?: UserpassListUsersRequestParameters): Keq<UserpassListUsersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<UserpassListUsersResponseBodies[STATUS]>('/auth/userpass/users')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  userpassReadUser<STATUS extends keyof UserpassReadUserResponseBodies, CONTENT_TYPE extends never = never>(args?: UserpassReadUserRequestParameters): Keq<UserpassReadUserOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<UserpassReadUserResponseBodies[STATUS]>('/auth/userpass/users/{username}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  userpassWriteUser<STATUS extends keyof UserpassWriteUserResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UserpassWriteUserRequestParameters): Keq<UserpassWriteUserOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UserpassWriteUserResponseBodies[STATUS]>('/auth/userpass/users/{username}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bound_cidrs' in args) req.send({ bound_cidrs: args['bound_cidrs'] })
    if (args && 'max_ttl' in args) req.send({ max_ttl: args['max_ttl'] })
    if (args && 'password' in args) req.send({ password: args['password'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'token_bound_cidrs' in args) req.send({ token_bound_cidrs: args['token_bound_cidrs'] })
    if (args && 'token_explicit_max_ttl' in args) req.send({ token_explicit_max_ttl: args['token_explicit_max_ttl'] })
    if (args && 'token_max_ttl' in args) req.send({ token_max_ttl: args['token_max_ttl'] })
    if (args && 'token_no_default_policy' in args) req.send({ token_no_default_policy: args['token_no_default_policy'] })
    if (args && 'token_num_uses' in args) req.send({ token_num_uses: args['token_num_uses'] })
    if (args && 'token_period' in args) req.send({ token_period: args['token_period'] })
    if (args && 'token_policies' in args) req.send({ token_policies: args['token_policies'] })
    if (args && 'token_strictly_bind_ip' in args) req.send({ token_strictly_bind_ip: args['token_strictly_bind_ip'] })
    if (args && 'token_ttl' in args) req.send({ token_ttl: args['token_ttl'] })
    if (args && 'token_type' in args) req.send({ token_type: args['token_type'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    /* @anchor:body:end */

    return req
  }


  userpassDeleteUser<STATUS extends keyof UserpassDeleteUserResponseBodies, CONTENT_TYPE extends never = never>(args?: UserpassDeleteUserRequestParameters): Keq<UserpassDeleteUserOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<UserpassDeleteUserResponseBodies[STATUS]>('/auth/userpass/users/{username}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  userpassResetPassword<STATUS extends keyof UserpassResetPasswordResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UserpassResetPasswordRequestParameters): Keq<UserpassResetPasswordOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UserpassResetPasswordResponseBodies[STATUS]>('/auth/userpass/users/{username}/password')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'password' in args) req.send({ password: args['password'] })
    /* @anchor:body:end */

    return req
  }


  userpassUpdatePolicies<STATUS extends keyof UserpassUpdatePoliciesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UserpassUpdatePoliciesRequestParameters): Keq<UserpassUpdatePoliciesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UserpassUpdatePoliciesResponseBodies[STATUS]>('/auth/userpass/users/{username}/policies')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'token_policies' in args) req.send({ token_policies: args['token_policies'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Retrieve the secret at the specified location.
   *
   */
  cubbyholeRead<STATUS extends keyof CubbyholeReadResponseBodies, CONTENT_TYPE extends never = never>(args?: CubbyholeReadRequestParameters): Keq<CubbyholeReadOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<CubbyholeReadResponseBodies[STATUS]>('/cubbyhole/{path}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Store a secret at the specified location.
   *
   */
  cubbyholeWrite<STATUS extends keyof CubbyholeWriteResponseBodies, CONTENT_TYPE extends never = never>(args?: CubbyholeWriteRequestParameters): Keq<CubbyholeWriteOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<CubbyholeWriteResponseBodies[STATUS]>('/cubbyhole/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Deletes the secret at the specified location.
   *
   */
  cubbyholeDelete<STATUS extends keyof CubbyholeDeleteResponseBodies, CONTENT_TYPE extends never = never>(args?: CubbyholeDeleteRequestParameters): Keq<CubbyholeDeleteOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<CubbyholeDeleteResponseBodies[STATUS]>('/cubbyhole/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  aliasCreate<STATUS extends keyof AliasCreateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AliasCreateRequestParameters): Keq<AliasCreateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AliasCreateResponseBodies[STATUS]>('/identity/alias')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  aliasListById<STATUS extends keyof AliasListByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: AliasListByIdRequestParameters): Keq<AliasListByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AliasListByIdResponseBodies[STATUS]>('/identity/alias/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  aliasReadById<STATUS extends keyof AliasReadByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: AliasReadByIdRequestParameters): Keq<AliasReadByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AliasReadByIdResponseBodies[STATUS]>('/identity/alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  aliasUpdateById<STATUS extends keyof AliasUpdateByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AliasUpdateByIdRequestParameters): Keq<AliasUpdateByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AliasUpdateByIdResponseBodies[STATUS]>('/identity/alias/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  aliasDeleteById<STATUS extends keyof AliasDeleteByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: AliasDeleteByIdRequestParameters): Keq<AliasDeleteByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<AliasDeleteByIdResponseBodies[STATUS]>('/identity/alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityCreate<STATUS extends keyof EntityCreateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityCreateRequestParameters): Keq<EntityCreateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityCreateResponseBodies[STATUS]>('/identity/entity')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'disabled' in args) req.send({ disabled: args['disabled'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    /* @anchor:body:end */

    return req
  }


  entityCreateAlias<STATUS extends keyof EntityCreateAliasResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityCreateAliasRequestParameters): Keq<EntityCreateAliasOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityCreateAliasResponseBodies[STATUS]>('/identity/entity-alias')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'custom_metadata' in args) req.send({ custom_metadata: args['custom_metadata'] })
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  entityListAliasesById<STATUS extends keyof EntityListAliasesByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityListAliasesByIdRequestParameters): Keq<EntityListAliasesByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityListAliasesByIdResponseBodies[STATUS]>('/identity/entity-alias/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityReadAliasById<STATUS extends keyof EntityReadAliasByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityReadAliasByIdRequestParameters): Keq<EntityReadAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityReadAliasByIdResponseBodies[STATUS]>('/identity/entity-alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityUpdateAliasById<STATUS extends keyof EntityUpdateAliasByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityUpdateAliasByIdRequestParameters): Keq<EntityUpdateAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityUpdateAliasByIdResponseBodies[STATUS]>('/identity/entity-alias/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'custom_metadata' in args) req.send({ custom_metadata: args['custom_metadata'] })
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  entityDeleteAliasById<STATUS extends keyof EntityDeleteAliasByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityDeleteAliasByIdRequestParameters): Keq<EntityDeleteAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<EntityDeleteAliasByIdResponseBodies[STATUS]>('/identity/entity-alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityBatchDelete<STATUS extends keyof EntityBatchDeleteResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityBatchDeleteRequestParameters): Keq<EntityBatchDeleteOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityBatchDeleteResponseBodies[STATUS]>('/identity/entity/batch-delete')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_ids' in args) req.send({ entity_ids: args['entity_ids'] })
    /* @anchor:body:end */

    return req
  }


  entityListById<STATUS extends keyof EntityListByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityListByIdRequestParameters): Keq<EntityListByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityListByIdResponseBodies[STATUS]>('/identity/entity/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityReadById<STATUS extends keyof EntityReadByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityReadByIdRequestParameters): Keq<EntityReadByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityReadByIdResponseBodies[STATUS]>('/identity/entity/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityUpdateById<STATUS extends keyof EntityUpdateByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityUpdateByIdRequestParameters): Keq<EntityUpdateByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityUpdateByIdResponseBodies[STATUS]>('/identity/entity/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'disabled' in args) req.send({ disabled: args['disabled'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    /* @anchor:body:end */

    return req
  }


  entityDeleteById<STATUS extends keyof EntityDeleteByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityDeleteByIdRequestParameters): Keq<EntityDeleteByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<EntityDeleteByIdResponseBodies[STATUS]>('/identity/entity/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityMerge<STATUS extends keyof EntityMergeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityMergeRequestParameters): Keq<EntityMergeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityMergeResponseBodies[STATUS]>('/identity/entity/merge')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'conflicting_alias_ids_to_keep' in args) req.send({ conflicting_alias_ids_to_keep: args['conflicting_alias_ids_to_keep'] })
    if (args && 'force' in args) req.send({ force: args['force'] })
    if (args && 'from_entity_ids' in args) req.send({ from_entity_ids: args['from_entity_ids'] })
    if (args && 'to_entity_id' in args) req.send({ to_entity_id: args['to_entity_id'] })
    /* @anchor:body:end */

    return req
  }


  entityListByName<STATUS extends keyof EntityListByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityListByNameRequestParameters): Keq<EntityListByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityListByNameResponseBodies[STATUS]>('/identity/entity/name')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityReadByName<STATUS extends keyof EntityReadByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityReadByNameRequestParameters): Keq<EntityReadByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EntityReadByNameResponseBodies[STATUS]>('/identity/entity/name/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityUpdateByName<STATUS extends keyof EntityUpdateByNameResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityUpdateByNameRequestParameters): Keq<EntityUpdateByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityUpdateByNameResponseBodies[STATUS]>('/identity/entity/name/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'disabled' in args) req.send({ disabled: args['disabled'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    /* @anchor:body:end */

    return req
  }


  entityDeleteByName<STATUS extends keyof EntityDeleteByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: EntityDeleteByNameRequestParameters): Keq<EntityDeleteByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<EntityDeleteByNameResponseBodies[STATUS]>('/identity/entity/name/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupCreate<STATUS extends keyof GroupCreateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupCreateRequestParameters): Keq<GroupCreateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupCreateResponseBodies[STATUS]>('/identity/group')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'member_entity_ids' in args) req.send({ member_entity_ids: args['member_entity_ids'] })
    if (args && 'member_group_ids' in args) req.send({ member_group_ids: args['member_group_ids'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  groupCreateAlias<STATUS extends keyof GroupCreateAliasResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupCreateAliasRequestParameters): Keq<GroupCreateAliasOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupCreateAliasResponseBodies[STATUS]>('/identity/group-alias')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  groupListAliasesById<STATUS extends keyof GroupListAliasesByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupListAliasesByIdRequestParameters): Keq<GroupListAliasesByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupListAliasesByIdResponseBodies[STATUS]>('/identity/group-alias/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupReadAliasById<STATUS extends keyof GroupReadAliasByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupReadAliasByIdRequestParameters): Keq<GroupReadAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupReadAliasByIdResponseBodies[STATUS]>('/identity/group-alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupUpdateAliasById<STATUS extends keyof GroupUpdateAliasByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupUpdateAliasByIdRequestParameters): Keq<GroupUpdateAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupUpdateAliasByIdResponseBodies[STATUS]>('/identity/group-alias/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'canonical_id' in args) req.send({ canonical_id: args['canonical_id'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  groupDeleteAliasById<STATUS extends keyof GroupDeleteAliasByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupDeleteAliasByIdRequestParameters): Keq<GroupDeleteAliasByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<GroupDeleteAliasByIdResponseBodies[STATUS]>('/identity/group-alias/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupListById<STATUS extends keyof GroupListByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupListByIdRequestParameters): Keq<GroupListByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupListByIdResponseBodies[STATUS]>('/identity/group/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupReadById<STATUS extends keyof GroupReadByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupReadByIdRequestParameters): Keq<GroupReadByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupReadByIdResponseBodies[STATUS]>('/identity/group/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupUpdateById<STATUS extends keyof GroupUpdateByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupUpdateByIdRequestParameters): Keq<GroupUpdateByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupUpdateByIdResponseBodies[STATUS]>('/identity/group/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'member_entity_ids' in args) req.send({ member_entity_ids: args['member_entity_ids'] })
    if (args && 'member_group_ids' in args) req.send({ member_group_ids: args['member_group_ids'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  groupDeleteById<STATUS extends keyof GroupDeleteByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupDeleteByIdRequestParameters): Keq<GroupDeleteByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<GroupDeleteByIdResponseBodies[STATUS]>('/identity/group/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupListByName<STATUS extends keyof GroupListByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupListByNameRequestParameters): Keq<GroupListByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupListByNameResponseBodies[STATUS]>('/identity/group/name')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupReadByName<STATUS extends keyof GroupReadByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupReadByNameRequestParameters): Keq<GroupReadByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<GroupReadByNameResponseBodies[STATUS]>('/identity/group/name/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  groupUpdateByName<STATUS extends keyof GroupUpdateByNameResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupUpdateByNameRequestParameters): Keq<GroupUpdateByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupUpdateByNameResponseBodies[STATUS]>('/identity/group/name/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'member_entity_ids' in args) req.send({ member_entity_ids: args['member_entity_ids'] })
    if (args && 'member_group_ids' in args) req.send({ member_group_ids: args['member_group_ids'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'policies' in args) req.send({ policies: args['policies'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  groupDeleteByName<STATUS extends keyof GroupDeleteByNameResponseBodies, CONTENT_TYPE extends never = never>(args?: GroupDeleteByNameRequestParameters): Keq<GroupDeleteByNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<GroupDeleteByNameResponseBodies[STATUS]>('/identity/group/name/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  entityLookUp<STATUS extends keyof EntityLookUpResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EntityLookUpRequestParameters): Keq<EntityLookUpOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EntityLookUpResponseBodies[STATUS]>('/identity/lookup/entity')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'alias_id' in args) req.send({ alias_id: args['alias_id'] })
    if (args && 'alias_mount_accessor' in args) req.send({ alias_mount_accessor: args['alias_mount_accessor'] })
    if (args && 'alias_name' in args) req.send({ alias_name: args['alias_name'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  groupLookUp<STATUS extends keyof GroupLookUpResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GroupLookUpRequestParameters): Keq<GroupLookUpOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GroupLookUpResponseBodies[STATUS]>('/identity/lookup/group')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'alias_id' in args) req.send({ alias_id: args['alias_id'] })
    if (args && 'alias_mount_accessor' in args) req.send({ alias_mount_accessor: args['alias_mount_accessor'] })
    if (args && 'alias_name' in args) req.send({ alias_name: args['alias_name'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * List login enforcements
   *
   */
  mfaListLoginEnforcements<STATUS extends keyof MfaListLoginEnforcementsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListLoginEnforcementsRequestParameters): Keq<MfaListLoginEnforcementsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListLoginEnforcementsResponseBodies[STATUS]>('/identity/mfa/login-enforcement')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current login enforcement
   *
   */
  mfaReadLoginEnforcement<STATUS extends keyof MfaReadLoginEnforcementResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadLoginEnforcementRequestParameters): Keq<MfaReadLoginEnforcementOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadLoginEnforcementResponseBodies[STATUS]>('/identity/mfa/login-enforcement/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Create or update a login enforcement
   *
   */
  mfaWriteLoginEnforcement<STATUS extends keyof MfaWriteLoginEnforcementResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaWriteLoginEnforcementRequestParameters): Keq<MfaWriteLoginEnforcementOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaWriteLoginEnforcementResponseBodies[STATUS]>('/identity/mfa/login-enforcement/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'auth_method_accessors' in args) req.send({ auth_method_accessors: args['auth_method_accessors'] })
    if (args && 'auth_method_types' in args) req.send({ auth_method_types: args['auth_method_types'] })
    if (args && 'identity_entity_ids' in args) req.send({ identity_entity_ids: args['identity_entity_ids'] })
    if (args && 'identity_group_ids' in args) req.send({ identity_group_ids: args['identity_group_ids'] })
    if (args && 'mfa_method_ids' in args) req.send({ mfa_method_ids: args['mfa_method_ids'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a login enforcement
   *
   */
  mfaDeleteLoginEnforcement<STATUS extends keyof MfaDeleteLoginEnforcementResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaDeleteLoginEnforcementRequestParameters): Keq<MfaDeleteLoginEnforcementOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MfaDeleteLoginEnforcementResponseBodies[STATUS]>('/identity/mfa/login-enforcement/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List MFA method configurations for all MFA methods
   *
   */
  mfaListMethods<STATUS extends keyof MfaListMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListMethodsRequestParameters): Keq<MfaListMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListMethodsResponseBodies[STATUS]>('/identity/mfa/method')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List MFA method configurations for the given MFA method
   *
   */
  mfaListDuoMethods<STATUS extends keyof MfaListDuoMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListDuoMethodsRequestParameters): Keq<MfaListDuoMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListDuoMethodsResponseBodies[STATUS]>('/identity/mfa/method/duo')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current configuration for the given MFA method
   *
   */
  mfaReadDuoMethodConfiguration<STATUS extends keyof MfaReadDuoMethodConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadDuoMethodConfigurationRequestParameters): Keq<MfaReadDuoMethodConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadDuoMethodConfigurationResponseBodies[STATUS]>('/identity/mfa/method/duo/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create a configuration for the given MFA method
   *
   */
  mfaConfigureDuoMethod<STATUS extends keyof MfaConfigureDuoMethodResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaConfigureDuoMethodRequestParameters): Keq<MfaConfigureDuoMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaConfigureDuoMethodResponseBodies[STATUS]>('/identity/mfa/method/duo/{method_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'api_hostname' in args) req.send({ api_hostname: args['api_hostname'] })
    if (args && 'integration_key' in args) req.send({ integration_key: args['integration_key'] })
    if (args && 'method_name' in args) req.send({ method_name: args['method_name'] })
    if (args && 'push_info' in args) req.send({ push_info: args['push_info'] })
    if (args && 'secret_key' in args) req.send({ secret_key: args['secret_key'] })
    if (args && 'use_passcode' in args) req.send({ use_passcode: args['use_passcode'] })
    if (args && 'username_format' in args) req.send({ username_format: args['username_format'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a configuration for the given MFA method
   *
   */
  mfaDeleteDuoMethod<STATUS extends keyof MfaDeleteDuoMethodResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaDeleteDuoMethodRequestParameters): Keq<MfaDeleteDuoMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MfaDeleteDuoMethodResponseBodies[STATUS]>('/identity/mfa/method/duo/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List MFA method configurations for the given MFA method
   *
   */
  mfaListOktaMethods<STATUS extends keyof MfaListOktaMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListOktaMethodsRequestParameters): Keq<MfaListOktaMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListOktaMethodsResponseBodies[STATUS]>('/identity/mfa/method/okta')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current configuration for the given MFA method
   *
   */
  mfaReadOktaMethodConfiguration<STATUS extends keyof MfaReadOktaMethodConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadOktaMethodConfigurationRequestParameters): Keq<MfaReadOktaMethodConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadOktaMethodConfigurationResponseBodies[STATUS]>('/identity/mfa/method/okta/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create a configuration for the given MFA method
   *
   */
  mfaConfigureOktaMethod<STATUS extends keyof MfaConfigureOktaMethodResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaConfigureOktaMethodRequestParameters): Keq<MfaConfigureOktaMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaConfigureOktaMethodResponseBodies[STATUS]>('/identity/mfa/method/okta/{method_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'api_token' in args) req.send({ api_token: args['api_token'] })
    if (args && 'base_url' in args) req.send({ base_url: args['base_url'] })
    if (args && 'method_name' in args) req.send({ method_name: args['method_name'] })
    if (args && 'org_name' in args) req.send({ org_name: args['org_name'] })
    if (args && 'primary_email' in args) req.send({ primary_email: args['primary_email'] })
    if (args && 'production' in args) req.send({ production: args['production'] })
    if (args && 'username_format' in args) req.send({ username_format: args['username_format'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a configuration for the given MFA method
   *
   */
  mfaDeleteOktaMethod<STATUS extends keyof MfaDeleteOktaMethodResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaDeleteOktaMethodRequestParameters): Keq<MfaDeleteOktaMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MfaDeleteOktaMethodResponseBodies[STATUS]>('/identity/mfa/method/okta/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List MFA method configurations for the given MFA method
   *
   */
  mfaListPingIdMethods<STATUS extends keyof MfaListPingIdMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListPingIdMethodsRequestParameters): Keq<MfaListPingIdMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListPingIdMethodsResponseBodies[STATUS]>('/identity/mfa/method/pingid')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current configuration for the given MFA method
   *
   */
  mfaReadPingIdMethodConfiguration<STATUS extends keyof MfaReadPingIdMethodConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadPingIdMethodConfigurationRequestParameters): Keq<MfaReadPingIdMethodConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadPingIdMethodConfigurationResponseBodies[STATUS]>('/identity/mfa/method/pingid/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create a configuration for the given MFA method
   *
   */
  mfaConfigurePingIdMethod<STATUS extends keyof MfaConfigurePingIdMethodResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaConfigurePingIdMethodRequestParameters): Keq<MfaConfigurePingIdMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaConfigurePingIdMethodResponseBodies[STATUS]>('/identity/mfa/method/pingid/{method_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'method_name' in args) req.send({ method_name: args['method_name'] })
    if (args && 'settings_file_base64' in args) req.send({ settings_file_base64: args['settings_file_base64'] })
    if (args && 'username_format' in args) req.send({ username_format: args['username_format'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a configuration for the given MFA method
   *
   */
  mfaDeletePingIdMethod<STATUS extends keyof MfaDeletePingIdMethodResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaDeletePingIdMethodRequestParameters): Keq<MfaDeletePingIdMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MfaDeletePingIdMethodResponseBodies[STATUS]>('/identity/mfa/method/pingid/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List MFA method configurations for the given MFA method
   *
   */
  mfaListTotpMethods<STATUS extends keyof MfaListTotpMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaListTotpMethodsRequestParameters): Keq<MfaListTotpMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaListTotpMethodsResponseBodies[STATUS]>('/identity/mfa/method/totp')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Destroys a TOTP secret for the given MFA method ID on the given entity
   *
   */
  mfaAdminDestroyTotpSecret<STATUS extends keyof MfaAdminDestroyTotpSecretResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaAdminDestroyTotpSecretRequestParameters): Keq<MfaAdminDestroyTotpSecretOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaAdminDestroyTotpSecretResponseBodies[STATUS]>('/identity/mfa/method/totp/admin-destroy')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'method_id' in args) req.send({ method_id: args['method_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create TOTP secret for the given method ID on the given entity.
   *
   */
  mfaAdminGenerateTotpSecret<STATUS extends keyof MfaAdminGenerateTotpSecretResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaAdminGenerateTotpSecretRequestParameters): Keq<MfaAdminGenerateTotpSecretOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaAdminGenerateTotpSecretResponseBodies[STATUS]>('/identity/mfa/method/totp/admin-generate')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'method_id' in args) req.send({ method_id: args['method_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create TOTP secret for the given method ID on the given entity.
   *
   */
  mfaGenerateTotpSecret<STATUS extends keyof MfaGenerateTotpSecretResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaGenerateTotpSecretRequestParameters): Keq<MfaGenerateTotpSecretOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaGenerateTotpSecretResponseBodies[STATUS]>('/identity/mfa/method/totp/generate')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'method_id' in args) req.send({ method_id: args['method_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current configuration for the given MFA method
   *
   */
  mfaReadTotpMethodConfiguration<STATUS extends keyof MfaReadTotpMethodConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadTotpMethodConfigurationRequestParameters): Keq<MfaReadTotpMethodConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadTotpMethodConfigurationResponseBodies[STATUS]>('/identity/mfa/method/totp/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Update or create a configuration for the given MFA method
   *
   */
  mfaConfigureTotpMethod<STATUS extends keyof MfaConfigureTotpMethodResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaConfigureTotpMethodRequestParameters): Keq<MfaConfigureTotpMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaConfigureTotpMethodResponseBodies[STATUS]>('/identity/mfa/method/totp/{method_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'digits' in args) req.send({ digits: args['digits'] })
    if (args && 'issuer' in args) req.send({ issuer: args['issuer'] })
    if (args && 'key_size' in args) req.send({ key_size: args['key_size'] })
    if (args && 'max_validation_attempts' in args) req.send({ max_validation_attempts: args['max_validation_attempts'] })
    if (args && 'method_name' in args) req.send({ method_name: args['method_name'] })
    if (args && 'period' in args) req.send({ period: args['period'] })
    if (args && 'qr_size' in args) req.send({ qr_size: args['qr_size'] })
    if (args && 'skew' in args) req.send({ skew: args['skew'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a configuration for the given MFA method
   *
   */
  mfaDeleteTotpMethod<STATUS extends keyof MfaDeleteTotpMethodResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaDeleteTotpMethodRequestParameters): Keq<MfaDeleteTotpMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MfaDeleteTotpMethodResponseBodies[STATUS]>('/identity/mfa/method/totp/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the current configuration for the given ID regardless of the MFA method type
   *
   */
  mfaReadMethodConfiguration<STATUS extends keyof MfaReadMethodConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MfaReadMethodConfigurationRequestParameters): Keq<MfaReadMethodConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MfaReadMethodConfigurationResponseBodies[STATUS]>('/identity/mfa/method/{method_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadPublicKeys<STATUS extends keyof OidcReadPublicKeysResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadPublicKeysRequestParameters): Keq<OidcReadPublicKeysOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadPublicKeysResponseBodies[STATUS]>('/identity/oidc/.well-known/keys')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadOpenIdConfiguration<STATUS extends keyof OidcReadOpenIdConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadOpenIdConfigurationRequestParameters): Keq<OidcReadOpenIdConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadOpenIdConfigurationResponseBodies[STATUS]>('/identity/oidc/.well-known/openid-configuration')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcListAssignments<STATUS extends keyof OidcListAssignmentsResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListAssignmentsRequestParameters): Keq<OidcListAssignmentsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListAssignmentsResponseBodies[STATUS]>('/identity/oidc/assignment')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadAssignment<STATUS extends keyof OidcReadAssignmentResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadAssignmentRequestParameters): Keq<OidcReadAssignmentOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadAssignmentResponseBodies[STATUS]>('/identity/oidc/assignment/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteAssignment<STATUS extends keyof OidcWriteAssignmentResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteAssignmentRequestParameters): Keq<OidcWriteAssignmentOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteAssignmentResponseBodies[STATUS]>('/identity/oidc/assignment/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_ids' in args) req.send({ entity_ids: args['entity_ids'] })
    if (args && 'group_ids' in args) req.send({ group_ids: args['group_ids'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteAssignment<STATUS extends keyof OidcDeleteAssignmentResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteAssignmentRequestParameters): Keq<OidcDeleteAssignmentOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteAssignmentResponseBodies[STATUS]>('/identity/oidc/assignment/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcListClients<STATUS extends keyof OidcListClientsResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListClientsRequestParameters): Keq<OidcListClientsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListClientsResponseBodies[STATUS]>('/identity/oidc/client')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadClient<STATUS extends keyof OidcReadClientResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadClientRequestParameters): Keq<OidcReadClientOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadClientResponseBodies[STATUS]>('/identity/oidc/client/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteClient<STATUS extends keyof OidcWriteClientResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteClientRequestParameters): Keq<OidcWriteClientOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteClientResponseBodies[STATUS]>('/identity/oidc/client/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'access_token_ttl' in args) req.send({ access_token_ttl: args['access_token_ttl'] })
    if (args && 'assignments' in args) req.send({ assignments: args['assignments'] })
    if (args && 'authorization_code' in args) req.send({ authorization_code: args['authorization_code'] })
    if (args && 'client_credentials' in args) req.send({ client_credentials: args['client_credentials'] })
    if (args && 'client_type' in args) req.send({ client_type: args['client_type'] })
    if (args && 'id_token_ttl' in args) req.send({ id_token_ttl: args['id_token_ttl'] })
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'redirect_uris' in args) req.send({ redirect_uris: args['redirect_uris'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteClient<STATUS extends keyof OidcDeleteClientResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteClientRequestParameters): Keq<OidcDeleteClientOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteClientResponseBodies[STATUS]>('/identity/oidc/client/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadConfiguration<STATUS extends keyof OidcReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadConfigurationRequestParameters): Keq<OidcReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadConfigurationResponseBodies[STATUS]>('/identity/oidc/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcConfigure<STATUS extends keyof OidcConfigureResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcConfigureRequestParameters): Keq<OidcConfigureOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcConfigureResponseBodies[STATUS]>('/identity/oidc/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'issuer' in args) req.send({ issuer: args['issuer'] })
    /* @anchor:body:end */

    return req
  }


  oidcIntrospect<STATUS extends keyof OidcIntrospectResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcIntrospectRequestParameters): Keq<OidcIntrospectOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcIntrospectResponseBodies[STATUS]>('/identity/oidc/introspect')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'client_id' in args) req.send({ client_id: args['client_id'] })
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  oidcListKeys<STATUS extends keyof OidcListKeysResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListKeysRequestParameters): Keq<OidcListKeysOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListKeysResponseBodies[STATUS]>('/identity/oidc/key')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadKey<STATUS extends keyof OidcReadKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadKeyRequestParameters): Keq<OidcReadKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadKeyResponseBodies[STATUS]>('/identity/oidc/key/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteKey<STATUS extends keyof OidcWriteKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteKeyRequestParameters): Keq<OidcWriteKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteKeyResponseBodies[STATUS]>('/identity/oidc/key/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'allowed_client_ids' in args) req.send({ allowed_client_ids: args['allowed_client_ids'] })
    if (args && 'rotation_period' in args) req.send({ rotation_period: args['rotation_period'] })
    if (args && 'verification_ttl' in args) req.send({ verification_ttl: args['verification_ttl'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteKey<STATUS extends keyof OidcDeleteKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteKeyRequestParameters): Keq<OidcDeleteKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteKeyResponseBodies[STATUS]>('/identity/oidc/key/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcRotateKey<STATUS extends keyof OidcRotateKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcRotateKeyRequestParameters): Keq<OidcRotateKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcRotateKeyResponseBodies[STATUS]>('/identity/oidc/key/{name}/rotate')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'verification_ttl' in args) req.send({ verification_ttl: args['verification_ttl'] })
    /* @anchor:body:end */

    return req
  }


  oidcListProviders<STATUS extends keyof OidcListProvidersResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListProvidersRequestParameters): Keq<OidcListProvidersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListProvidersResponseBodies[STATUS]>('/identity/oidc/provider')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadProvider<STATUS extends keyof OidcReadProviderResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadProviderRequestParameters): Keq<OidcReadProviderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadProviderResponseBodies[STATUS]>('/identity/oidc/provider/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteProvider<STATUS extends keyof OidcWriteProviderResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteProviderRequestParameters): Keq<OidcWriteProviderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteProviderResponseBodies[STATUS]>('/identity/oidc/provider/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allowed_client_ids' in args) req.send({ allowed_client_ids: args['allowed_client_ids'] })
    if (args && 'issuer' in args) req.send({ issuer: args['issuer'] })
    if (args && 'scopes_supported' in args) req.send({ scopes_supported: args['scopes_supported'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteProvider<STATUS extends keyof OidcDeleteProviderResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteProviderRequestParameters): Keq<OidcDeleteProviderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteProviderResponseBodies[STATUS]>('/identity/oidc/provider/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadProviderPublicKeys<STATUS extends keyof OidcReadProviderPublicKeysResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadProviderPublicKeysRequestParameters): Keq<OidcReadProviderPublicKeysOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadProviderPublicKeysResponseBodies[STATUS]>('/identity/oidc/provider/{name}/.well-known/keys')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadProviderOpenIdConfiguration<STATUS extends keyof OidcReadProviderOpenIdConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadProviderOpenIdConfigurationRequestParameters): Keq<OidcReadProviderOpenIdConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadProviderOpenIdConfigurationResponseBodies[STATUS]>('/identity/oidc/provider/{name}/.well-known/openid-configuration')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcProviderAuthorize<STATUS extends keyof OidcProviderAuthorizeResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcProviderAuthorizeRequestParameters): Keq<OidcProviderAuthorizeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcProviderAuthorizeResponseBodies[STATUS]>('/identity/oidc/provider/{name}/authorize')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcProviderAuthorizeWithParameters<STATUS extends keyof OidcProviderAuthorizeWithParametersResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcProviderAuthorizeWithParametersRequestParameters): Keq<OidcProviderAuthorizeWithParametersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcProviderAuthorizeWithParametersResponseBodies[STATUS]>('/identity/oidc/provider/{name}/authorize')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'client_id' in args) req.send({ client_id: args['client_id'] })
    if (args && 'code_challenge' in args) req.send({ code_challenge: args['code_challenge'] })
    if (args && 'code_challenge_method' in args) req.send({ code_challenge_method: args['code_challenge_method'] })
    if (args && 'max_age' in args) req.send({ max_age: args['max_age'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    if (args && 'redirect_uri' in args) req.send({ redirect_uri: args['redirect_uri'] })
    if (args && 'response_type' in args) req.send({ response_type: args['response_type'] })
    if (args && 'scope' in args) req.send({ scope: args['scope'] })
    if (args && 'state' in args) req.send({ state: args['state'] })
    /* @anchor:body:end */

    return req
  }


  oidcProviderToken<STATUS extends keyof OidcProviderTokenResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcProviderTokenRequestParameters): Keq<OidcProviderTokenOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcProviderTokenResponseBodies[STATUS]>('/identity/oidc/provider/{name}/token')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'client_id' in args) req.send({ client_id: args['client_id'] })
    if (args && 'client_secret' in args) req.send({ client_secret: args['client_secret'] })
    if (args && 'code' in args) req.send({ code: args['code'] })
    if (args && 'code_verifier' in args) req.send({ code_verifier: args['code_verifier'] })
    if (args && 'grant_type' in args) req.send({ grant_type: args['grant_type'] })
    if (args && 'redirect_uri' in args) req.send({ redirect_uri: args['redirect_uri'] })
    if (args && 'scope' in args) req.send({ scope: args['scope'] })
    /* @anchor:body:end */

    return req
  }


  oidcProviderUserInfo<STATUS extends keyof OidcProviderUserInfoResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcProviderUserInfoRequestParameters): Keq<OidcProviderUserInfoOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcProviderUserInfoResponseBodies[STATUS]>('/identity/oidc/provider/{name}/userinfo')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcListRoles<STATUS extends keyof OidcListRolesResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListRolesRequestParameters): Keq<OidcListRolesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListRolesResponseBodies[STATUS]>('/identity/oidc/role')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadRole<STATUS extends keyof OidcReadRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadRoleRequestParameters): Keq<OidcReadRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadRoleResponseBodies[STATUS]>('/identity/oidc/role/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteRole<STATUS extends keyof OidcWriteRoleResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteRoleRequestParameters): Keq<OidcWriteRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteRoleResponseBodies[STATUS]>('/identity/oidc/role/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'client_id' in args) req.send({ client_id: args['client_id'] })
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'template' in args) req.send({ template: args['template'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteRole<STATUS extends keyof OidcDeleteRoleResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteRoleRequestParameters): Keq<OidcDeleteRoleOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteRoleResponseBodies[STATUS]>('/identity/oidc/role/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcListScopes<STATUS extends keyof OidcListScopesResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcListScopesRequestParameters): Keq<OidcListScopesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcListScopesResponseBodies[STATUS]>('/identity/oidc/scope')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcReadScope<STATUS extends keyof OidcReadScopeResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcReadScopeRequestParameters): Keq<OidcReadScopeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcReadScopeResponseBodies[STATUS]>('/identity/oidc/scope/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcWriteScope<STATUS extends keyof OidcWriteScopeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: OidcWriteScopeRequestParameters): Keq<OidcWriteScopeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<OidcWriteScopeResponseBodies[STATUS]>('/identity/oidc/scope/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'template' in args) req.send({ template: args['template'] })
    /* @anchor:body:end */

    return req
  }


  oidcDeleteScope<STATUS extends keyof OidcDeleteScopeResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcDeleteScopeRequestParameters): Keq<OidcDeleteScopeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<OidcDeleteScopeResponseBodies[STATUS]>('/identity/oidc/scope/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  oidcGenerateToken<STATUS extends keyof OidcGenerateTokenResponseBodies, CONTENT_TYPE extends never = never>(args?: OidcGenerateTokenRequestParameters): Keq<OidcGenerateTokenOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<OidcGenerateTokenResponseBodies[STATUS]>('/identity/oidc/token/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  personaCreate<STATUS extends keyof PersonaCreateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PersonaCreateRequestParameters): Keq<PersonaCreateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PersonaCreateResponseBodies[STATUS]>('/identity/persona')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'id' in args) req.send({ id: args['id'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  personaListById<STATUS extends keyof PersonaListByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: PersonaListByIdRequestParameters): Keq<PersonaListByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PersonaListByIdResponseBodies[STATUS]>('/identity/persona/id')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  personaReadById<STATUS extends keyof PersonaReadByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: PersonaReadByIdRequestParameters): Keq<PersonaReadByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PersonaReadByIdResponseBodies[STATUS]>('/identity/persona/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  personaUpdateById<STATUS extends keyof PersonaUpdateByIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PersonaUpdateByIdRequestParameters): Keq<PersonaUpdateByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PersonaUpdateByIdResponseBodies[STATUS]>('/identity/persona/id/{id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'entity_id' in args) req.send({ entity_id: args['entity_id'] })
    if (args && 'metadata' in args) req.send({ metadata: args['metadata'] })
    if (args && 'mount_accessor' in args) req.send({ mount_accessor: args['mount_accessor'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  personaDeleteById<STATUS extends keyof PersonaDeleteByIdResponseBodies, CONTENT_TYPE extends never = never>(args?: PersonaDeleteByIdRequestParameters): Keq<PersonaDeleteByIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<PersonaDeleteByIdResponseBodies[STATUS]>('/identity/persona/id/{id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the backend level settings.
   *
   */
  kvReadConfig<STATUS extends keyof KvReadConfigResponseBodies, CONTENT_TYPE extends never = never>(args?: KvReadConfigRequestParameters): Keq<KvReadConfigOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KvReadConfigResponseBodies[STATUS]>('/kv/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Configure backend level settings that are applied to every key in the key-value store.
   *
   */
  kvWriteConfig<STATUS extends keyof KvWriteConfigResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteConfigRequestParameters): Keq<KvWriteConfigOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteConfigResponseBodies[STATUS]>('/kv/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'cas_required' in args) req.send({ cas_required: args['cas_required'] })
    if (args && 'delete_version_after' in args) req.send({ delete_version_after: args['delete_version_after'] })
    if (args && 'max_versions' in args) req.send({ max_versions: args['max_versions'] })
    if (args && 'metadata_cas_required' in args) req.send({ metadata_cas_required: args['metadata_cas_required'] })
    /* @anchor:body:end */

    return req
  }


  kvReadDataPath<STATUS extends keyof KvReadDataPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvReadDataPathRequestParameters): Keq<KvReadDataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KvReadDataPathResponseBodies[STATUS]>('/kv/data/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvWriteDataPath<STATUS extends keyof KvWriteDataPathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteDataPathRequestParameters): Keq<KvWriteDataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteDataPathResponseBodies[STATUS]>('/kv/data/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'data' in args) req.send({ data: args['data'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }


  kvDeleteDataPath<STATUS extends keyof KvDeleteDataPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvDeleteDataPathRequestParameters): Keq<KvDeleteDataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<KvDeleteDataPathResponseBodies[STATUS]>('/kv/data/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvWriteDeletePath<STATUS extends keyof KvWriteDeletePathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteDeletePathRequestParameters): Keq<KvWriteDeletePathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteDeletePathResponseBodies[STATUS]>('/kv/delete/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'versions' in args) req.send({ versions: args['versions'] })
    /* @anchor:body:end */

    return req
  }


  kvWriteDestroyPath<STATUS extends keyof KvWriteDestroyPathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteDestroyPathRequestParameters): Keq<KvWriteDestroyPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteDestroyPathResponseBodies[STATUS]>('/kv/destroy/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'versions' in args) req.send({ versions: args['versions'] })
    /* @anchor:body:end */

    return req
  }


  kvListDetailedMetadataPath<STATUS extends keyof KvListDetailedMetadataPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvListDetailedMetadataPathRequestParameters): Keq<KvListDetailedMetadataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KvListDetailedMetadataPathResponseBodies[STATUS]>('/kv/detailed-metadata/{path}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvReadMetadataPath<STATUS extends keyof KvReadMetadataPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvReadMetadataPathRequestParameters): Keq<KvReadMetadataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KvReadMetadataPathResponseBodies[STATUS]>('/kv/metadata/{path}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvWriteMetadataPath<STATUS extends keyof KvWriteMetadataPathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteMetadataPathRequestParameters): Keq<KvWriteMetadataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteMetadataPathResponseBodies[STATUS]>('/kv/metadata/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'after' in args) req.send({ after: args['after'] })
    if (args && 'cas_required' in args) req.send({ cas_required: args['cas_required'] })
    if (args && 'custom_metadata' in args) req.send({ custom_metadata: args['custom_metadata'] })
    if (args && 'delete_version_after' in args) req.send({ delete_version_after: args['delete_version_after'] })
    if (args && 'limit' in args) req.send({ limit: args['limit'] })
    if (args && 'max_versions' in args) req.send({ max_versions: args['max_versions'] })
    if (args && 'metadata_cas' in args) req.send({ metadata_cas: args['metadata_cas'] })
    if (args && 'metadata_cas_required' in args) req.send({ metadata_cas_required: args['metadata_cas_required'] })
    /* @anchor:body:end */

    return req
  }


  kvDeleteMetadataPath<STATUS extends keyof KvDeleteMetadataPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvDeleteMetadataPathRequestParameters): Keq<KvDeleteMetadataPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<KvDeleteMetadataPathResponseBodies[STATUS]>('/kv/metadata/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvReadSubkeysPath<STATUS extends keyof KvReadSubkeysPathResponseBodies, CONTENT_TYPE extends never = never>(args?: KvReadSubkeysPathRequestParameters): Keq<KvReadSubkeysPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<KvReadSubkeysPathResponseBodies[STATUS]>('/kv/subkeys/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  kvWriteUndeletePath<STATUS extends keyof KvWriteUndeletePathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: KvWriteUndeletePathRequestParameters): Keq<KvWriteUndeletePathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<KvWriteUndeletePathResponseBodies[STATUS]>('/kv/undelete/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'versions' in args) req.send({ versions: args['versions'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * List the enabled audit devices.
   *
   */
  auditingListEnabledDevices<STATUS extends keyof AuditingListEnabledDevicesResponseBodies, CONTENT_TYPE extends never = never>(args?: AuditingListEnabledDevicesRequestParameters): Keq<AuditingListEnabledDevicesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuditingListEnabledDevicesResponseBodies[STATUS]>('/sys/audit')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  auditingCalculateHash<STATUS extends keyof AuditingCalculateHashResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AuditingCalculateHashRequestParameters): Keq<AuditingCalculateHashOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AuditingCalculateHashResponseBodies[STATUS]>('/sys/audit-hash/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'input' in args) req.send({ input: args['input'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Enable a new audit device at the supplied path.
   *
   */
  auditingEnableDevice<STATUS extends keyof AuditingEnableDeviceResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AuditingEnableDeviceRequestParameters): Keq<AuditingEnableDeviceOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AuditingEnableDeviceResponseBodies[STATUS]>('/sys/audit/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'local' in args) req.send({ local: args['local'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Disable the audit device at the given path.
   *
   */
  auditingDisableDevice<STATUS extends keyof AuditingDisableDeviceResponseBodies, CONTENT_TYPE extends never = never>(args?: AuditingDisableDeviceRequestParameters): Keq<AuditingDisableDeviceOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<AuditingDisableDeviceResponseBodies[STATUS]>('/sys/audit/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  authListEnabledMethods<STATUS extends keyof AuthListEnabledMethodsResponseBodies, CONTENT_TYPE extends never = never>(args?: AuthListEnabledMethodsRequestParameters): Keq<AuthListEnabledMethodsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuthListEnabledMethodsResponseBodies[STATUS]>('/sys/auth')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration of the auth engine at the given path.
   *
   */
  authReadConfiguration<STATUS extends keyof AuthReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: AuthReadConfigurationRequestParameters): Keq<AuthReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuthReadConfigurationResponseBodies[STATUS]>('/sys/auth/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enables a new auth method.
   *
   * @description After enabling, the auth method can be accessed and configured via the auth path specified as part of the URL. This auth path will be nested under the auth prefix.
   *
   * For example, enable the "foo" auth method will make it accessible at /auth/foo.
   */
  authEnableMethod<STATUS extends keyof AuthEnableMethodResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AuthEnableMethodRequestParameters): Keq<AuthEnableMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AuthEnableMethodResponseBodies[STATUS]>('/sys/auth/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'config' in args) req.send({ config: args['config'] })
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'external_entropy_access' in args) req.send({ external_entropy_access: args['external_entropy_access'] })
    if (args && 'local' in args) req.send({ local: args['local'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'plugin_name' in args) req.send({ plugin_name: args['plugin_name'] })
    if (args && 'plugin_version' in args) req.send({ plugin_version: args['plugin_version'] })
    if (args && 'seal_wrap' in args) req.send({ seal_wrap: args['seal_wrap'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Disable the auth method at the given auth path
   *
   */
  authDisableMethod<STATUS extends keyof AuthDisableMethodResponseBodies, CONTENT_TYPE extends never = never>(args?: AuthDisableMethodRequestParameters): Keq<AuthDisableMethodOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<AuthDisableMethodResponseBodies[STATUS]>('/sys/auth/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reads the given auth path's configuration.
   *
   * @description This endpoint requires sudo capability on the final path, but the same functionality can be achieved without sudo via `sys/mounts/auth/[auth-path]/tune`.
   */
  authReadTuningInformation<STATUS extends keyof AuthReadTuningInformationResponseBodies, CONTENT_TYPE extends never = never>(args?: AuthReadTuningInformationRequestParameters): Keq<AuthReadTuningInformationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuthReadTuningInformationResponseBodies[STATUS]>('/sys/auth/{path}/tune')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Tune configuration parameters for a given auth path.
   *
   * @description This endpoint requires sudo capability on the final path, but the same functionality can be achieved without sudo via `sys/mounts/auth/[auth-path]/tune`.
   */
  authTuneConfigurationParameters<STATUS extends keyof AuthTuneConfigurationParametersResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AuthTuneConfigurationParametersRequestParameters): Keq<AuthTuneConfigurationParametersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AuthTuneConfigurationParametersResponseBodies[STATUS]>('/sys/auth/{path}/tune')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allowed_response_headers' in args) req.send({ allowed_response_headers: args['allowed_response_headers'] })
    if (args && 'audit_non_hmac_request_keys' in args) req.send({ audit_non_hmac_request_keys: args['audit_non_hmac_request_keys'] })
    if (args && 'audit_non_hmac_response_keys' in args) req.send({ audit_non_hmac_response_keys: args['audit_non_hmac_response_keys'] })
    if (args && 'default_lease_ttl' in args) req.send({ default_lease_ttl: args['default_lease_ttl'] })
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'listing_visibility' in args) req.send({ listing_visibility: args['listing_visibility'] })
    if (args && 'max_lease_ttl' in args) req.send({ max_lease_ttl: args['max_lease_ttl'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'passthrough_request_headers' in args) req.send({ passthrough_request_headers: args['passthrough_request_headers'] })
    if (args && 'plugin_version' in args) req.send({ plugin_version: args['plugin_version'] })
    if (args && 'token_type' in args) req.send({ token_type: args['token_type'] })
    if (args && 'user_lockout_config' in args) req.send({ user_lockout_config: args['user_lockout_config'] })
    /* @anchor:body:end */

    return req
  }


  queryTokenCapabilities<STATUS extends keyof QueryTokenCapabilitiesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: QueryTokenCapabilitiesRequestParameters): Keq<QueryTokenCapabilitiesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<QueryTokenCapabilitiesResponseBodies[STATUS]>('/sys/capabilities')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'path' in args) req.send({ path: args['path'] })
    if (args && 'paths' in args) req.send({ paths: args['paths'] })
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  queryTokenAccessorCapabilities<STATUS extends keyof QueryTokenAccessorCapabilitiesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: QueryTokenAccessorCapabilitiesRequestParameters): Keq<QueryTokenAccessorCapabilitiesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<QueryTokenAccessorCapabilitiesResponseBodies[STATUS]>('/sys/capabilities-accessor')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'accessor' in args) req.send({ accessor: args['accessor'] })
    if (args && 'path' in args) req.send({ path: args['path'] })
    if (args && 'paths' in args) req.send({ paths: args['paths'] })
    /* @anchor:body:end */

    return req
  }


  queryTokenSelfCapabilities<STATUS extends keyof QueryTokenSelfCapabilitiesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: QueryTokenSelfCapabilitiesRequestParameters): Keq<QueryTokenSelfCapabilitiesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<QueryTokenSelfCapabilitiesResponseBodies[STATUS]>('/sys/capabilities-self')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'path' in args) req.send({ path: args['path'] })
    if (args && 'paths' in args) req.send({ paths: args['paths'] })
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * List the request headers that are configured to be audited.
   *
   */
  auditingListRequestHeaders<STATUS extends keyof AuditingListRequestHeadersResponseBodies, CONTENT_TYPE extends never = never>(args?: AuditingListRequestHeadersRequestParameters): Keq<AuditingListRequestHeadersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuditingListRequestHeadersResponseBodies[STATUS]>('/sys/config/auditing/request-headers')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List the information for the given request header.
   *
   */
  auditingReadRequestHeaderInformation<STATUS extends keyof AuditingReadRequestHeaderInformationResponseBodies, CONTENT_TYPE extends never = never>(args?: AuditingReadRequestHeaderInformationRequestParameters): Keq<AuditingReadRequestHeaderInformationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<AuditingReadRequestHeaderInformationResponseBodies[STATUS]>('/sys/config/auditing/request-headers/{header}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enable auditing of a header.
   *
   */
  auditingEnableRequestHeader<STATUS extends keyof AuditingEnableRequestHeaderResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: AuditingEnableRequestHeaderRequestParameters): Keq<AuditingEnableRequestHeaderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<AuditingEnableRequestHeaderResponseBodies[STATUS]>('/sys/config/auditing/request-headers/{header}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'hmac' in args) req.send({ hmac: args['hmac'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Disable auditing of the given request header.
   *
   */
  auditingDisableRequestHeader<STATUS extends keyof AuditingDisableRequestHeaderResponseBodies, CONTENT_TYPE extends never = never>(args?: AuditingDisableRequestHeaderRequestParameters): Keq<AuditingDisableRequestHeaderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<AuditingDisableRequestHeaderResponseBodies[STATUS]>('/sys/config/auditing/request-headers/{header}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the current CORS settings.
   *
   */
  corsReadConfiguration<STATUS extends keyof CorsReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: CorsReadConfigurationRequestParameters): Keq<CorsReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<CorsReadConfigurationResponseBodies[STATUS]>('/sys/config/cors')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Configure the CORS settings.
   *
   */
  corsConfigure<STATUS extends keyof CorsConfigureResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: CorsConfigureRequestParameters): Keq<CorsConfigureOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<CorsConfigureResponseBodies[STATUS]>('/sys/config/cors')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allowed_headers' in args) req.send({ allowed_headers: args['allowed_headers'] })
    if (args && 'allowed_origins' in args) req.send({ allowed_origins: args['allowed_origins'] })
    if (args && 'enable' in args) req.send({ enable: args['enable'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Remove any CORS settings.
   *
   */
  corsDeleteConfiguration<STATUS extends keyof CorsDeleteConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: CorsDeleteConfigurationRequestParameters): Keq<CorsDeleteConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<CorsDeleteConfigurationResponseBodies[STATUS]>('/sys/config/cors')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reload the given subsystem
   *
   */
  reloadSubsystem<STATUS extends keyof ReloadSubsystemResponseBodies, CONTENT_TYPE extends never = never>(args?: ReloadSubsystemRequestParameters): Keq<ReloadSubsystemOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<ReloadSubsystemResponseBodies[STATUS]>('/sys/config/reload/{subsystem}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return a sanitized version of the OpenBao server configuration.
   *
   * @description The sanitized output strips configuration values in the storage, HA storage, and seals stanzas, which may contain sensitive values such as API tokens. It also removes any token or secret fields in other stanzas, such as the circonus_api_token from telemetry.
   */
  readSanitizedConfigurationState<STATUS extends keyof ReadSanitizedConfigurationStateResponseBodies, CONTENT_TYPE extends never = never>(args?: ReadSanitizedConfigurationStateRequestParameters): Keq<ReadSanitizedConfigurationStateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<ReadSanitizedConfigurationStateResponseBodies[STATUS]>('/sys/config/state/sanitized')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return a list of configured UI headers.
   *
   */
  uiHeadersList<STATUS extends keyof UiHeadersListResponseBodies, CONTENT_TYPE extends never = never>(args?: UiHeadersListRequestParameters): Keq<UiHeadersListOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<UiHeadersListResponseBodies[STATUS]>('/sys/config/ui/headers')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the given UI header's configuration
   *
   */
  uiHeadersReadConfiguration<STATUS extends keyof UiHeadersReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: UiHeadersReadConfigurationRequestParameters): Keq<UiHeadersReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<UiHeadersReadConfigurationResponseBodies[STATUS]>('/sys/config/ui/headers/{header}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Configure the values to be returned for the UI header.
   *
   */
  uiHeadersConfigure<STATUS extends keyof UiHeadersConfigureResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UiHeadersConfigureRequestParameters): Keq<UiHeadersConfigureOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UiHeadersConfigureResponseBodies[STATUS]>('/sys/config/ui/headers/{header}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'multivalue' in args) req.send({ multivalue: args['multivalue'] })
    if (args && 'values' in args) req.send({ values: args['values'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Remove a UI header.
   *
   */
  uiHeadersDeleteConfiguration<STATUS extends keyof UiHeadersDeleteConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: UiHeadersDeleteConfigurationRequestParameters): Keq<UiHeadersDeleteConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<UiHeadersDeleteConfigurationResponseBodies[STATUS]>('/sys/config/ui/headers/{header}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Decodes the encoded token with the otp.
   *
   */
  decode<STATUS extends keyof DecodeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: DecodeRequestParameters): Keq<DecodeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<DecodeResponseBodies[STATUS]>('/sys/decode-token')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'encoded_token' in args) req.send({ encoded_token: args['encoded_token'] })
    if (args && 'otp' in args) req.send({ otp: args['otp'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration and progress of the current root generation attempt.
   *
   */
  rootTokenGenerationReadProgress2<STATUS extends keyof RootTokenGenerationReadProgress2ResponseBodies, CONTENT_TYPE extends never = never>(args?: RootTokenGenerationReadProgress2RequestParameters): Keq<RootTokenGenerationReadProgress2Operation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RootTokenGenerationReadProgress2ResponseBodies[STATUS]>('/sys/generate-root')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration and progress of the current root generation attempt.
   *
   */
  rootTokenGenerationReadProgress<STATUS extends keyof RootTokenGenerationReadProgressResponseBodies, CONTENT_TYPE extends never = never>(args?: RootTokenGenerationReadProgressRequestParameters): Keq<RootTokenGenerationReadProgressOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RootTokenGenerationReadProgressResponseBodies[STATUS]>('/sys/generate-root/attempt')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initializes a new root generation attempt.
   *
   * @description Only a single root generation attempt can take place at a time. One (and only one) of otp or pgp_key are required.
   */
  rootTokenGenerationInitialize<STATUS extends keyof RootTokenGenerationInitializeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RootTokenGenerationInitializeRequestParameters): Keq<RootTokenGenerationInitializeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RootTokenGenerationInitializeResponseBodies[STATUS]>('/sys/generate-root/attempt')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'pgp_key' in args) req.send({ pgp_key: args['pgp_key'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancels any in-progress root generation attempt.
   *
   */
  rootTokenGenerationCancel<STATUS extends keyof RootTokenGenerationCancelResponseBodies, CONTENT_TYPE extends never = never>(args?: RootTokenGenerationCancelRequestParameters): Keq<RootTokenGenerationCancelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RootTokenGenerationCancelResponseBodies[STATUS]>('/sys/generate-root/attempt')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single unseal key share to progress the root generation attempt.
   *
   * @description If the threshold number of unseal key shares is reached, OpenBao will complete the root generation and issue the new token. Otherwise, this API must be called multiple times until that threshold is met. The attempt nonce must be provided with each call.
   */
  rootTokenGenerationUpdate<STATUS extends keyof RootTokenGenerationUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RootTokenGenerationUpdateRequestParameters): Keq<RootTokenGenerationUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RootTokenGenerationUpdateResponseBodies[STATUS]>('/sys/generate-root/update')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Check the HA status of an OpenBao cluster
   *
   */
  haStatus<STATUS extends keyof HaStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: HaStatusRequestParameters): Keq<HaStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<HaStatusResponseBodies[STATUS]>('/sys/ha-status')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Returns the health status of OpenBao.
   *
   */
  readHealthStatus<STATUS extends keyof ReadHealthStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: ReadHealthStatusRequestParameters): Keq<ReadHealthStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<ReadHealthStatusResponseBodies[STATUS]>('/sys/health')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Information about the host instance that this OpenBao server is running on.
   *
   * @description Information about the host instance that this OpenBao server is running on.
   *     The information that gets collected includes host hardware information, and CPU,
   *     disk, and memory utilization
   */
  collectHostInformation<STATUS extends keyof CollectHostInformationResponseBodies, CONTENT_TYPE extends never = never>(args?: CollectHostInformationRequestParameters): Keq<CollectHostInformationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<CollectHostInformationResponseBodies[STATUS]>('/sys/host-info')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * reports in-flight requests
   *
   * @description This path responds to the following HTTP methods.
   *     GET /
   *       Returns a map of in-flight requests.
   */
  collectInFlightRequestInformation<STATUS extends keyof CollectInFlightRequestInformationResponseBodies, CONTENT_TYPE extends never = never>(args?: CollectInFlightRequestInformationRequestParameters): Keq<CollectInFlightRequestInformationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<CollectInFlightRequestInformationResponseBodies[STATUS]>('/sys/in-flight-req')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Returns the initialization status of OpenBao.
   *
   */
  readInitializationStatus<STATUS extends keyof ReadInitializationStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: ReadInitializationStatusRequestParameters): Keq<ReadInitializationStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<ReadInitializationStatusResponseBodies[STATUS]>('/sys/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initialize a new OpenBao instance.
   *
   * @description The OpenBao instance must not have been previously initialized. The recovery options, as well as the stored shares option, are only available when using OpenBao HSM.
   */
  initializeSystem<STATUS extends keyof InitializeSystemResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: InitializeSystemRequestParameters): Keq<InitializeSystemOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<InitializeSystemResponseBodies[STATUS]>('/sys/init')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'pgp_keys' in args) req.send({ pgp_keys: args['pgp_keys'] })
    if (args && 'recovery_pgp_keys' in args) req.send({ recovery_pgp_keys: args['recovery_pgp_keys'] })
    if (args && 'recovery_shares' in args) req.send({ recovery_shares: args['recovery_shares'] })
    if (args && 'recovery_threshold' in args) req.send({ recovery_threshold: args['recovery_threshold'] })
    if (args && 'root_token_pgp_key' in args) req.send({ root_token_pgp_key: args['root_token_pgp_key'] })
    if (args && 'secret_shares' in args) req.send({ secret_shares: args['secret_shares'] })
    if (args && 'secret_threshold' in args) req.send({ secret_threshold: args['secret_threshold'] })
    if (args && 'stored_shares' in args) req.send({ stored_shares: args['stored_shares'] })
    /* @anchor:body:end */

    return req
  }


  encryptionKeyStatus<STATUS extends keyof EncryptionKeyStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: EncryptionKeyStatusRequestParameters): Keq<EncryptionKeyStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EncryptionKeyStatusResponseBodies[STATUS]>('/sys/key-status')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Returns the high availability status and current leader instance of OpenBao.
   *
   */
  leaderStatus<STATUS extends keyof LeaderStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: LeaderStatusRequestParameters): Keq<LeaderStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LeaderStatusResponseBodies[STATUS]>('/sys/leader')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  leasesList<STATUS extends keyof LeasesListResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesListRequestParameters): Keq<LeasesListOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LeasesListResponseBodies[STATUS]>('/sys/leases')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  leasesCount<STATUS extends keyof LeasesCountResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesCountRequestParameters): Keq<LeasesCountOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LeasesCountResponseBodies[STATUS]>('/sys/leases/count')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  leasesReadLease<STATUS extends keyof LeasesReadLeaseResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesReadLeaseRequestParameters): Keq<LeasesReadLeaseOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesReadLeaseResponseBodies[STATUS]>('/sys/leases/lookup')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'lease_id' in args) req.send({ lease_id: args['lease_id'] })
    /* @anchor:body:end */

    return req
  }


  leasesLookUp<STATUS extends keyof LeasesLookUpResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesLookUpRequestParameters): Keq<LeasesLookUpOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LeasesLookUpResponseBodies[STATUS]>('/sys/leases/lookup/')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  leasesLookUpWithPrefix<STATUS extends keyof LeasesLookUpWithPrefixResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesLookUpWithPrefixRequestParameters): Keq<LeasesLookUpWithPrefixOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LeasesLookUpWithPrefixResponseBodies[STATUS]>('/sys/leases/lookup/{prefix}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Renews a lease, requesting to extend the lease.
   *
   */
  leasesRenewLease<STATUS extends keyof LeasesRenewLeaseResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesRenewLeaseRequestParameters): Keq<LeasesRenewLeaseOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesRenewLeaseResponseBodies[STATUS]>('/sys/leases/renew')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'increment' in args) req.send({ increment: args['increment'] })
    if (args && 'lease_id' in args) req.send({ lease_id: args['lease_id'] })
    if (args && 'url_lease_id' in args) req.send({ url_lease_id: args['url_lease_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Renews a lease, requesting to extend the lease.
   *
   */
  leasesRenewLeaseWithId<STATUS extends keyof LeasesRenewLeaseWithIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesRenewLeaseWithIdRequestParameters): Keq<LeasesRenewLeaseWithIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesRenewLeaseWithIdResponseBodies[STATUS]>('/sys/leases/renew/{url_lease_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'increment' in args) req.send({ increment: args['increment'] })
    if (args && 'lease_id' in args) req.send({ lease_id: args['lease_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Revokes a lease immediately.
   *
   */
  leasesRevokeLease<STATUS extends keyof LeasesRevokeLeaseResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesRevokeLeaseRequestParameters): Keq<LeasesRevokeLeaseOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesRevokeLeaseResponseBodies[STATUS]>('/sys/leases/revoke')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'lease_id' in args) req.send({ lease_id: args['lease_id'] })
    if (args && 'sync' in args) req.send({ sync: args['sync'] })
    if (args && 'url_lease_id' in args) req.send({ url_lease_id: args['url_lease_id'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Revokes all secrets or tokens generated under a given prefix immediately
   *
   * @description Unlike `/sys/leases/revoke-prefix`, this path ignores backend errors encountered during revocation. This is potentially very dangerous and should only be used in specific emergency situations where errors in the backend or the connected backend service prevent normal revocation.
   *
   * By ignoring these errors, OpenBao abdicates responsibility for ensuring that the issued credentials or secrets are properly revoked and/or cleaned up. Access to this endpoint should be tightly controlled.
   */
  leasesForceRevokeLeaseWithPrefix<STATUS extends keyof LeasesForceRevokeLeaseWithPrefixResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesForceRevokeLeaseWithPrefixRequestParameters): Keq<LeasesForceRevokeLeaseWithPrefixOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesForceRevokeLeaseWithPrefixResponseBodies[STATUS]>('/sys/leases/revoke-force/{prefix}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Revokes all secrets (via a lease ID prefix) or tokens (via the tokens' path property) generated under a given prefix immediately.
   *
   */
  leasesRevokeLeaseWithPrefix<STATUS extends keyof LeasesRevokeLeaseWithPrefixResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesRevokeLeaseWithPrefixRequestParameters): Keq<LeasesRevokeLeaseWithPrefixOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesRevokeLeaseWithPrefixResponseBodies[STATUS]>('/sys/leases/revoke-prefix/{prefix}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'sync' in args) req.send({ sync: args['sync'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Revokes a lease immediately.
   *
   */
  leasesRevokeLeaseWithId<STATUS extends keyof LeasesRevokeLeaseWithIdResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LeasesRevokeLeaseWithIdRequestParameters): Keq<LeasesRevokeLeaseWithIdOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesRevokeLeaseWithIdResponseBodies[STATUS]>('/sys/leases/revoke/{url_lease_id}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'lease_id' in args) req.send({ lease_id: args['lease_id'] })
    if (args && 'sync' in args) req.send({ sync: args['sync'] })
    /* @anchor:body:end */

    return req
  }


  leasesTidy<STATUS extends keyof LeasesTidyResponseBodies, CONTENT_TYPE extends never = never>(args?: LeasesTidyRequestParameters): Keq<LeasesTidyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LeasesTidyResponseBodies[STATUS]>('/sys/leases/tidy')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Report the locked user count metrics, for this namespace and all child namespaces.
   *
   */
  lockedUsersList<STATUS extends keyof LockedUsersListResponseBodies, CONTENT_TYPE extends never = never>(args?: LockedUsersListRequestParameters): Keq<LockedUsersListOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LockedUsersListResponseBodies[STATUS]>('/sys/locked-users')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Unlocks the user with given mount_accessor and alias_identifier
   *
   */
  lockedUsersUnlock<STATUS extends keyof LockedUsersUnlockResponseBodies, CONTENT_TYPE extends never = never>(args?: LockedUsersUnlockRequestParameters): Keq<LockedUsersUnlockOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LockedUsersUnlockResponseBodies[STATUS]>('/sys/locked-users/{mount_accessor}/unlock/{alias_identifier}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the log level for all existing loggers.
   *
   */
  loggersReadVerbosityLevel<STATUS extends keyof LoggersReadVerbosityLevelResponseBodies, CONTENT_TYPE extends never = never>(args?: LoggersReadVerbosityLevelRequestParameters): Keq<LoggersReadVerbosityLevelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LoggersReadVerbosityLevelResponseBodies[STATUS]>('/sys/loggers')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Modify the log level for all existing loggers.
   *
   */
  loggersUpdateVerbosityLevel<STATUS extends keyof LoggersUpdateVerbosityLevelResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LoggersUpdateVerbosityLevelRequestParameters): Keq<LoggersUpdateVerbosityLevelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LoggersUpdateVerbosityLevelResponseBodies[STATUS]>('/sys/loggers')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'level' in args) req.send({ level: args['level'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Revert the all loggers to use log level provided in config.
   *
   */
  loggersRevertVerbosityLevel<STATUS extends keyof LoggersRevertVerbosityLevelResponseBodies, CONTENT_TYPE extends never = never>(args?: LoggersRevertVerbosityLevelRequestParameters): Keq<LoggersRevertVerbosityLevelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<LoggersRevertVerbosityLevelResponseBodies[STATUS]>('/sys/loggers')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the log level for a single logger.
   *
   */
  loggersReadVerbosityLevelFor<STATUS extends keyof LoggersReadVerbosityLevelForResponseBodies, CONTENT_TYPE extends never = never>(args?: LoggersReadVerbosityLevelForRequestParameters): Keq<LoggersReadVerbosityLevelForOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<LoggersReadVerbosityLevelForResponseBodies[STATUS]>('/sys/loggers/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Modify the log level of a single logger.
   *
   */
  loggersUpdateVerbosityLevelFor<STATUS extends keyof LoggersUpdateVerbosityLevelForResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: LoggersUpdateVerbosityLevelForRequestParameters): Keq<LoggersUpdateVerbosityLevelForOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<LoggersUpdateVerbosityLevelForResponseBodies[STATUS]>('/sys/loggers/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'level' in args) req.send({ level: args['level'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Revert a single logger to use log level provided in config.
   *
   */
  loggersRevertVerbosityLevelFor<STATUS extends keyof LoggersRevertVerbosityLevelForResponseBodies, CONTENT_TYPE extends never = never>(args?: LoggersRevertVerbosityLevelForRequestParameters): Keq<LoggersRevertVerbosityLevelForOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<LoggersRevertVerbosityLevelForResponseBodies[STATUS]>('/sys/loggers/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  metrics<STATUS extends keyof MetricsResponseBodies, CONTENT_TYPE extends never = never>(args?: MetricsRequestParameters): Keq<MetricsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MetricsResponseBodies[STATUS]>('/sys/metrics')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Validates the login for the given MFA methods. Upon successful validation, it returns an auth response containing the client token
   *
   */
  mfaValidate<STATUS extends keyof MfaValidateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MfaValidateRequestParameters): Keq<MfaValidateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MfaValidateResponseBodies[STATUS]>('/sys/mfa/validate')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'mfa_payload' in args) req.send({ mfa_payload: args['mfa_payload'] })
    if (args && 'mfa_request_id' in args) req.send({ mfa_request_id: args['mfa_request_id'] })
    /* @anchor:body:end */

    return req
  }


  monitor<STATUS extends keyof MonitorResponseBodies, CONTENT_TYPE extends never = never>(args?: MonitorRequestParameters): Keq<MonitorOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MonitorResponseBodies[STATUS]>('/sys/monitor')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  mountsListSecretsEngines<STATUS extends keyof MountsListSecretsEnginesResponseBodies, CONTENT_TYPE extends never = never>(args?: MountsListSecretsEnginesRequestParameters): Keq<MountsListSecretsEnginesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MountsListSecretsEnginesResponseBodies[STATUS]>('/sys/mounts')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration of the secret engine at the given path.
   *
   */
  mountsReadConfiguration<STATUS extends keyof MountsReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: MountsReadConfigurationRequestParameters): Keq<MountsReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MountsReadConfigurationResponseBodies[STATUS]>('/sys/mounts/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enable a new secrets engine at the given path.
   *
   */
  mountsEnableSecretsEngine<STATUS extends keyof MountsEnableSecretsEngineResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MountsEnableSecretsEngineRequestParameters): Keq<MountsEnableSecretsEngineOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MountsEnableSecretsEngineResponseBodies[STATUS]>('/sys/mounts/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'config' in args) req.send({ config: args['config'] })
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'external_entropy_access' in args) req.send({ external_entropy_access: args['external_entropy_access'] })
    if (args && 'local' in args) req.send({ local: args['local'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'plugin_name' in args) req.send({ plugin_name: args['plugin_name'] })
    if (args && 'plugin_version' in args) req.send({ plugin_version: args['plugin_version'] })
    if (args && 'seal_wrap' in args) req.send({ seal_wrap: args['seal_wrap'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Disable the mount point specified at the given path.
   *
   */
  mountsDisableSecretsEngine<STATUS extends keyof MountsDisableSecretsEngineResponseBodies, CONTENT_TYPE extends never = never>(args?: MountsDisableSecretsEngineRequestParameters): Keq<MountsDisableSecretsEngineOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<MountsDisableSecretsEngineResponseBodies[STATUS]>('/sys/mounts/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  mountsReadTuningInformation<STATUS extends keyof MountsReadTuningInformationResponseBodies, CONTENT_TYPE extends never = never>(args?: MountsReadTuningInformationRequestParameters): Keq<MountsReadTuningInformationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<MountsReadTuningInformationResponseBodies[STATUS]>('/sys/mounts/{path}/tune')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  mountsTuneConfigurationParameters<STATUS extends keyof MountsTuneConfigurationParametersResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: MountsTuneConfigurationParametersRequestParameters): Keq<MountsTuneConfigurationParametersOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<MountsTuneConfigurationParametersResponseBodies[STATUS]>('/sys/mounts/{path}/tune')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allowed_managed_keys' in args) req.send({ allowed_managed_keys: args['allowed_managed_keys'] })
    if (args && 'allowed_response_headers' in args) req.send({ allowed_response_headers: args['allowed_response_headers'] })
    if (args && 'audit_non_hmac_request_keys' in args) req.send({ audit_non_hmac_request_keys: args['audit_non_hmac_request_keys'] })
    if (args && 'audit_non_hmac_response_keys' in args) req.send({ audit_non_hmac_response_keys: args['audit_non_hmac_response_keys'] })
    if (args && 'default_lease_ttl' in args) req.send({ default_lease_ttl: args['default_lease_ttl'] })
    if (args && 'description' in args) req.send({ description: args['description'] })
    if (args && 'listing_visibility' in args) req.send({ listing_visibility: args['listing_visibility'] })
    if (args && 'max_lease_ttl' in args) req.send({ max_lease_ttl: args['max_lease_ttl'] })
    if (args && 'options' in args) req.send({ options: args['options'] })
    if (args && 'passthrough_request_headers' in args) req.send({ passthrough_request_headers: args['passthrough_request_headers'] })
    if (args && 'plugin_version' in args) req.send({ plugin_version: args['plugin_version'] })
    if (args && 'token_type' in args) req.send({ token_type: args['token_type'] })
    if (args && 'user_lockout_config' in args) req.send({ user_lockout_config: args['user_lockout_config'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * List namespaces.
   *
   */
  namespacesListNamespaces<STATUS extends keyof NamespacesListNamespacesResponseBodies, CONTENT_TYPE extends never = never>(args?: NamespacesListNamespacesRequestParameters): Keq<NamespacesListNamespacesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<NamespacesListNamespacesResponseBodies[STATUS]>('/sys/namespaces')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Lock a namespace.
   *
   */
  namespacesWriteNamespacesApiLockLock<STATUS extends keyof NamespacesWriteNamespacesApiLockLockResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: NamespacesWriteNamespacesApiLockLockRequestParameters): Keq<NamespacesWriteNamespacesApiLockLockOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<NamespacesWriteNamespacesApiLockLockResponseBodies[STATUS]>('/sys/namespaces/api-lock/lock')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'path' in args) req.send({ path: args['path'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Lock a namespace.
   *
   */
  namespacesWriteNamespacesApiLockLockPath<STATUS extends keyof NamespacesWriteNamespacesApiLockLockPathResponseBodies, CONTENT_TYPE extends never = never>(args?: NamespacesWriteNamespacesApiLockLockPathRequestParameters): Keq<NamespacesWriteNamespacesApiLockLockPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<NamespacesWriteNamespacesApiLockLockPathResponseBodies[STATUS]>('/sys/namespaces/api-lock/lock/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Unlock a namespace.
   *
   */
  namespacesWriteNamespacesApiLockUnlock<STATUS extends keyof NamespacesWriteNamespacesApiLockUnlockResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: NamespacesWriteNamespacesApiLockUnlockRequestParameters): Keq<NamespacesWriteNamespacesApiLockUnlockOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<NamespacesWriteNamespacesApiLockUnlockResponseBodies[STATUS]>('/sys/namespaces/api-lock/unlock')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'path' in args) req.send({ path: args['path'] })
    if (args && 'unlock_key' in args) req.send({ unlock_key: args['unlock_key'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Unlock a namespace.
   *
   */
  namespacesWriteNamespacesApiLockUnlockPath<STATUS extends keyof NamespacesWriteNamespacesApiLockUnlockPathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: NamespacesWriteNamespacesApiLockUnlockPathRequestParameters): Keq<NamespacesWriteNamespacesApiLockUnlockPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<NamespacesWriteNamespacesApiLockUnlockPathResponseBodies[STATUS]>('/sys/namespaces/api-lock/unlock/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'unlock_key' in args) req.send({ unlock_key: args['unlock_key'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Retrieve a namespace.
   *
   */
  namespacesReadNamespacesPath<STATUS extends keyof NamespacesReadNamespacesPathResponseBodies, CONTENT_TYPE extends never = never>(args?: NamespacesReadNamespacesPathRequestParameters): Keq<NamespacesReadNamespacesPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<NamespacesReadNamespacesPathResponseBodies[STATUS]>('/sys/namespaces/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Create or update a namespace.
   *
   */
  namespacesWriteNamespacesPath<STATUS extends keyof NamespacesWriteNamespacesPathResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: NamespacesWriteNamespacesPathRequestParameters): Keq<NamespacesWriteNamespacesPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<NamespacesWriteNamespacesPathResponseBodies[STATUS]>('/sys/namespaces/{path}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'custom_metadata' in args) req.send({ custom_metadata: args['custom_metadata'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a namespace.
   *
   */
  namespacesDeleteNamespacesPath<STATUS extends keyof NamespacesDeleteNamespacesPathResponseBodies, CONTENT_TYPE extends never = never>(args?: NamespacesDeleteNamespacesPathRequestParameters): Keq<NamespacesDeleteNamespacesPathOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<NamespacesDeleteNamespacesPathResponseBodies[STATUS]>('/sys/namespaces/{path}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  pluginsCatalogListPlugins<STATUS extends keyof PluginsCatalogListPluginsResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogListPluginsRequestParameters): Keq<PluginsCatalogListPluginsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PluginsCatalogListPluginsResponseBodies[STATUS]>('/sys/plugins/catalog')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the configuration data for the plugin with the given name.
   *
   */
  pluginsCatalogReadPluginConfiguration<STATUS extends keyof PluginsCatalogReadPluginConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogReadPluginConfigurationRequestParameters): Keq<PluginsCatalogReadPluginConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PluginsCatalogReadPluginConfigurationResponseBodies[STATUS]>('/sys/plugins/catalog/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Register a new plugin, or updates an existing one with the supplied name.
   *
   */
  pluginsCatalogRegisterPlugin<STATUS extends keyof PluginsCatalogRegisterPluginResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PluginsCatalogRegisterPluginRequestParameters): Keq<PluginsCatalogRegisterPluginOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PluginsCatalogRegisterPluginResponseBodies[STATUS]>('/sys/plugins/catalog/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'args' in args) req.send({ args: args['args'] })
    if (args && 'command' in args) req.send({ command: args['command'] })
    if (args && 'env' in args) req.send({ env: args['env'] })
    if (args && 'oci' in args) req.send({ oci: args['oci'] })
    if (args && 'sha256' in args) req.send({ sha256: args['sha256'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Remove the plugin with the given name.
   *
   */
  pluginsCatalogRemovePlugin<STATUS extends keyof PluginsCatalogRemovePluginResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogRemovePluginRequestParameters): Keq<PluginsCatalogRemovePluginOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<PluginsCatalogRemovePluginResponseBodies[STATUS]>('/sys/plugins/catalog/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List the plugins in the catalog.
   *
   */
  pluginsCatalogListPluginsWithType<STATUS extends keyof PluginsCatalogListPluginsWithTypeResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogListPluginsWithTypeRequestParameters): Keq<PluginsCatalogListPluginsWithTypeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PluginsCatalogListPluginsWithTypeResponseBodies[STATUS]>('/sys/plugins/catalog/{type}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the configuration data for the plugin with the given name.
   *
   */
  pluginsCatalogReadPluginConfigurationWithType<STATUS extends keyof PluginsCatalogReadPluginConfigurationWithTypeResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogReadPluginConfigurationWithTypeRequestParameters): Keq<PluginsCatalogReadPluginConfigurationWithTypeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PluginsCatalogReadPluginConfigurationWithTypeResponseBodies[STATUS]>('/sys/plugins/catalog/{type}/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Register a new plugin, or updates an existing one with the supplied name.
   *
   */
  pluginsCatalogRegisterPluginWithType<STATUS extends keyof PluginsCatalogRegisterPluginWithTypeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PluginsCatalogRegisterPluginWithTypeRequestParameters): Keq<PluginsCatalogRegisterPluginWithTypeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PluginsCatalogRegisterPluginWithTypeResponseBodies[STATUS]>('/sys/plugins/catalog/{type}/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'args' in args) req.send({ args: args['args'] })
    if (args && 'command' in args) req.send({ command: args['command'] })
    if (args && 'env' in args) req.send({ env: args['env'] })
    if (args && 'oci' in args) req.send({ oci: args['oci'] })
    if (args && 'sha256' in args) req.send({ sha256: args['sha256'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Remove the plugin with the given name.
   *
   */
  pluginsCatalogRemovePluginWithType<STATUS extends keyof PluginsCatalogRemovePluginWithTypeResponseBodies, CONTENT_TYPE extends never = never>(args?: PluginsCatalogRemovePluginWithTypeRequestParameters): Keq<PluginsCatalogRemovePluginWithTypeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<PluginsCatalogRemovePluginWithTypeResponseBodies[STATUS]>('/sys/plugins/catalog/{type}/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reload mounted plugin backends.
   *
   * @description Either the plugin name (`plugin`) or the desired plugin backend mounts (`mounts`) must be provided, but not both. In the case that the plugin name is provided, all mounted paths that use that plugin backend will be reloaded.  If (`scope`) is provided and is (`global`), the plugin(s) are reloaded globally.
   */
  pluginsReloadBackends<STATUS extends keyof PluginsReloadBackendsResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PluginsReloadBackendsRequestParameters): Keq<PluginsReloadBackendsOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PluginsReloadBackendsResponseBodies[STATUS]>('/sys/plugins/reload/backend')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'mounts' in args) req.send({ mounts: args['mounts'] })
    if (args && 'plugin' in args) req.send({ plugin: args['plugin'] })
    if (args && 'scope' in args) req.send({ scope: args['scope'] })
    /* @anchor:body:end */

    return req
  }


  policiesListAclPolicies<STATUS extends keyof PoliciesListAclPoliciesResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesListAclPoliciesRequestParameters): Keq<PoliciesListAclPoliciesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesListAclPoliciesResponseBodies[STATUS]>('/sys/policies/acl')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Retrieve information about the named ACL policy.
   *
   */
  policiesReadAclPolicy<STATUS extends keyof PoliciesReadAclPolicyResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesReadAclPolicyRequestParameters): Keq<PoliciesReadAclPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesReadAclPolicyResponseBodies[STATUS]>('/sys/policies/acl/{name}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Add a new or update an existing ACL policy.
   *
   */
  policiesWriteAclPolicy<STATUS extends keyof PoliciesWriteAclPolicyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PoliciesWriteAclPolicyRequestParameters): Keq<PoliciesWriteAclPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PoliciesWriteAclPolicyResponseBodies[STATUS]>('/sys/policies/acl/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'cas' in args) req.send({ cas: args['cas'] })
    if (args && 'cas_required' in args) req.send({ cas_required: args['cas_required'] })
    if (args && 'expiration' in args) req.send({ expiration: args['expiration'] })
    if (args && 'policy' in args) req.send({ policy: args['policy'] })
    if (args && 'ttl' in args) req.send({ ttl: args['ttl'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete the ACL policy with the given name.
   *
   */
  policiesDeleteAclPolicy<STATUS extends keyof PoliciesDeleteAclPolicyResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesDeleteAclPolicyRequestParameters): Keq<PoliciesDeleteAclPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<PoliciesDeleteAclPolicyResponseBodies[STATUS]>('/sys/policies/acl/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List ACL policies with detailed information.
   *
   */
  systemListPoliciesDetailedAcl<STATUS extends keyof SystemListPoliciesDetailedAclResponseBodies, CONTENT_TYPE extends never = never>(args?: SystemListPoliciesDetailedAclRequestParameters): Keq<SystemListPoliciesDetailedAclOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<SystemListPoliciesDetailedAclResponseBodies[STATUS]>('/sys/policies/detailed/acl')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List ACL policies with detailed information.
   *
   */
  systemListPoliciesDetailedAclName<STATUS extends keyof SystemListPoliciesDetailedAclNameResponseBodies, CONTENT_TYPE extends never = never>(args?: SystemListPoliciesDetailedAclNameRequestParameters): Keq<SystemListPoliciesDetailedAclNameOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<SystemListPoliciesDetailedAclNameResponseBodies[STATUS]>('/sys/policies/detailed/acl/{name}')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * List the existing password policies.
   *
   */
  policiesListPasswordPolicies<STATUS extends keyof PoliciesListPasswordPoliciesResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesListPasswordPoliciesRequestParameters): Keq<PoliciesListPasswordPoliciesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesListPasswordPoliciesResponseBodies[STATUS]>('/sys/policies/password')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Retrieve an existing password policy.
   *
   */
  policiesReadPasswordPolicy<STATUS extends keyof PoliciesReadPasswordPolicyResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesReadPasswordPolicyRequestParameters): Keq<PoliciesReadPasswordPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesReadPasswordPolicyResponseBodies[STATUS]>('/sys/policies/password/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Add a new or update an existing password policy.
   *
   */
  policiesWritePasswordPolicy<STATUS extends keyof PoliciesWritePasswordPolicyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: PoliciesWritePasswordPolicyRequestParameters): Keq<PoliciesWritePasswordPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<PoliciesWritePasswordPolicyResponseBodies[STATUS]>('/sys/policies/password/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'policy' in args) req.send({ policy: args['policy'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete a password policy.
   *
   */
  policiesDeletePasswordPolicy<STATUS extends keyof PoliciesDeletePasswordPolicyResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesDeletePasswordPolicyRequestParameters): Keq<PoliciesDeletePasswordPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<PoliciesDeletePasswordPolicyResponseBodies[STATUS]>('/sys/policies/password/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Generate a password from an existing password policy.
   *
   */
  policiesGeneratePasswordFromPasswordPolicy<STATUS extends keyof PoliciesGeneratePasswordFromPasswordPolicyResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesGeneratePasswordFromPasswordPolicyRequestParameters): Keq<PoliciesGeneratePasswordFromPasswordPolicyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesGeneratePasswordFromPasswordPolicyResponseBodies[STATUS]>('/sys/policies/password/{name}/generate')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  policiesList<STATUS extends keyof PoliciesListResponseBodies, CONTENT_TYPE extends never = never>(args?: PoliciesListRequestParameters): Keq<PoliciesListOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<PoliciesListResponseBodies[STATUS]>('/sys/policy')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasReadConfiguration<STATUS extends keyof RateLimitQuotasReadConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: RateLimitQuotasReadConfigurationRequestParameters): Keq<RateLimitQuotasReadConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RateLimitQuotasReadConfigurationResponseBodies[STATUS]>('/sys/quotas/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasConfigure<STATUS extends keyof RateLimitQuotasConfigureResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RateLimitQuotasConfigureRequestParameters): Keq<RateLimitQuotasConfigureOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RateLimitQuotasConfigureResponseBodies[STATUS]>('/sys/quotas/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'enable_rate_limit_audit_logging' in args) req.send({ enable_rate_limit_audit_logging: args['enable_rate_limit_audit_logging'] })
    if (args && 'enable_rate_limit_response_headers' in args) req.send({ enable_rate_limit_response_headers: args['enable_rate_limit_response_headers'] })
    if (args && 'rate_limit_exempt_paths' in args) req.send({ rate_limit_exempt_paths: args['rate_limit_exempt_paths'] })
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasList<STATUS extends keyof RateLimitQuotasListResponseBodies, CONTENT_TYPE extends never = never>(args?: RateLimitQuotasListRequestParameters): Keq<RateLimitQuotasListOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RateLimitQuotasListResponseBodies[STATUS]>('/sys/quotas/rate-limit')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasRead<STATUS extends keyof RateLimitQuotasReadResponseBodies, CONTENT_TYPE extends never = never>(args?: RateLimitQuotasReadRequestParameters): Keq<RateLimitQuotasReadOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RateLimitQuotasReadResponseBodies[STATUS]>('/sys/quotas/rate-limit/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasWrite<STATUS extends keyof RateLimitQuotasWriteResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RateLimitQuotasWriteRequestParameters): Keq<RateLimitQuotasWriteOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RateLimitQuotasWriteResponseBodies[STATUS]>('/sys/quotas/rate-limit/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'block_interval' in args) req.send({ block_interval: args['block_interval'] })
    if (args && 'inheritable' in args) req.send({ inheritable: args['inheritable'] })
    if (args && 'interval' in args) req.send({ interval: args['interval'] })
    if (args && 'path' in args) req.send({ path: args['path'] })
    if (args && 'rate' in args) req.send({ rate: args['rate'] })
    if (args && 'role' in args) req.send({ role: args['role'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  rateLimitQuotasDelete<STATUS extends keyof RateLimitQuotasDeleteResponseBodies, CONTENT_TYPE extends never = never>(args?: RateLimitQuotasDeleteRequestParameters): Keq<RateLimitQuotasDeleteOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RateLimitQuotasDeleteResponseBodies[STATUS]>('/sys/quotas/rate-limit/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the backup copy of PGP-encrypted unseal keys.
   *
   */
  rekeyReadBackupKey<STATUS extends keyof RekeyReadBackupKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyReadBackupKeyRequestParameters): Keq<RekeyReadBackupKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RekeyReadBackupKeyResponseBodies[STATUS]>('/sys/rekey/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete the backup copy of PGP-encrypted unseal keys.
   *
   */
  rekeyDeleteBackupKey<STATUS extends keyof RekeyDeleteBackupKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyDeleteBackupKeyRequestParameters): Keq<RekeyDeleteBackupKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RekeyDeleteBackupKeyResponseBodies[STATUS]>('/sys/rekey/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reads the configuration and progress of the current rekey attempt.
   *
   */
  rekeyAttemptReadProgress<STATUS extends keyof RekeyAttemptReadProgressResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyAttemptReadProgressRequestParameters): Keq<RekeyAttemptReadProgressOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RekeyAttemptReadProgressResponseBodies[STATUS]>('/sys/rekey/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initializes a new rekey attempt.
   *
   * @description Only a single rekey attempt can take place at a time, and changing the parameters of a rekey requires canceling and starting a new rekey, which will also provide a new nonce.
   */
  rekeyAttemptInitialize<STATUS extends keyof RekeyAttemptInitializeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RekeyAttemptInitializeRequestParameters): Keq<RekeyAttemptInitializeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RekeyAttemptInitializeResponseBodies[STATUS]>('/sys/rekey/init')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'backup' in args) req.send({ backup: args['backup'] })
    if (args && 'pgp_keys' in args) req.send({ pgp_keys: args['pgp_keys'] })
    if (args && 'require_verification' in args) req.send({ require_verification: args['require_verification'] })
    if (args && 'secret_shares' in args) req.send({ secret_shares: args['secret_shares'] })
    if (args && 'secret_threshold' in args) req.send({ secret_threshold: args['secret_threshold'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancels any in-progress rekey.
   *
   * @description This clears the rekey settings as well as any progress made. This must be called to change the parameters of the rekey. Note: verification is still a part of a rekey. If rekeying is canceled during the verification flow, the current unseal keys remain valid.
   */
  rekeyAttemptCancel<STATUS extends keyof RekeyAttemptCancelResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyAttemptCancelRequestParameters): Keq<RekeyAttemptCancelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RekeyAttemptCancelResponseBodies[STATUS]>('/sys/rekey/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rekeyReadBackupRecoveryKey<STATUS extends keyof RekeyReadBackupRecoveryKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyReadBackupRecoveryKeyRequestParameters): Keq<RekeyReadBackupRecoveryKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RekeyReadBackupRecoveryKeyResponseBodies[STATUS]>('/sys/rekey/recovery-key-backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rekeyDeleteBackupRecoveryKey<STATUS extends keyof RekeyDeleteBackupRecoveryKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyDeleteBackupRecoveryKeyRequestParameters): Keq<RekeyDeleteBackupRecoveryKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RekeyDeleteBackupRecoveryKeyResponseBodies[STATUS]>('/sys/rekey/recovery-key-backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single unseal key share to progress the rekey of the OpenBao.
   *
   */
  rekeyAttemptUpdate<STATUS extends keyof RekeyAttemptUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RekeyAttemptUpdateRequestParameters): Keq<RekeyAttemptUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RekeyAttemptUpdateResponseBodies[STATUS]>('/sys/rekey/update')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration and progress of the current rekey verification attempt.
   *
   */
  rekeyVerificationReadProgress<STATUS extends keyof RekeyVerificationReadProgressResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyVerificationReadProgressRequestParameters): Keq<RekeyVerificationReadProgressOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RekeyVerificationReadProgressResponseBodies[STATUS]>('/sys/rekey/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single new key share to progress the rekey verification operation.
   *
   */
  rekeyVerificationUpdate<STATUS extends keyof RekeyVerificationUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RekeyVerificationUpdateRequestParameters): Keq<RekeyVerificationUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RekeyVerificationUpdateResponseBodies[STATUS]>('/sys/rekey/verify')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancel any in-progress rekey verification operation.
   *
   * @description This clears any progress made and resets the nonce. Unlike a `DELETE` against `sys/rekey/init`, this only resets the current verification operation, not the entire rekey atttempt.
   */
  rekeyVerificationCancel<STATUS extends keyof RekeyVerificationCancelResponseBodies, CONTENT_TYPE extends never = never>(args?: RekeyVerificationCancelRequestParameters): Keq<RekeyVerificationCancelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RekeyVerificationCancelResponseBodies[STATUS]>('/sys/rekey/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initiate a mount migration
   *
   */
  remount<STATUS extends keyof RemountResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RemountRequestParameters): Keq<RemountOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RemountResponseBodies[STATUS]>('/sys/remount')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'from' in args) req.send({ from: args['from'] })
    if (args && 'to' in args) req.send({ to: args['to'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Check status of a mount migration
   *
   */
  remountStatus<STATUS extends keyof RemountStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: RemountStatusRequestParameters): Keq<RemountStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RemountStatusResponseBodies[STATUS]>('/sys/remount/status/{migration_id}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  encryptionKeyRotate<STATUS extends keyof EncryptionKeyRotateResponseBodies, CONTENT_TYPE extends never = never>(args?: EncryptionKeyRotateRequestParameters): Keq<EncryptionKeyRotateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EncryptionKeyRotateResponseBodies[STATUS]>('/sys/rotate')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  encryptionKeyReadRotationConfiguration<STATUS extends keyof EncryptionKeyReadRotationConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: EncryptionKeyReadRotationConfigurationRequestParameters): Keq<EncryptionKeyReadRotationConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EncryptionKeyReadRotationConfigurationResponseBodies[STATUS]>('/sys/rotate/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  encryptionKeyConfigureRotationConfiguration<STATUS extends keyof EncryptionKeyConfigureRotationConfigurationResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EncryptionKeyConfigureRotationConfigurationRequestParameters): Keq<EncryptionKeyConfigureRotationConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EncryptionKeyConfigureRotationConfigurationResponseBodies[STATUS]>('/sys/rotate/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'enabled' in args) req.send({ enabled: args['enabled'] })
    if (args && 'interval' in args) req.send({ interval: args['interval'] })
    if (args && 'max_operations' in args) req.send({ max_operations: args['max_operations'] })
    /* @anchor:body:end */

    return req
  }


  encryptionKeyRotateRotateKeyring<STATUS extends keyof EncryptionKeyRotateRotateKeyringResponseBodies, CONTENT_TYPE extends never = never>(args?: EncryptionKeyRotateRotateKeyringRequestParameters): Keq<EncryptionKeyRotateRotateKeyringOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EncryptionKeyRotateRotateKeyringResponseBodies[STATUS]>('/sys/rotate/keyring')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  encryptionKeyReadRotateKeyringConfig<STATUS extends keyof EncryptionKeyReadRotateKeyringConfigResponseBodies, CONTENT_TYPE extends never = never>(args?: EncryptionKeyReadRotateKeyringConfigRequestParameters): Keq<EncryptionKeyReadRotateKeyringConfigOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<EncryptionKeyReadRotateKeyringConfigResponseBodies[STATUS]>('/sys/rotate/keyring/config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  encryptionKeyConfigureRotateKeyringConfig<STATUS extends keyof EncryptionKeyConfigureRotateKeyringConfigResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: EncryptionKeyConfigureRotateKeyringConfigRequestParameters): Keq<EncryptionKeyConfigureRotateKeyringConfigOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<EncryptionKeyConfigureRotateKeyringConfigResponseBodies[STATUS]>('/sys/rotate/keyring/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'enabled' in args) req.send({ enabled: args['enabled'] })
    if (args && 'interval' in args) req.send({ interval: args['interval'] })
    if (args && 'max_operations' in args) req.send({ max_operations: args['max_operations'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the backup copy of PGP-encrypted unseal keys.
   *
   */
  rotateReadRotateRecoveryBackup<STATUS extends keyof RotateReadRotateRecoveryBackupResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateReadRotateRecoveryBackupRequestParameters): Keq<RotateReadRotateRecoveryBackupOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateReadRotateRecoveryBackupResponseBodies[STATUS]>('/sys/rotate/recovery/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete the backup copy of PGP-encrypted unseal keys.
   *
   */
  rotateDeleteRotateRecoveryBackup<STATUS extends keyof RotateDeleteRotateRecoveryBackupResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateDeleteRotateRecoveryBackupRequestParameters): Keq<RotateDeleteRotateRecoveryBackupOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateDeleteRotateRecoveryBackupResponseBodies[STATUS]>('/sys/rotate/recovery/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reads the configuration and progress of the current root rotate attempt.
   *
   */
  rotateAttemptReadRotateRecoveryInit<STATUS extends keyof RotateAttemptReadRotateRecoveryInitResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateAttemptReadRotateRecoveryInitRequestParameters): Keq<RotateAttemptReadRotateRecoveryInitOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateAttemptReadRotateRecoveryInitResponseBodies[STATUS]>('/sys/rotate/recovery/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initializes a new root rotate attempt.
   *
   * @description Only a single rotate attempt can take place at a time, and changing the parameters of a rotate requires canceling and starting a new rotation, which will also provide a new nonce.
   */
  rotateAttemptInitializeRotateRecoveryInit<STATUS extends keyof RotateAttemptInitializeRotateRecoveryInitResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateAttemptInitializeRotateRecoveryInitRequestParameters): Keq<RotateAttemptInitializeRotateRecoveryInitOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateAttemptInitializeRotateRecoveryInitResponseBodies[STATUS]>('/sys/rotate/recovery/init')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'backup' in args) req.send({ backup: args['backup'] })
    if (args && 'pgp_keys' in args) req.send({ pgp_keys: args['pgp_keys'] })
    if (args && 'require_verification' in args) req.send({ require_verification: args['require_verification'] })
    if (args && 'secret_shares' in args) req.send({ secret_shares: args['secret_shares'] })
    if (args && 'secret_threshold' in args) req.send({ secret_threshold: args['secret_threshold'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancels any in-progress rotate root operation.
   *
   * @description This clears the rotate settings as well as any progress made. This must be called to change the parameters of the rotate. Note: verification is still a part of a rotate. If rotating is canceled during the verification flow, the current unseal keys remain valid.
   */
  rotateAttemptCancelRotateRecoveryInit<STATUS extends keyof RotateAttemptCancelRotateRecoveryInitResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateAttemptCancelRotateRecoveryInitRequestParameters): Keq<RotateAttemptCancelRotateRecoveryInitOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateAttemptCancelRotateRecoveryInitResponseBodies[STATUS]>('/sys/rotate/recovery/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single unseal key share to progress the rotation of the root key of OpenBao.
   *
   */
  rotateAttemptUpdateRotateRecoveryUpdate<STATUS extends keyof RotateAttemptUpdateRotateRecoveryUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateAttemptUpdateRotateRecoveryUpdateRequestParameters): Keq<RotateAttemptUpdateRotateRecoveryUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateAttemptUpdateRotateRecoveryUpdateResponseBodies[STATUS]>('/sys/rotate/recovery/update')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration and progress of the current rotate verification attempt.
   *
   */
  rotateVerificationReadRotateRecoveryVerify<STATUS extends keyof RotateVerificationReadRotateRecoveryVerifyResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateVerificationReadRotateRecoveryVerifyRequestParameters): Keq<RotateVerificationReadRotateRecoveryVerifyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateVerificationReadRotateRecoveryVerifyResponseBodies[STATUS]>('/sys/rotate/recovery/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single new key share to progress the rotation verification operation.
   *
   */
  rotateVerificationUpdateRotateRecoveryVerify<STATUS extends keyof RotateVerificationUpdateRotateRecoveryVerifyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateVerificationUpdateRotateRecoveryVerifyRequestParameters): Keq<RotateVerificationUpdateRotateRecoveryVerifyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateVerificationUpdateRotateRecoveryVerifyResponseBodies[STATUS]>('/sys/rotate/recovery/verify')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancel any in-progress rotate verification operation.
   *
   * @description This clears any progress made and resets the nonce. Unlike a `DELETE` against `sys/rotate/(root/recovery)/init`, this only resets the current verification operation, not the entire rotate atttempt.
   */
  rotateVerificationCancelRotateRecoveryVerify<STATUS extends keyof RotateVerificationCancelRotateRecoveryVerifyResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateVerificationCancelRotateRecoveryVerifyRequestParameters): Keq<RotateVerificationCancelRotateRecoveryVerifyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateVerificationCancelRotateRecoveryVerifyResponseBodies[STATUS]>('/sys/rotate/recovery/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  rootKeyRotate<STATUS extends keyof RootKeyRotateResponseBodies, CONTENT_TYPE extends never = never>(args?: RootKeyRotateRequestParameters): Keq<RootKeyRotateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RootKeyRotateResponseBodies[STATUS]>('/sys/rotate/root')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Return the backup copy of PGP-encrypted unseal keys.
   *
   */
  rotateReadBackupKey<STATUS extends keyof RotateReadBackupKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateReadBackupKeyRequestParameters): Keq<RotateReadBackupKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateReadBackupKeyResponseBodies[STATUS]>('/sys/rotate/root/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Delete the backup copy of PGP-encrypted unseal keys.
   *
   */
  rotateDeleteBackupKey<STATUS extends keyof RotateDeleteBackupKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateDeleteBackupKeyRequestParameters): Keq<RotateDeleteBackupKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateDeleteBackupKeyResponseBodies[STATUS]>('/sys/rotate/root/backup')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Reads the configuration and progress of the current root rotate attempt.
   *
   */
  rotateAttemptReadProgress<STATUS extends keyof RotateAttemptReadProgressResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateAttemptReadProgressRequestParameters): Keq<RotateAttemptReadProgressOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateAttemptReadProgressResponseBodies[STATUS]>('/sys/rotate/root/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Initializes a new root rotate attempt.
   *
   * @description Only a single rotate attempt can take place at a time, and changing the parameters of a rotate requires canceling and starting a new rotation, which will also provide a new nonce.
   */
  rotateAttemptInitialize<STATUS extends keyof RotateAttemptInitializeResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateAttemptInitializeRequestParameters): Keq<RotateAttemptInitializeOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateAttemptInitializeResponseBodies[STATUS]>('/sys/rotate/root/init')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'backup' in args) req.send({ backup: args['backup'] })
    if (args && 'pgp_keys' in args) req.send({ pgp_keys: args['pgp_keys'] })
    if (args && 'require_verification' in args) req.send({ require_verification: args['require_verification'] })
    if (args && 'secret_shares' in args) req.send({ secret_shares: args['secret_shares'] })
    if (args && 'secret_threshold' in args) req.send({ secret_threshold: args['secret_threshold'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancels any in-progress rotate root operation.
   *
   * @description This clears the rotate settings as well as any progress made. This must be called to change the parameters of the rotate. Note: verification is still a part of a rotate. If rotating is canceled during the verification flow, the current unseal keys remain valid.
   */
  rotateAttemptCancel<STATUS extends keyof RotateAttemptCancelResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateAttemptCancelRequestParameters): Keq<RotateAttemptCancelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateAttemptCancelResponseBodies[STATUS]>('/sys/rotate/root/init')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single unseal key share to progress the rotation of the root key of OpenBao.
   *
   */
  rotateAttemptUpdate<STATUS extends keyof RotateAttemptUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateAttemptUpdateRequestParameters): Keq<RotateAttemptUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateAttemptUpdateResponseBodies[STATUS]>('/sys/rotate/root/update')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Read the configuration and progress of the current rotate verification attempt.
   *
   */
  rotateVerificationReadProgress<STATUS extends keyof RotateVerificationReadProgressResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateVerificationReadProgressRequestParameters): Keq<RotateVerificationReadProgressOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<RotateVerificationReadProgressResponseBodies[STATUS]>('/sys/rotate/root/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Enter a single new key share to progress the rotation verification operation.
   *
   */
  rotateVerificationUpdate<STATUS extends keyof RotateVerificationUpdateResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RotateVerificationUpdateRequestParameters): Keq<RotateVerificationUpdateOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RotateVerificationUpdateResponseBodies[STATUS]>('/sys/rotate/root/verify')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'nonce' in args) req.send({ nonce: args['nonce'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Cancel any in-progress rotate verification operation.
   *
   * @description This clears any progress made and resets the nonce. Unlike a `DELETE` against `sys/rotate/(root/recovery)/init`, this only resets the current verification operation, not the entire rotate atttempt.
   */
  rotateVerificationCancel<STATUS extends keyof RotateVerificationCancelResponseBodies, CONTENT_TYPE extends never = never>(args?: RotateVerificationCancelRequestParameters): Keq<RotateVerificationCancelOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<RotateVerificationCancelResponseBodies[STATUS]>('/sys/rotate/root/verify')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Seal the OpenBao instance.
   *
   */
  seal<STATUS extends keyof SealResponseBodies, CONTENT_TYPE extends never = never>(args?: SealRequestParameters): Keq<SealOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<SealResponseBodies[STATUS]>('/sys/seal')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Check the seal status of an OpenBao instance.
   *
   */
  sealStatus<STATUS extends keyof SealStatusResponseBodies, CONTENT_TYPE extends never = never>(args?: SealStatusRequestParameters): Keq<SealStatusOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<SealStatusResponseBodies[STATUS]>('/sys/seal-status')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Cause the node to give up active status.
   *
   * @description This endpoint forces the node to give up active status. If the node does not have active status, this endpoint does nothing. Note that the node will sleep for ten seconds before attempting to grab the active lock again, but if no standby nodes grab the active lock in the interim, the same node may become the active node again.
   */
  stepDownLeader<STATUS extends keyof StepDownLeaderResponseBodies, CONTENT_TYPE extends never = never>(args?: StepDownLeaderRequestParameters): Keq<StepDownLeaderOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<StepDownLeaderResponseBodies[STATUS]>('/sys/step-down')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  generateHash<STATUS extends keyof GenerateHashResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateHashRequestParameters): Keq<GenerateHashOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateHashResponseBodies[STATUS]>('/sys/tools/hash')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'urlalgorithm' in args) req.send({ urlalgorithm: args['urlalgorithm'] })
    /* @anchor:body:end */

    return req
  }


  generateHashWithAlgorithm<STATUS extends keyof GenerateHashWithAlgorithmResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateHashWithAlgorithmRequestParameters): Keq<GenerateHashWithAlgorithmOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateHashWithAlgorithmResponseBodies[STATUS]>('/sys/tools/hash/{urlalgorithm}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    /* @anchor:body:end */

    return req
  }


  generateRandom<STATUS extends keyof GenerateRandomResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateRandomRequestParameters): Keq<GenerateRandomOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateRandomResponseBodies[STATUS]>('/sys/tools/random')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'source' in args) req.send({ source: args['source'] })
    if (args && 'urlbytes' in args) req.send({ urlbytes: args['urlbytes'] })
    /* @anchor:body:end */

    return req
  }


  generateRandomWithSource<STATUS extends keyof GenerateRandomWithSourceResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateRandomWithSourceRequestParameters): Keq<GenerateRandomWithSourceOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateRandomWithSourceResponseBodies[STATUS]>('/sys/tools/random/{source}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'urlbytes' in args) req.send({ urlbytes: args['urlbytes'] })
    /* @anchor:body:end */

    return req
  }


  generateRandomWithSourceAndBytes<STATUS extends keyof GenerateRandomWithSourceAndBytesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateRandomWithSourceAndBytesRequestParameters): Keq<GenerateRandomWithSourceAndBytesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateRandomWithSourceAndBytesResponseBodies[STATUS]>('/sys/tools/random/{source}/{urlbytes}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    /* @anchor:body:end */

    return req
  }


  generateRandomWithBytes<STATUS extends keyof GenerateRandomWithBytesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GenerateRandomWithBytesRequestParameters): Keq<GenerateRandomWithBytesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GenerateRandomWithBytesResponseBodies[STATUS]>('/sys/tools/random/{urlbytes}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'source' in args) req.send({ source: args['source'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Unseal the OpenBao instance.
   *
   */
  unseal<STATUS extends keyof UnsealResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UnsealRequestParameters): Keq<UnsealOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UnsealResponseBodies[STATUS]>('/sys/unseal')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'key' in args) req.send({ key: args['key'] })
    if (args && 'reset' in args) req.send({ reset: args['reset'] })
    /* @anchor:body:end */

    return req
  }

  /**
   * Look up wrapping properties for the given token.
   *
   */
  readWrappingProperties<STATUS extends keyof ReadWrappingPropertiesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: ReadWrappingPropertiesRequestParameters): Keq<ReadWrappingPropertiesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<ReadWrappingPropertiesResponseBodies[STATUS]>('/sys/wrapping/lookup')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  rewrap<STATUS extends keyof RewrapResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: RewrapRequestParameters): Keq<RewrapOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<RewrapResponseBodies[STATUS]>('/sys/wrapping/rewrap')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  unwrap<STATUS extends keyof UnwrapResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: UnwrapRequestParameters): Keq<UnwrapOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<UnwrapResponseBodies[STATUS]>('/sys/wrapping/unwrap')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'token' in args) req.send({ token: args['token'] })
    /* @anchor:body:end */

    return req
  }


  wrap<STATUS extends keyof WrapResponseBodies, CONTENT_TYPE extends never = never>(args?: WrapRequestParameters): Keq<WrapOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<WrapResponseBodies[STATUS]>('/sys/wrapping/wrap')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitBackUpKey<STATUS extends keyof TransitBackUpKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitBackUpKeyRequestParameters): Keq<TransitBackUpKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitBackUpKeyResponseBodies[STATUS]>('/transit/backup/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitByokKey<STATUS extends keyof TransitByokKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitByokKeyRequestParameters): Keq<TransitByokKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitByokKeyResponseBodies[STATUS]>('/transit/byok-export/{destination}/{source}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitByokKeyVersion<STATUS extends keyof TransitByokKeyVersionResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitByokKeyVersionRequestParameters): Keq<TransitByokKeyVersionOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitByokKeyVersionResponseBodies[STATUS]>('/transit/byok-export/{destination}/{source}/{version}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Returns the size of the active cache
   *
   */
  transitReadCacheConfiguration<STATUS extends keyof TransitReadCacheConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitReadCacheConfigurationRequestParameters): Keq<TransitReadCacheConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitReadCacheConfigurationResponseBodies[STATUS]>('/transit/cache-config')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }

  /**
   * Configures a new cache of the specified size
   *
   */
  transitConfigureCache<STATUS extends keyof TransitConfigureCacheResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitConfigureCacheRequestParameters): Keq<TransitConfigureCacheOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitConfigureCacheResponseBodies[STATUS]>('/transit/cache-config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'size' in args) req.send({ size: args['size'] })
    /* @anchor:body:end */

    return req
  }


  transitReadKeysConfiguration<STATUS extends keyof TransitReadKeysConfigurationResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitReadKeysConfigurationRequestParameters): Keq<TransitReadKeysConfigurationOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitReadKeysConfigurationResponseBodies[STATUS]>('/transit/config/keys')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitConfigureKeys<STATUS extends keyof TransitConfigureKeysResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitConfigureKeysRequestParameters): Keq<TransitConfigureKeysOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitConfigureKeysResponseBodies[STATUS]>('/transit/config/keys')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'disable_upsert' in args) req.send({ disable_upsert: args['disable_upsert'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateDataKey<STATUS extends keyof TransitGenerateDataKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateDataKeyRequestParameters): Keq<TransitGenerateDataKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateDataKeyResponseBodies[STATUS]>('/transit/datakey/{plaintext}/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'associated_data' in args) req.send({ associated_data: args['associated_data'] })
    if (args && 'bits' in args) req.send({ bits: args['bits'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    /* @anchor:body:end */

    return req
  }


  transitDecrypt<STATUS extends keyof TransitDecryptResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitDecryptRequestParameters): Keq<TransitDecryptOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitDecryptResponseBodies[STATUS]>('/transit/decrypt/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'associated_data' in args) req.send({ associated_data: args['associated_data'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'ciphertext' in args) req.send({ ciphertext: args['ciphertext'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'partial_failure_response_code' in args) req.send({ partial_failure_response_code: args['partial_failure_response_code'] })
    /* @anchor:body:end */

    return req
  }


  transitDeriveKey<STATUS extends keyof TransitDeriveKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitDeriveKeyRequestParameters): Keq<TransitDeriveKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitDeriveKeyResponseBodies[STATUS]>('/transit/derive-key/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'base_key_name' in args) req.send({ base_key_name: args['base_key_name'] })
    if (args && 'base_key_version' in args) req.send({ base_key_version: args['base_key_version'] })
    if (args && 'derived_key_type' in args) req.send({ derived_key_type: args['derived_key_type'] })
    if (args && 'key_derivation_algorithm' in args) req.send({ key_derivation_algorithm: args['key_derivation_algorithm'] })
    if (args && 'peer_public_key' in args) req.send({ peer_public_key: args['peer_public_key'] })
    /* @anchor:body:end */

    return req
  }


  transitEncrypt<STATUS extends keyof TransitEncryptResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitEncryptRequestParameters): Keq<TransitEncryptOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitEncryptResponseBodies[STATUS]>('/transit/encrypt/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'associated_data' in args) req.send({ associated_data: args['associated_data'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'convergent_encryption' in args) req.send({ convergent_encryption: args['convergent_encryption'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    if (args && 'partial_failure_response_code' in args) req.send({ partial_failure_response_code: args['partial_failure_response_code'] })
    if (args && 'plaintext' in args) req.send({ plaintext: args['plaintext'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  transitExportKey<STATUS extends keyof TransitExportKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitExportKeyRequestParameters): Keq<TransitExportKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitExportKeyResponseBodies[STATUS]>('/transit/export/{type}/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitExportKeyVersion<STATUS extends keyof TransitExportKeyVersionResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitExportKeyVersionRequestParameters): Keq<TransitExportKeyVersionOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitExportKeyVersionResponseBodies[STATUS]>('/transit/export/{type}/{name}/{version}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitHash<STATUS extends keyof TransitHashResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitHashRequestParameters): Keq<TransitHashOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitHashResponseBodies[STATUS]>('/transit/hash')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'urlalgorithm' in args) req.send({ urlalgorithm: args['urlalgorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitHashWithAlgorithm<STATUS extends keyof TransitHashWithAlgorithmResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitHashWithAlgorithmRequestParameters): Keq<TransitHashWithAlgorithmOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitHashWithAlgorithmResponseBodies[STATUS]>('/transit/hash/{urlalgorithm}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateHmac<STATUS extends keyof TransitGenerateHmacResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateHmacRequestParameters): Keq<TransitGenerateHmacOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateHmacResponseBodies[STATUS]>('/transit/hmac/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    if (args && 'urlalgorithm' in args) req.send({ urlalgorithm: args['urlalgorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateHmacWithAlgorithm<STATUS extends keyof TransitGenerateHmacWithAlgorithmResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateHmacWithAlgorithmRequestParameters): Keq<TransitGenerateHmacWithAlgorithmOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateHmacWithAlgorithmResponseBodies[STATUS]>('/transit/hmac/{name}/{urlalgorithm}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    /* @anchor:body:end */

    return req
  }


  transitListKeys<STATUS extends keyof TransitListKeysResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitListKeysRequestParameters): Keq<TransitListKeysOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitListKeysResponseBodies[STATUS]>('/transit/keys')


    /* @anchor:query:start */
    if (args && 'list' in args) req.query('list', args['list'], { arrayFormat: 'repeat' })
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitReadKey<STATUS extends keyof TransitReadKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitReadKeyRequestParameters): Keq<TransitReadKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitReadKeyResponseBodies[STATUS]>('/transit/keys/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitCreateKey<STATUS extends keyof TransitCreateKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitCreateKeyRequestParameters): Keq<TransitCreateKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitCreateKeyResponseBodies[STATUS]>('/transit/keys/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allow_plaintext_backup' in args) req.send({ allow_plaintext_backup: args['allow_plaintext_backup'] })
    if (args && 'auto_rotate_period' in args) req.send({ auto_rotate_period: args['auto_rotate_period'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'convergent_encryption' in args) req.send({ convergent_encryption: args['convergent_encryption'] })
    if (args && 'derived' in args) req.send({ derived: args['derived'] })
    if (args && 'exportable' in args) req.send({ exportable: args['exportable'] })
    if (args && 'key_size' in args) req.send({ key_size: args['key_size'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  transitDeleteKey<STATUS extends keyof TransitDeleteKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitDeleteKeyRequestParameters): Keq<TransitDeleteKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<TransitDeleteKeyResponseBodies[STATUS]>('/transit/keys/{name}')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitConfigureKey<STATUS extends keyof TransitConfigureKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitConfigureKeyRequestParameters): Keq<TransitConfigureKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitConfigureKeyResponseBodies[STATUS]>('/transit/keys/{name}/config')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allow_plaintext_backup' in args) req.send({ allow_plaintext_backup: args['allow_plaintext_backup'] })
    if (args && 'auto_rotate_period' in args) req.send({ auto_rotate_period: args['auto_rotate_period'] })
    if (args && 'deletion_allowed' in args) req.send({ deletion_allowed: args['deletion_allowed'] })
    if (args && 'exportable' in args) req.send({ exportable: args['exportable'] })
    if (args && 'min_decryption_version' in args) req.send({ min_decryption_version: args['min_decryption_version'] })
    if (args && 'min_encryption_version' in args) req.send({ min_encryption_version: args['min_encryption_version'] })
    /* @anchor:body:end */

    return req
  }


  getCsr<STATUS extends keyof GetCsrResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: GetCsrRequestParameters): Keq<GetCsrOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<GetCsrResponseBodies[STATUS]>('/transit/keys/{name}/csr')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'csr' in args) req.send({ csr: args['csr'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }


  transitImportKey<STATUS extends keyof TransitImportKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitImportKeyRequestParameters): Keq<TransitImportKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitImportKeyResponseBodies[STATUS]>('/transit/keys/{name}/import')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'allow_plaintext_backup' in args) req.send({ allow_plaintext_backup: args['allow_plaintext_backup'] })
    if (args && 'allow_rotation' in args) req.send({ allow_rotation: args['allow_rotation'] })
    if (args && 'auto_rotate_period' in args) req.send({ auto_rotate_period: args['auto_rotate_period'] })
    if (args && 'ciphertext' in args) req.send({ ciphertext: args['ciphertext'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'derived' in args) req.send({ derived: args['derived'] })
    if (args && 'exportable' in args) req.send({ exportable: args['exportable'] })
    if (args && 'hash_function' in args) req.send({ hash_function: args['hash_function'] })
    if (args && 'public_key' in args) req.send({ public_key: args['public_key'] })
    if (args && 'type' in args) req.send({ type: args['type'] })
    /* @anchor:body:end */

    return req
  }


  transitImportKeyVersion<STATUS extends keyof TransitImportKeyVersionResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitImportKeyVersionRequestParameters): Keq<TransitImportKeyVersionOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitImportKeyVersionResponseBodies[STATUS]>('/transit/keys/{name}/import_version')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'ciphertext' in args) req.send({ ciphertext: args['ciphertext'] })
    if (args && 'hash_function' in args) req.send({ hash_function: args['hash_function'] })
    if (args && 'public_key' in args) req.send({ public_key: args['public_key'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }


  transitRotateKey<STATUS extends keyof TransitRotateKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitRotateKeyRequestParameters): Keq<TransitRotateKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitRotateKeyResponseBodies[STATUS]>('/transit/keys/{name}/rotate')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  setChain<STATUS extends keyof SetChainResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: SetChainRequestParameters): Keq<SetChainOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<SetChainResponseBodies[STATUS]>('/transit/keys/{name}/set-certificate')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'certificate_chain' in args) req.send({ certificate_chain: args['certificate_chain'] })
    if (args && 'version' in args) req.send({ version: args['version'] })
    /* @anchor:body:end */

    return req
  }


  transitSoftDeleteKey<STATUS extends keyof TransitSoftDeleteKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitSoftDeleteKeyRequestParameters): Keq<TransitSoftDeleteKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.delete<TransitSoftDeleteKeyResponseBodies[STATUS]>('/transit/keys/{name}/soft-delete')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitSoftDeleteRestoreKey<STATUS extends keyof TransitSoftDeleteRestoreKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitSoftDeleteRestoreKeyRequestParameters): Keq<TransitSoftDeleteRestoreKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitSoftDeleteRestoreKeyResponseBodies[STATUS]>('/transit/keys/{name}/soft-delete-restore')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }


  transitTrimKey<STATUS extends keyof TransitTrimKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitTrimKeyRequestParameters): Keq<TransitTrimKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitTrimKeyResponseBodies[STATUS]>('/transit/keys/{name}/trim')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'min_available_version' in args) req.send({ min_available_version: args['min_available_version'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateRandom<STATUS extends keyof TransitGenerateRandomResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateRandomRequestParameters): Keq<TransitGenerateRandomOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateRandomResponseBodies[STATUS]>('/transit/random')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'source' in args) req.send({ source: args['source'] })
    if (args && 'urlbytes' in args) req.send({ urlbytes: args['urlbytes'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateRandomWithSource<STATUS extends keyof TransitGenerateRandomWithSourceResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateRandomWithSourceRequestParameters): Keq<TransitGenerateRandomWithSourceOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateRandomWithSourceResponseBodies[STATUS]>('/transit/random/{source}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'urlbytes' in args) req.send({ urlbytes: args['urlbytes'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateRandomWithSourceAndBytes<STATUS extends keyof TransitGenerateRandomWithSourceAndBytesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateRandomWithSourceAndBytesRequestParameters): Keq<TransitGenerateRandomWithSourceAndBytesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateRandomWithSourceAndBytesResponseBodies[STATUS]>('/transit/random/{source}/{urlbytes}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    /* @anchor:body:end */

    return req
  }


  transitGenerateRandomWithBytes<STATUS extends keyof TransitGenerateRandomWithBytesResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitGenerateRandomWithBytesRequestParameters): Keq<TransitGenerateRandomWithBytesOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitGenerateRandomWithBytesResponseBodies[STATUS]>('/transit/random/{urlbytes}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'bytes' in args) req.send({ bytes: args['bytes'] })
    if (args && 'format' in args) req.send({ format: args['format'] })
    if (args && 'source' in args) req.send({ source: args['source'] })
    /* @anchor:body:end */

    return req
  }


  transitRestoreKey<STATUS extends keyof TransitRestoreKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitRestoreKeyRequestParameters): Keq<TransitRestoreKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitRestoreKeyResponseBodies[STATUS]>('/transit/restore')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'backup' in args) req.send({ backup: args['backup'] })
    if (args && 'force' in args) req.send({ force: args['force'] })
    if (args && 'name' in args) req.send({ name: args['name'] })
    /* @anchor:body:end */

    return req
  }


  transitRestoreAndRenameKey<STATUS extends keyof TransitRestoreAndRenameKeyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitRestoreAndRenameKeyRequestParameters): Keq<TransitRestoreAndRenameKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitRestoreAndRenameKeyResponseBodies[STATUS]>('/transit/restore/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'backup' in args) req.send({ backup: args['backup'] })
    if (args && 'force' in args) req.send({ force: args['force'] })
    /* @anchor:body:end */

    return req
  }


  transitRewrap<STATUS extends keyof TransitRewrapResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitRewrapRequestParameters): Keq<TransitRewrapOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitRewrapResponseBodies[STATUS]>('/transit/rewrap/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'ciphertext' in args) req.send({ ciphertext: args['ciphertext'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    /* @anchor:body:end */

    return req
  }


  transitSign<STATUS extends keyof TransitSignResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitSignRequestParameters): Keq<TransitSignOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitSignResponseBodies[STATUS]>('/transit/sign/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'hash_algorithm' in args) req.send({ hash_algorithm: args['hash_algorithm'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    if (args && 'marshaling_algorithm' in args) req.send({ marshaling_algorithm: args['marshaling_algorithm'] })
    if (args && 'prehashed' in args) req.send({ prehashed: args['prehashed'] })
    if (args && 'salt_length' in args) req.send({ salt_length: args['salt_length'] })
    if (args && 'signature_algorithm' in args) req.send({ signature_algorithm: args['signature_algorithm'] })
    if (args && 'urlalgorithm' in args) req.send({ urlalgorithm: args['urlalgorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitSignWithAlgorithm<STATUS extends keyof TransitSignWithAlgorithmResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitSignWithAlgorithmRequestParameters): Keq<TransitSignWithAlgorithmOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitSignWithAlgorithmResponseBodies[STATUS]>('/transit/sign/{name}/{urlalgorithm}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'hash_algorithm' in args) req.send({ hash_algorithm: args['hash_algorithm'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'key_version' in args) req.send({ key_version: args['key_version'] })
    if (args && 'marshaling_algorithm' in args) req.send({ marshaling_algorithm: args['marshaling_algorithm'] })
    if (args && 'prehashed' in args) req.send({ prehashed: args['prehashed'] })
    if (args && 'salt_length' in args) req.send({ salt_length: args['salt_length'] })
    if (args && 'signature_algorithm' in args) req.send({ signature_algorithm: args['signature_algorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitVerify<STATUS extends keyof TransitVerifyResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitVerifyRequestParameters): Keq<TransitVerifyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitVerifyResponseBodies[STATUS]>('/transit/verify/{name}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'hash_algorithm' in args) req.send({ hash_algorithm: args['hash_algorithm'] })
    if (args && 'hmac' in args) req.send({ hmac: args['hmac'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'marshaling_algorithm' in args) req.send({ marshaling_algorithm: args['marshaling_algorithm'] })
    if (args && 'prehashed' in args) req.send({ prehashed: args['prehashed'] })
    if (args && 'salt_length' in args) req.send({ salt_length: args['salt_length'] })
    if (args && 'signature' in args) req.send({ signature: args['signature'] })
    if (args && 'signature_algorithm' in args) req.send({ signature_algorithm: args['signature_algorithm'] })
    if (args && 'urlalgorithm' in args) req.send({ urlalgorithm: args['urlalgorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitVerifyWithAlgorithm<STATUS extends keyof TransitVerifyWithAlgorithmResponseBodies, CONTENT_TYPE extends 'application/json' = 'application/json'>(args?: TransitVerifyWithAlgorithmRequestParameters): Keq<TransitVerifyWithAlgorithmOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.post<TransitVerifyWithAlgorithmResponseBodies[STATUS]>('/transit/verify/{name}/{urlalgorithm}')

    req.type('application/json')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    if (args && 'algorithm' in args) req.send({ algorithm: args['algorithm'] })
    if (args && 'batch_input' in args) req.send({ batch_input: args['batch_input'] })
    if (args && 'context' in args) req.send({ context: args['context'] })
    if (args && 'hash_algorithm' in args) req.send({ hash_algorithm: args['hash_algorithm'] })
    if (args && 'hmac' in args) req.send({ hmac: args['hmac'] })
    if (args && 'input' in args) req.send({ input: args['input'] })
    if (args && 'marshaling_algorithm' in args) req.send({ marshaling_algorithm: args['marshaling_algorithm'] })
    if (args && 'prehashed' in args) req.send({ prehashed: args['prehashed'] })
    if (args && 'salt_length' in args) req.send({ salt_length: args['salt_length'] })
    if (args && 'signature' in args) req.send({ signature: args['signature'] })
    if (args && 'signature_algorithm' in args) req.send({ signature_algorithm: args['signature_algorithm'] })
    /* @anchor:body:end */

    return req
  }


  transitReadWrappingKey<STATUS extends keyof TransitReadWrappingKeyResponseBodies, CONTENT_TYPE extends never = never>(args?: TransitReadWrappingKeyRequestParameters): Keq<TransitReadWrappingKeyOperation<STATUS, CONTENT_TYPE>> {
    const req = this.request.get<TransitReadWrappingKeyResponseBodies[STATUS]>('/transit/wrapping_key')


    /* @anchor:query:start */
    /* @anchor:query:end */

    /* @anchor:headers:start */
    /* @anchor:headers:end */

    /* @anchor:path-parameters:start */
    /* @anchor:path-parameters:end */

    /* @anchor:body:start */
    /* @anchor:body:end */

    return req
  }
}

/* @anchor:file:end */
